{
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "ActionConversionGoal": {
            "additionalProperties": false,
            "properties": {
                "actionId": {
                    "$ref": "#/definitions/integer"
                }
            },
            "required": ["actionId"],
            "type": "object"
        },
        "ActionsNode": {
            "additionalProperties": false,
            "properties": {
                "custom_name": {
                    "type": "string"
                },
                "fixedProperties": {
                    "description": "Fixed properties in the query, can't be edited in the interface (e.g. scoping down by person)",
                    "items": {
                        "$ref": "#/definitions/AnyPropertyFilter"
                    },
                    "type": "array"
                },
                "id": {
                    "$ref": "#/definitions/integer"
                },
                "kind": {
                    "const": "ActionsNode",
                    "type": "string"
                },
                "math": {
                    "$ref": "#/definitions/MathType"
                },
                "math_group_type_index": {
                    "enum": [0, 1, 2, 3, 4],
                    "type": "number"
                },
                "math_hogql": {
                    "type": "string"
                },
                "math_property": {
                    "type": "string"
                },
                "math_property_revenue_currency": {
                    "$ref": "#/definitions/RevenueCurrencyPropertyConfig"
                },
                "math_property_type": {
                    "type": "string"
                },
                "name": {
                    "type": "string"
                },
                "properties": {
                    "description": "Properties configurable in the interface",
                    "items": {
                        "$ref": "#/definitions/AnyPropertyFilter"
                    },
                    "type": "array"
                },
                "response": {
                    "type": "object"
                }
            },
            "required": ["id", "kind"],
            "type": "object"
        },
        "ActorsPropertyTaxonomyQuery": {
            "additionalProperties": false,
            "properties": {
                "group_type_index": {
                    "$ref": "#/definitions/integer"
                },
                "kind": {
                    "const": "ActorsPropertyTaxonomyQuery",
                    "type": "string"
                },
                "maxPropertyValues": {
                    "$ref": "#/definitions/integer"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "property": {
                    "type": "string"
                },
                "response": {
                    "$ref": "#/definitions/ActorsPropertyTaxonomyQueryResponse"
                }
            },
            "required": ["kind", "property"],
            "type": "object"
        },
        "ActorsPropertyTaxonomyQueryResponse": {
            "additionalProperties": false,
            "description": "All analytics query responses must inherit from this.",
            "properties": {
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "$ref": "#/definitions/ActorsPropertyTaxonomyResponse"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                }
            },
            "required": ["results"],
            "type": "object"
        },
        "ActorsPropertyTaxonomyResponse": {
            "additionalProperties": false,
            "properties": {
                "sample_count": {
                    "$ref": "#/definitions/integer"
                },
                "sample_values": {
                    "items": {
                        "anyOf": [
                            {
                                "type": "string"
                            },
                            {
                                "type": "number"
                            },
                            {
                                "type": "boolean"
                            },
                            {
                                "$ref": "#/definitions/integer"
                            }
                        ]
                    },
                    "type": "array"
                }
            },
            "required": ["sample_values", "sample_count"],
            "type": "object"
        },
        "ActorsQuery": {
            "additionalProperties": false,
            "properties": {
                "fixedProperties": {
                    "description": "Currently only person filters supported. No filters for querying groups. See `filter_conditions()` in actor_strategies.py.",
                    "items": {
                        "$ref": "#/definitions/AnyPersonScopeFilter"
                    },
                    "type": "array"
                },
                "kind": {
                    "const": "ActorsQuery",
                    "type": "string"
                },
                "limit": {
                    "$ref": "#/definitions/integer"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "offset": {
                    "$ref": "#/definitions/integer"
                },
                "orderBy": {
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                },
                "properties": {
                    "anyOf": [
                        {
                            "items": {
                                "$ref": "#/definitions/AnyPersonScopeFilter"
                            },
                            "type": "array"
                        },
                        {
                            "$ref": "#/definitions/PropertyGroupFilterValue"
                        }
                    ],
                    "description": "Currently only person filters supported. No filters for querying groups. See `filter_conditions()` in actor_strategies.py."
                },
                "response": {
                    "$ref": "#/definitions/ActorsQueryResponse"
                },
                "search": {
                    "type": "string"
                },
                "select": {
                    "items": {
                        "$ref": "#/definitions/HogQLExpression"
                    },
                    "type": "array"
                },
                "source": {
                    "anyOf": [
                        {
                            "$ref": "#/definitions/InsightActorsQuery"
                        },
                        {
                            "$ref": "#/definitions/FunnelsActorsQuery"
                        },
                        {
                            "$ref": "#/definitions/FunnelCorrelationActorsQuery"
                        },
                        {
                            "$ref": "#/definitions/StickinessActorsQuery"
                        },
                        {
                            "$ref": "#/definitions/HogQLQuery"
                        }
                    ]
                }
            },
            "required": ["kind"],
            "type": "object"
        },
        "ActorsQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "columns": {
                    "items": {},
                    "type": "array"
                },
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hasMore": {
                    "type": "boolean"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "limit": {
                    "$ref": "#/definitions/integer"
                },
                "missing_actors_count": {
                    "$ref": "#/definitions/integer"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "offset": {
                    "$ref": "#/definitions/integer"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "items": {
                        "items": {},
                        "type": "array"
                    },
                    "type": "array"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                },
                "types": {
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                }
            },
            "required": ["columns", "hogql", "limit", "offset", "results", "types"],
            "type": "object"
        },
        "AggregationAxisFormat": {
            "enum": ["numeric", "duration", "duration_ms", "percentage", "percentage_scaled"],
            "type": "string"
        },
        "AlertCalculationInterval": {
            "enum": ["hourly", "daily", "weekly", "monthly"],
            "type": "string"
        },
        "AlertCondition": {
            "additionalProperties": false,
            "properties": {
                "type": {
                    "$ref": "#/definitions/AlertConditionType"
                }
            },
            "required": ["type"],
            "type": "object"
        },
        "AlertConditionType": {
            "enum": ["absolute_value", "relative_increase", "relative_decrease"],
            "type": "string"
        },
        "AlertState": {
            "enum": ["Firing", "Not firing", "Errored", "Snoozed"],
            "type": "string"
        },
        "AnyDataNode": {
            "anyOf": [
                {
                    "$ref": "#/definitions/EventsNode"
                },
                {
                    "$ref": "#/definitions/ActionsNode"
                },
                {
                    "$ref": "#/definitions/PersonsNode"
                },
                {
                    "$ref": "#/definitions/EventsQuery"
                },
                {
                    "$ref": "#/definitions/ActorsQuery"
                },
                {
                    "$ref": "#/definitions/GroupsQuery"
                },
                {
                    "$ref": "#/definitions/InsightActorsQuery"
                },
                {
                    "$ref": "#/definitions/InsightActorsQueryOptions"
                },
                {
                    "$ref": "#/definitions/SessionsTimelineQuery"
                },
                {
                    "$ref": "#/definitions/HogQuery"
                },
                {
                    "$ref": "#/definitions/HogQLQuery"
                },
                {
                    "$ref": "#/definitions/HogQLMetadata"
                },
                {
                    "$ref": "#/definitions/HogQLAutocomplete"
                },
                {
                    "$ref": "#/definitions/RevenueAnalyticsOverviewQuery"
                },
                {
                    "$ref": "#/definitions/RevenueAnalyticsGrowthRateQuery"
                },
                {
                    "$ref": "#/definitions/RevenueAnalyticsTopCustomersQuery"
                },
                {
                    "$ref": "#/definitions/WebOverviewQuery"
                },
                {
                    "$ref": "#/definitions/WebStatsTableQuery"
                },
                {
                    "$ref": "#/definitions/WebExternalClicksTableQuery"
                },
                {
                    "$ref": "#/definitions/WebGoalsQuery"
                },
                {
                    "$ref": "#/definitions/WebVitalsQuery"
                },
                {
                    "$ref": "#/definitions/WebVitalsPathBreakdownQuery"
                },
                {
                    "$ref": "#/definitions/WebPageURLSearchQuery"
                },
                {
                    "$ref": "#/definitions/SessionAttributionExplorerQuery"
                },
                {
                    "$ref": "#/definitions/RevenueExampleEventsQuery"
                },
                {
                    "$ref": "#/definitions/RevenueExampleDataWarehouseTablesQuery"
                },
                {
                    "$ref": "#/definitions/ErrorTrackingQuery"
                },
                {
                    "$ref": "#/definitions/ExperimentFunnelsQuery"
                },
                {
                    "$ref": "#/definitions/ExperimentTrendsQuery"
                },
                {
                    "$ref": "#/definitions/RecordingsQuery"
                },
                {
                    "$ref": "#/definitions/TracesQuery"
                },
                {
                    "$ref": "#/definitions/VectorSearchQuery"
                },
                {
                    "$ref": "#/definitions/EventsHeatMapQuery"
                }
            ]
        },
        "AnyEntityNode": {
            "anyOf": [
                {
                    "$ref": "#/definitions/EventsNode"
                },
                {
                    "$ref": "#/definitions/ActionsNode"
                },
                {
                    "$ref": "#/definitions/DataWarehouseNode"
                }
            ]
        },
        "AnyFilterLike": {
            "anyOf": [
                {
                    "$ref": "#/definitions/AnyPropertyFilter"
                },
                {
                    "$ref": "#/definitions/PropertyGroupFilter"
                },
                {
                    "$ref": "#/definitions/PropertyGroupFilterValue"
                }
            ]
        },
        "AnyGroupScopeFilter": {
            "anyOf": [
                {
                    "$ref": "#/definitions/GroupPropertyFilter"
                },
                {
                    "$ref": "#/definitions/HogQLPropertyFilter"
                }
            ]
        },
        "AnyPersonScopeFilter": {
            "anyOf": [
                {
                    "$ref": "#/definitions/PersonPropertyFilter"
                },
                {
                    "$ref": "#/definitions/CohortPropertyFilter"
                },
                {
                    "$ref": "#/definitions/HogQLPropertyFilter"
                },
                {
                    "$ref": "#/definitions/EmptyPropertyFilter"
                }
            ],
            "description": "Any filter type supported by `property_to_expr(scope=\"person\", ...)`."
        },
        "AnyPropertyFilter": {
            "anyOf": [
                {
                    "$ref": "#/definitions/EventPropertyFilter"
                },
                {
                    "$ref": "#/definitions/PersonPropertyFilter"
                },
                {
                    "$ref": "#/definitions/ElementPropertyFilter"
                },
                {
                    "$ref": "#/definitions/EventMetadataPropertyFilter"
                },
                {
                    "$ref": "#/definitions/SessionPropertyFilter"
                },
                {
                    "$ref": "#/definitions/CohortPropertyFilter"
                },
                {
                    "$ref": "#/definitions/RecordingPropertyFilter"
                },
                {
                    "$ref": "#/definitions/LogEntryPropertyFilter"
                },
                {
                    "$ref": "#/definitions/GroupPropertyFilter"
                },
                {
                    "$ref": "#/definitions/FeaturePropertyFilter"
                },
                {
                    "$ref": "#/definitions/HogQLPropertyFilter"
                },
                {
                    "$ref": "#/definitions/EmptyPropertyFilter"
                },
                {
                    "$ref": "#/definitions/DataWarehousePropertyFilter"
                },
                {
                    "$ref": "#/definitions/DataWarehousePersonPropertyFilter"
                },
                {
                    "$ref": "#/definitions/ErrorTrackingIssueFilter"
                }
            ]
        },
        "AnyResponseType": {
            "anyOf": [
                {
                    "type": "object"
                },
                {
                    "$ref": "#/definitions/HogQueryResponse"
                },
                {
                    "$ref": "#/definitions/HogQLQueryResponse"
                },
                {
                    "$ref": "#/definitions/HogQLMetadataResponse"
                },
                {
                    "$ref": "#/definitions/HogQLAutocompleteResponse"
                },
                {
                    "type": "object"
                },
                {
                    "not": {}
                },
                {
                    "$ref": "#/definitions/EventsQueryResponse"
                },
                {
                    "$ref": "#/definitions/ErrorTrackingQueryResponse"
                }
            ]
        },
        "AssistantArrayPropertyFilter": {
            "additionalProperties": false,
            "properties": {
                "operator": {
                    "$ref": "#/definitions/AssistantArrayPropertyFilterOperator",
                    "description": "`exact` - exact match of any of the values. `is_not` - does not match any of the values."
                },
                "value": {
                    "description": "Only use property values from the plan. Always use strings as values. If you have a number, convert it to a string first. If you have a boolean, convert it to a string \"true\" or \"false\".",
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                }
            },
            "required": ["operator", "value"],
            "type": "object"
        },
        "AssistantArrayPropertyFilterOperator": {
            "enum": ["exact", "is_not"],
            "type": "string"
        },
        "AssistantBaseMultipleBreakdownFilter": {
            "additionalProperties": false,
            "properties": {
                "property": {
                    "description": "Property name from the plan to break down by.",
                    "type": "string"
                }
            },
            "required": ["property"],
            "type": "object"
        },
        "AssistantBasePropertyFilter": {
            "anyOf": [
                {
                    "$ref": "#/definitions/AssistantStringNumberOrBooleanPropertyFilter"
                },
                {
                    "$ref": "#/definitions/AssistantDateTimePropertyFilter"
                },
                {
                    "$ref": "#/definitions/AssistantSetPropertyFilter"
                }
            ]
        },
        "AssistantBreakdownFilter": {
            "additionalProperties": false,
            "properties": {
                "breakdown_limit": {
                    "$ref": "#/definitions/integer",
                    "default": 25,
                    "description": "How many distinct values to show."
                }
            },
            "type": "object"
        },
        "AssistantContextualTool": {
            "enum": ["search_session_recordings", "generate_hogql_query"],
            "type": "string"
        },
        "AssistantDateRange": {
            "additionalProperties": false,
            "description": "This filter only works with absolute dates.",
            "properties": {
                "date_from": {
                    "description": "ISO8601 date string.",
                    "type": "string"
                },
                "date_to": {
                    "description": "ISO8601 date string.",
                    "type": ["string", "null"]
                }
            },
            "required": ["date_from"],
            "type": "object"
        },
        "AssistantDateRangeFilter": {
            "anyOf": [
                {
                    "$ref": "#/definitions/AssistantDateRange"
                },
                {
                    "$ref": "#/definitions/AssistantDurationRange"
                }
            ]
        },
        "AssistantDateTimePropertyFilter": {
            "additionalProperties": false,
            "properties": {
                "operator": {
                    "$ref": "#/definitions/AssistantDateTimePropertyFilterOperator"
                },
                "value": {
                    "description": "Value must be a date in ISO 8601 format.",
                    "type": "string"
                }
            },
            "required": ["operator", "value"],
            "type": "object"
        },
        "AssistantDateTimePropertyFilterOperator": {
            "enum": ["is_date_exact", "is_date_before", "is_date_after"],
            "type": "string"
        },
        "AssistantDurationRange": {
            "additionalProperties": false,
            "description": "This filter only works with durations.",
            "properties": {
                "date_from": {
                    "description": "Duration in the past. Supported units are: `h` (hour), `d` (day), `w` (week), `m` (month), `y` (year), `all` (all time). Use the `Start` suffix to define the exact left date boundary. Examples: `-1d` last day from now, `-180d` last 180 days from now, `mStart` this month start, `-1dStart` yesterday's start.",
                    "type": "string"
                }
            },
            "required": ["date_from"],
            "type": "object"
        },
        "AssistantEventMultipleBreakdownFilterType": {
            "enum": ["person", "event", "event_metadata", "session", "hogql"],
            "type": "string"
        },
        "AssistantEventType": {
            "enum": ["status", "message", "conversation"],
            "type": "string"
        },
        "AssistantForm": {
            "additionalProperties": false,
            "properties": {
                "options": {
                    "items": {
                        "$ref": "#/definitions/AssistantFormOption"
                    },
                    "type": "array"
                }
            },
            "required": ["options"],
            "type": "object"
        },
        "AssistantFormOption": {
            "additionalProperties": false,
            "properties": {
                "value": {
                    "type": "string"
                },
                "variant": {
                    "type": "string"
                }
            },
            "required": ["value"],
            "type": "object"
        },
        "AssistantFunnelNodeShared": {
            "additionalProperties": false,
            "properties": {
                "math": {
                    "$ref": "#/definitions/AssistantFunnelsMath",
                    "description": "Optional math aggregation type for the series. Only specify this math type if the user wants one of these. `first_time_for_user` - counts the number of users who have completed the event for the first time ever. `first_time_for_user_with_filters` - counts the number of users who have completed the event with specified filters for the first time."
                },
                "properties": {
                    "items": {
                        "$ref": "#/definitions/AssistantPropertyFilter"
                    },
                    "type": "array"
                }
            },
            "type": "object"
        },
        "AssistantFunnelsActionsNode": {
            "additionalProperties": false,
            "properties": {
                "id": {
                    "description": "Action ID from the plan.",
                    "type": "number"
                },
                "kind": {
                    "const": "ActionsNode",
                    "type": "string"
                },
                "math": {
                    "$ref": "#/definitions/AssistantFunnelsMath",
                    "description": "Optional math aggregation type for the series. Only specify this math type if the user wants one of these. `first_time_for_user` - counts the number of users who have completed the event for the first time ever. `first_time_for_user_with_filters` - counts the number of users who have completed the event with specified filters for the first time."
                },
                "name": {
                    "description": "Action name from the plan.",
                    "type": "string"
                },
                "properties": {
                    "items": {
                        "$ref": "#/definitions/AssistantPropertyFilter"
                    },
                    "type": "array"
                }
            },
            "required": ["id", "kind", "name"],
            "type": "object"
        },
        "AssistantFunnelsBreakdownFilter": {
            "additionalProperties": false,
            "properties": {
                "breakdown": {
                    "description": "The entity property to break down by.",
                    "type": "string"
                },
                "breakdown_group_type_index": {
                    "anyOf": [
                        {
                            "$ref": "#/definitions/integer"
                        },
                        {
                            "type": "null"
                        }
                    ],
                    "description": "If `breakdown_type` is `group`, this is the index of the group. Use the index from the group mapping."
                },
                "breakdown_limit": {
                    "$ref": "#/definitions/integer",
                    "default": 25,
                    "description": "How many distinct values to show."
                },
                "breakdown_type": {
                    "$ref": "#/definitions/AssistantFunnelsBreakdownType",
                    "default": "event",
                    "description": "Type of the entity to break down by. If `group` is used, you must also provide `breakdown_group_type_index` from the group mapping."
                }
            },
            "required": ["breakdown_type", "breakdown"],
            "type": "object"
        },
        "AssistantFunnelsBreakdownType": {
            "enum": ["person", "event", "group", "session"],
            "type": "string"
        },
        "AssistantFunnelsEventsNode": {
            "additionalProperties": false,
            "properties": {
                "custom_name": {
                    "description": "Optional custom name for the event if it is needed to be renamed.",
                    "type": "string"
                },
                "event": {
                    "description": "Name of the event.",
                    "type": "string"
                },
                "kind": {
                    "const": "EventsNode",
                    "type": "string"
                },
                "math": {
                    "$ref": "#/definitions/AssistantFunnelsMath",
                    "description": "Optional math aggregation type for the series. Only specify this math type if the user wants one of these. `first_time_for_user` - counts the number of users who have completed the event for the first time ever. `first_time_for_user_with_filters` - counts the number of users who have completed the event with specified filters for the first time."
                },
                "properties": {
                    "items": {
                        "$ref": "#/definitions/AssistantPropertyFilter"
                    },
                    "type": "array"
                }
            },
            "required": ["event", "kind"],
            "type": "object"
        },
        "AssistantFunnelsExclusionEventsNode": {
            "additionalProperties": false,
            "description": "Exclustion steps for funnels. The \"from\" and \"to\" steps must not exceed the funnel's series length.",
            "properties": {
                "event": {
                    "type": "string"
                },
                "funnelFromStep": {
                    "$ref": "#/definitions/integer"
                },
                "funnelToStep": {
                    "$ref": "#/definitions/integer"
                },
                "kind": {
                    "const": "EventsNode",
                    "type": "string"
                }
            },
            "required": ["event", "funnelFromStep", "funnelToStep", "kind"],
            "type": "object"
        },
        "AssistantFunnelsFilter": {
            "additionalProperties": false,
            "properties": {
                "binCount": {
                    "description": "Use this setting only when `funnelVizType` is `time_to_convert`: number of bins to show in histogram.",
                    "type": "integer"
                },
                "exclusions": {
                    "default": [],
                    "description": "Users may want to use exclusion events to filter out conversions in which a particular event occurred between specific steps. These events must not be included in the main sequence. You must include start and end indexes for each exclusion where the minimum index is one and the maximum index is the number of steps in the funnel. For example, there is a sequence with three steps: sign up, finish onboarding, purchase. If the user wants to exclude all conversions in which users left the page before finishing the onboarding, the exclusion step would be the event `$pageleave` with start index 2 and end index 3.",
                    "items": {
                        "$ref": "#/definitions/AssistantFunnelsExclusionEventsNode"
                    },
                    "type": "array"
                },
                "funnelAggregateByHogQL": {
                    "const": "properties.$session_id",
                    "description": "Use this field only if the user explicitly asks to aggregate the funnel by unique sessions.",
                    "type": "string"
                },
                "funnelOrderType": {
                    "$ref": "#/definitions/StepOrderValue",
                    "default": "ordered",
                    "description": "Defines the behavior of event matching between steps. Prefer the `strict` option unless explicitly told to use a different one. `ordered` - defines a sequential funnel. Step B must happen after Step A, but any number of events can happen between A and B. `strict` - defines a funnel where all events must happen in order. Step B must happen directly after Step A without any events in between. `any` - order doesn't matter. Steps can be completed in any sequence."
                },
                "funnelStepReference": {
                    "$ref": "#/definitions/FunnelStepReference",
                    "default": "total",
                    "description": "Whether conversion shown in the graph should be across all steps or just relative to the previous step."
                },
                "funnelVizType": {
                    "$ref": "#/definitions/FunnelVizType",
                    "default": "steps",
                    "description": "Defines the type of visualization to use. The `steps` option is recommended. `steps` - shows a step-by-step funnel. Perfect to show a conversion rate of a sequence of events (default). `time_to_convert` - shows a histogram of the time it took to complete the funnel. `trends` - shows trends of the conversion rate of the whole sequence over time."
                },
                "funnelWindowInterval": {
                    "$ref": "#/definitions/integer",
                    "default": 14,
                    "description": "Controls a time frame value for a conversion to be considered. Select a reasonable value based on the user's query. Use in combination with `funnelWindowIntervalUnit`. The default value is 14 days."
                },
                "funnelWindowIntervalUnit": {
                    "$ref": "#/definitions/FunnelConversionWindowTimeUnit",
                    "default": "day",
                    "description": "Controls a time frame interval for a conversion to be considered. Select a reasonable value based on the user's query. Use in combination with `funnelWindowInterval`. The default value is 14 days."
                },
                "layout": {
                    "$ref": "#/definitions/FunnelLayout",
                    "default": "vertical",
                    "description": "Controls how the funnel chart is displayed: vertically (preferred) or horizontally."
                }
            },
            "type": "object"
        },
        "AssistantFunnelsMath": {
            "enum": ["first_time_for_user", "first_time_for_user_with_filters"],
            "type": "string"
        },
        "AssistantFunnelsNode": {
            "anyOf": [
                {
                    "$ref": "#/definitions/AssistantFunnelsEventsNode"
                },
                {
                    "$ref": "#/definitions/AssistantFunnelsActionsNode"
                }
            ]
        },
        "AssistantFunnelsQuery": {
            "additionalProperties": false,
            "properties": {
                "aggregation_group_type_index": {
                    "$ref": "#/definitions/integer",
                    "description": "Use this field to define the aggregation by a specific group from the group mapping that the user has provided."
                },
                "breakdownFilter": {
                    "$ref": "#/definitions/AssistantFunnelsBreakdownFilter",
                    "description": "Breakdown the chart by a property"
                },
                "dateRange": {
                    "$ref": "#/definitions/AssistantDateRangeFilter",
                    "description": "Date range for the query"
                },
                "filterTestAccounts": {
                    "default": false,
                    "description": "Exclude internal and test users by applying the respective filters",
                    "type": "boolean"
                },
                "funnelsFilter": {
                    "$ref": "#/definitions/AssistantFunnelsFilter",
                    "description": "Properties specific to the funnels insight"
                },
                "interval": {
                    "$ref": "#/definitions/IntervalType",
                    "description": "Granularity of the response. Can be one of `hour`, `day`, `week` or `month`"
                },
                "kind": {
                    "const": "FunnelsQuery",
                    "type": "string"
                },
                "properties": {
                    "default": [],
                    "description": "Property filters for all series",
                    "items": {
                        "$ref": "#/definitions/AssistantPropertyFilter"
                    },
                    "type": "array"
                },
                "samplingFactor": {
                    "description": "Sampling rate from 0 to 1 where 1 is 100% of the data.",
                    "type": ["number", "null"]
                },
                "series": {
                    "description": "Events or actions to include",
                    "items": {
                        "$ref": "#/definitions/AssistantFunnelsNode"
                    },
                    "type": "array"
                }
            },
            "required": ["kind", "series"],
            "type": "object"
        },
        "AssistantGenerationStatusEvent": {
            "additionalProperties": false,
            "properties": {
                "type": {
                    "$ref": "#/definitions/AssistantGenerationStatusType"
                }
            },
            "required": ["type"],
            "type": "object"
        },
        "AssistantGenerationStatusType": {
            "enum": ["ack", "generation_error"],
            "type": "string"
        },
        "AssistantGenericMultipleBreakdownFilter": {
            "additionalProperties": false,
            "properties": {
                "property": {
                    "description": "Property name from the plan to break down by.",
                    "type": "string"
                },
                "type": {
                    "$ref": "#/definitions/AssistantEventMultipleBreakdownFilterType"
                }
            },
            "required": ["property", "type"],
            "type": "object"
        },
        "AssistantGenericPropertyFilter": {
            "anyOf": [
                {
                    "additionalProperties": false,
                    "properties": {
                        "key": {
                            "description": "Use one of the properties the user has provided in the plan.",
                            "type": "string"
                        },
                        "operator": {
                            "$ref": "#/definitions/AssistantSingleValuePropertyFilterOperator",
                            "description": "`icontains` - case insensitive contains. `not_icontains` - case insensitive does not contain. `regex` - matches the regex pattern. `not_regex` - does not match the regex pattern."
                        },
                        "type": {
                            "anyOf": [
                                {
                                    "const": "event",
                                    "description": "Event properties",
                                    "type": "string"
                                },
                                {
                                    "const": "person",
                                    "description": "Person properties",
                                    "type": "string"
                                },
                                {
                                    "const": "session",
                                    "type": "string"
                                },
                                {
                                    "const": "feature",
                                    "description": "Event property with \"$feature/\" prepended",
                                    "type": "string"
                                }
                            ]
                        },
                        "value": {
                            "description": "Only use property values from the plan. If the operator is `regex` or `not_regex`, the value must be a valid ClickHouse regex pattern to match against. Otherwise, the value must be a substring that will be matched against the property value.",
                            "type": "string"
                        }
                    },
                    "required": ["key", "operator", "type", "value"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "key": {
                            "description": "Use one of the properties the user has provided in the plan.",
                            "type": "string"
                        },
                        "operator": {
                            "$ref": "#/definitions/AssistantArrayPropertyFilterOperator",
                            "description": "`exact` - exact match of any of the values. `is_not` - does not match any of the values."
                        },
                        "type": {
                            "anyOf": [
                                {
                                    "const": "event",
                                    "description": "Event properties",
                                    "type": "string"
                                },
                                {
                                    "const": "person",
                                    "description": "Person properties",
                                    "type": "string"
                                },
                                {
                                    "const": "session",
                                    "type": "string"
                                },
                                {
                                    "const": "feature",
                                    "description": "Event property with \"$feature/\" prepended",
                                    "type": "string"
                                }
                            ]
                        },
                        "value": {
                            "description": "Only use property values from the plan. Always use strings as values. If you have a number, convert it to a string first. If you have a boolean, convert it to a string \"true\" or \"false\".",
                            "items": {
                                "type": "string"
                            },
                            "type": "array"
                        }
                    },
                    "required": ["key", "operator", "type", "value"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "key": {
                            "description": "Use one of the properties the user has provided in the plan.",
                            "type": "string"
                        },
                        "operator": {
                            "$ref": "#/definitions/AssistantDateTimePropertyFilterOperator"
                        },
                        "type": {
                            "anyOf": [
                                {
                                    "const": "event",
                                    "description": "Event properties",
                                    "type": "string"
                                },
                                {
                                    "const": "person",
                                    "description": "Person properties",
                                    "type": "string"
                                },
                                {
                                    "const": "session",
                                    "type": "string"
                                },
                                {
                                    "const": "feature",
                                    "description": "Event property with \"$feature/\" prepended",
                                    "type": "string"
                                }
                            ]
                        },
                        "value": {
                            "description": "Value must be a date in ISO 8601 format.",
                            "type": "string"
                        }
                    },
                    "required": ["key", "operator", "type", "value"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "key": {
                            "description": "Use one of the properties the user has provided in the plan.",
                            "type": "string"
                        },
                        "operator": {
                            "$ref": "#/definitions/AssistantSetPropertyFilterOperator",
                            "description": "`is_set` - the property has any value. `is_not_set` - the property doesn't have a value or wasn't collected."
                        },
                        "type": {
                            "anyOf": [
                                {
                                    "const": "event",
                                    "description": "Event properties",
                                    "type": "string"
                                },
                                {
                                    "const": "person",
                                    "description": "Person properties",
                                    "type": "string"
                                },
                                {
                                    "const": "session",
                                    "type": "string"
                                },
                                {
                                    "const": "feature",
                                    "description": "Event property with \"$feature/\" prepended",
                                    "type": "string"
                                }
                            ]
                        }
                    },
                    "required": ["key", "operator", "type"],
                    "type": "object"
                }
            ]
        },
        "AssistantGroupMultipleBreakdownFilter": {
            "additionalProperties": false,
            "properties": {
                "group_type_index": {
                    "anyOf": [
                        {
                            "$ref": "#/definitions/integer"
                        },
                        {
                            "type": "null"
                        }
                    ],
                    "description": "Index of the group type from the group mapping."
                },
                "property": {
                    "description": "Property name from the plan to break down by.",
                    "type": "string"
                },
                "type": {
                    "const": "group",
                    "type": "string"
                }
            },
            "required": ["property", "type"],
            "type": "object"
        },
        "AssistantGroupPropertyFilter": {
            "anyOf": [
                {
                    "additionalProperties": false,
                    "properties": {
                        "group_type_index": {
                            "$ref": "#/definitions/integer",
                            "description": "Index of the group type from the group mapping."
                        },
                        "key": {
                            "description": "Use one of the properties the user has provided in the plan.",
                            "type": "string"
                        },
                        "operator": {
                            "$ref": "#/definitions/AssistantSingleValuePropertyFilterOperator",
                            "description": "`icontains` - case insensitive contains. `not_icontains` - case insensitive does not contain. `regex` - matches the regex pattern. `not_regex` - does not match the regex pattern."
                        },
                        "type": {
                            "const": "group",
                            "type": "string"
                        },
                        "value": {
                            "description": "Only use property values from the plan. If the operator is `regex` or `not_regex`, the value must be a valid ClickHouse regex pattern to match against. Otherwise, the value must be a substring that will be matched against the property value.",
                            "type": "string"
                        }
                    },
                    "required": ["group_type_index", "key", "operator", "type", "value"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "group_type_index": {
                            "$ref": "#/definitions/integer",
                            "description": "Index of the group type from the group mapping."
                        },
                        "key": {
                            "description": "Use one of the properties the user has provided in the plan.",
                            "type": "string"
                        },
                        "operator": {
                            "$ref": "#/definitions/AssistantArrayPropertyFilterOperator",
                            "description": "`exact` - exact match of any of the values. `is_not` - does not match any of the values."
                        },
                        "type": {
                            "const": "group",
                            "type": "string"
                        },
                        "value": {
                            "description": "Only use property values from the plan. Always use strings as values. If you have a number, convert it to a string first. If you have a boolean, convert it to a string \"true\" or \"false\".",
                            "items": {
                                "type": "string"
                            },
                            "type": "array"
                        }
                    },
                    "required": ["group_type_index", "key", "operator", "type", "value"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "group_type_index": {
                            "$ref": "#/definitions/integer",
                            "description": "Index of the group type from the group mapping."
                        },
                        "key": {
                            "description": "Use one of the properties the user has provided in the plan.",
                            "type": "string"
                        },
                        "operator": {
                            "$ref": "#/definitions/AssistantDateTimePropertyFilterOperator"
                        },
                        "type": {
                            "const": "group",
                            "type": "string"
                        },
                        "value": {
                            "description": "Value must be a date in ISO 8601 format.",
                            "type": "string"
                        }
                    },
                    "required": ["group_type_index", "key", "operator", "type", "value"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "group_type_index": {
                            "$ref": "#/definitions/integer",
                            "description": "Index of the group type from the group mapping."
                        },
                        "key": {
                            "description": "Use one of the properties the user has provided in the plan.",
                            "type": "string"
                        },
                        "operator": {
                            "$ref": "#/definitions/AssistantSetPropertyFilterOperator",
                            "description": "`is_set` - the property has any value. `is_not_set` - the property doesn't have a value or wasn't collected."
                        },
                        "type": {
                            "const": "group",
                            "type": "string"
                        }
                    },
                    "required": ["group_type_index", "key", "operator", "type"],
                    "type": "object"
                }
            ]
        },
        "AssistantHogQLQuery": {
            "additionalProperties": false,
            "properties": {
                "kind": {
                    "const": "HogQLQuery",
                    "type": "string"
                },
                "query": {
                    "description": "SQL SELECT statement to execute. Mostly standard ClickHouse SQL with PostHog-specific additions.",
                    "type": "string"
                }
            },
            "required": ["kind", "query"],
            "type": "object"
        },
        "AssistantInsightsQueryBase": {
            "additionalProperties": false,
            "properties": {
                "dateRange": {
                    "$ref": "#/definitions/AssistantDateRangeFilter",
                    "description": "Date range for the query"
                },
                "filterTestAccounts": {
                    "default": false,
                    "description": "Exclude internal and test users by applying the respective filters",
                    "type": "boolean"
                },
                "properties": {
                    "default": [],
                    "description": "Property filters for all series",
                    "items": {
                        "$ref": "#/definitions/AssistantPropertyFilter"
                    },
                    "type": "array"
                },
                "samplingFactor": {
                    "description": "Sampling rate from 0 to 1 where 1 is 100% of the data.",
                    "type": ["number", "null"]
                }
            },
            "type": "object"
        },
        "AssistantMessage": {
            "additionalProperties": false,
            "properties": {
                "content": {
                    "type": "string"
                },
                "id": {
                    "type": "string"
                },
                "meta": {
                    "$ref": "#/definitions/AssistantMessageMetadata"
                },
                "tool_calls": {
                    "items": {
                        "$ref": "#/definitions/AssistantToolCall"
                    },
                    "type": "array"
                },
                "type": {
                    "const": "ai",
                    "type": "string"
                }
            },
            "required": ["type", "content"],
            "type": "object"
        },
        "AssistantMessageMetadata": {
            "additionalProperties": false,
            "properties": {
                "form": {
                    "$ref": "#/definitions/AssistantForm"
                }
            },
            "type": "object"
        },
        "AssistantMessageType": {
            "enum": ["human", "tool", "ai", "ai/reasoning", "ai/viz", "ai/failure"],
            "type": "string"
        },
        "AssistantMultipleBreakdownFilter": {
            "anyOf": [
                {
                    "$ref": "#/definitions/AssistantGroupMultipleBreakdownFilter"
                },
                {
                    "$ref": "#/definitions/AssistantGenericMultipleBreakdownFilter"
                }
            ]
        },
        "AssistantPropertyFilter": {
            "anyOf": [
                {
                    "$ref": "#/definitions/AssistantGenericPropertyFilter"
                },
                {
                    "$ref": "#/definitions/AssistantGroupPropertyFilter"
                }
            ]
        },
        "AssistantRetentionActionsNode": {
            "additionalProperties": false,
            "properties": {
                "id": {
                    "description": "Action ID from the plan.",
                    "type": "number"
                },
                "name": {
                    "description": "Action name from the plan.",
                    "type": "string"
                },
                "properties": {
                    "description": "Property filters for the action.",
                    "items": {
                        "$ref": "#/definitions/AssistantPropertyFilter"
                    },
                    "type": "array"
                },
                "type": {
                    "const": "actions",
                    "type": "string"
                }
            },
            "required": ["type", "id", "name"],
            "type": "object"
        },
        "AssistantRetentionEntity": {
            "anyOf": [
                {
                    "$ref": "#/definitions/AssistantRetentionEventsNode"
                },
                {
                    "$ref": "#/definitions/AssistantRetentionActionsNode"
                }
            ]
        },
        "AssistantRetentionEventsNode": {
            "additionalProperties": false,
            "properties": {
                "custom_name": {
                    "description": "Custom name for the event if it is needed to be renamed.",
                    "type": "string"
                },
                "name": {
                    "description": "Event name from the plan.",
                    "type": "string"
                },
                "properties": {
                    "description": "Property filters for the event.",
                    "items": {
                        "$ref": "#/definitions/AssistantPropertyFilter"
                    },
                    "type": "array"
                },
                "type": {
                    "const": "events",
                    "type": "string"
                }
            },
            "required": ["type", "name"],
            "type": "object"
        },
        "AssistantRetentionFilter": {
            "additionalProperties": false,
            "properties": {
                "cumulative": {
                    "description": "Whether retention should be rolling (aka unbounded, cumulative). Rolling retention means that a user coming back in period 5 makes them count towards all the previous periods.",
                    "type": "boolean"
                },
                "meanRetentionCalculation": {
                    "description": "Whether an additional series should be shown, showing the mean conversion for each period across cohorts.",
                    "enum": ["simple", "weighted", "none"],
                    "type": "string"
                },
                "period": {
                    "$ref": "#/definitions/RetentionPeriod",
                    "default": "Day",
                    "description": "Retention period, the interval to track cohorts by."
                },
                "retentionReference": {
                    "description": "Whether retention is with regard to initial cohort size, or that of the previous period.",
                    "enum": ["total", "previous"],
                    "type": "string"
                },
                "retentionType": {
                    "$ref": "#/definitions/RetentionType",
                    "description": "Retention type: recurring or first time. Recurring retention counts a user as part of a cohort if they performed the cohort event during that time period, irrespective of it was their first time or not. First time retention only counts a user as part of the cohort if it was their first time performing the cohort event."
                },
                "returningEntity": {
                    "$ref": "#/definitions/AssistantRetentionEntity",
                    "description": "Retention event (event marking the user coming back)."
                },
                "showMean": {
                    "description": "DEPRECATED: Whether an additional series should be shown, showing the mean conversion for each period across cohorts.",
                    "type": "boolean"
                },
                "targetEntity": {
                    "$ref": "#/definitions/AssistantRetentionEntity",
                    "description": "Activation event (event putting the actor into the initial cohort)."
                },
                "totalIntervals": {
                    "$ref": "#/definitions/integer",
                    "default": 11,
                    "description": "How many intervals to show in the chart. The default value is 11 (meaning 10 periods after initial cohort)."
                }
            },
            "required": ["returningEntity", "targetEntity"],
            "type": "object"
        },
        "AssistantRetentionQuery": {
            "additionalProperties": false,
            "properties": {
                "dateRange": {
                    "$ref": "#/definitions/AssistantDateRangeFilter",
                    "description": "Date range for the query"
                },
                "filterTestAccounts": {
                    "default": false,
                    "description": "Exclude internal and test users by applying the respective filters",
                    "type": "boolean"
                },
                "kind": {
                    "const": "RetentionQuery",
                    "type": "string"
                },
                "properties": {
                    "default": [],
                    "description": "Property filters for all series",
                    "items": {
                        "$ref": "#/definitions/AssistantPropertyFilter"
                    },
                    "type": "array"
                },
                "retentionFilter": {
                    "$ref": "#/definitions/AssistantRetentionFilter",
                    "description": "Properties specific to the retention insight"
                },
                "samplingFactor": {
                    "description": "Sampling rate from 0 to 1 where 1 is 100% of the data.",
                    "type": ["number", "null"]
                }
            },
            "required": ["kind", "retentionFilter"],
            "type": "object"
        },
        "AssistantSetPropertyFilter": {
            "additionalProperties": false,
            "properties": {
                "operator": {
                    "$ref": "#/definitions/AssistantSetPropertyFilterOperator",
                    "description": "`is_set` - the property has any value. `is_not_set` - the property doesn't have a value or wasn't collected."
                }
            },
            "required": ["operator"],
            "type": "object"
        },
        "AssistantSetPropertyFilterOperator": {
            "enum": ["is_set", "is_not_set"],
            "type": "string"
        },
        "AssistantSingleValuePropertyFilter": {
            "additionalProperties": false,
            "properties": {
                "operator": {
                    "$ref": "#/definitions/AssistantSingleValuePropertyFilterOperator",
                    "description": "`icontains` - case insensitive contains. `not_icontains` - case insensitive does not contain. `regex` - matches the regex pattern. `not_regex` - does not match the regex pattern."
                },
                "value": {
                    "description": "Only use property values from the plan. If the operator is `regex` or `not_regex`, the value must be a valid ClickHouse regex pattern to match against. Otherwise, the value must be a substring that will be matched against the property value.",
                    "type": "string"
                }
            },
            "required": ["operator", "value"],
            "type": "object"
        },
        "AssistantSingleValuePropertyFilterOperator": {
            "enum": ["exact", "is_not", "icontains", "not_icontains", "regex", "not_regex"],
            "type": "string"
        },
        "AssistantStringNumberOrBooleanPropertyFilter": {
            "anyOf": [
                {
                    "$ref": "#/definitions/AssistantSingleValuePropertyFilter"
                },
                {
                    "$ref": "#/definitions/AssistantArrayPropertyFilter"
                }
            ]
        },
        "AssistantToolCall": {
            "additionalProperties": false,
            "properties": {
                "args": {
                    "additionalProperties": {},
                    "type": "object"
                },
                "id": {
                    "type": "string"
                },
                "name": {
                    "type": "string"
                },
                "type": {
                    "const": "tool_call",
                    "default": "tool_call",
                    "description": "`type` needed to conform to the OpenAI shape, which is expected by LangChain",
                    "type": "string"
                }
            },
            "required": ["id", "name", "args", "type"],
            "type": "object"
        },
        "AssistantToolCallMessage": {
            "additionalProperties": false,
            "properties": {
                "content": {
                    "type": "string"
                },
                "id": {
                    "type": "string"
                },
                "tool_call_id": {
                    "type": "string"
                },
                "type": {
                    "const": "tool",
                    "type": "string"
                },
                "ui_payload": {
                    "description": "Payload passed through to the frontend - specifically for calls of contextual tool. Tool call messages without a ui_payload are not passed through to the frontend.",
                    "type": "object"
                }
            },
            "required": ["type", "content", "tool_call_id"],
            "type": "object"
        },
        "AssistantTrendsActionsNode": {
            "additionalProperties": false,
            "description": "Defines the action series. You must provide the action ID in the `id` field and the name in the `name` field.",
            "properties": {
                "custom_name": {
                    "type": "string"
                },
                "id": {
                    "$ref": "#/definitions/integer"
                },
                "kind": {
                    "const": "ActionsNode",
                    "type": "string"
                },
                "math": {
                    "$ref": "#/definitions/MathType"
                },
                "math_group_type_index": {
                    "enum": [0, 1, 2, 3, 4],
                    "type": "number"
                },
                "math_property": {
                    "type": "string"
                },
                "math_property_revenue_currency": {
                    "$ref": "#/definitions/RevenueCurrencyPropertyConfig"
                },
                "math_property_type": {
                    "type": "string"
                },
                "name": {
                    "description": "Action name from the plan.",
                    "type": "string"
                },
                "properties": {
                    "items": {
                        "$ref": "#/definitions/AssistantPropertyFilter"
                    },
                    "type": "array"
                }
            },
            "required": ["id", "kind", "name"],
            "type": "object"
        },
        "AssistantTrendsBreakdownFilter": {
            "additionalProperties": false,
            "properties": {
                "breakdown_limit": {
                    "$ref": "#/definitions/integer",
                    "default": 25,
                    "description": "How many distinct values to show."
                },
                "breakdowns": {
                    "description": "Use this field to define breakdowns.",
                    "items": {
                        "$ref": "#/definitions/AssistantMultipleBreakdownFilter"
                    },
                    "maxLength": 3,
                    "type": "array"
                }
            },
            "required": ["breakdowns"],
            "type": "object"
        },
        "AssistantTrendsDisplayType": {
            "anyOf": [
                {
                    "const": "ActionsLineGraph",
                    "type": "string"
                },
                {
                    "const": "ActionsBar",
                    "type": "string"
                },
                {
                    "const": "ActionsAreaGraph",
                    "type": "string"
                },
                {
                    "const": "ActionsLineGraphCumulative",
                    "type": "string"
                },
                {
                    "const": "BoldNumber",
                    "type": "string"
                },
                {
                    "const": "ActionsPie",
                    "type": "string"
                },
                {
                    "const": "ActionsBarValue",
                    "type": "string"
                },
                {
                    "const": "ActionsTable",
                    "type": "string"
                },
                {
                    "const": "WorldMap",
                    "type": "string"
                },
                {
                    "not": {}
                }
            ]
        },
        "AssistantTrendsEventsNode": {
            "additionalProperties": false,
            "description": "Defines the event series.",
            "properties": {
                "custom_name": {
                    "type": "string"
                },
                "event": {
                    "description": "The event or `null` for all events.",
                    "type": ["string", "null"]
                },
                "kind": {
                    "const": "EventsNode",
                    "type": "string"
                },
                "math": {
                    "$ref": "#/definitions/MathType"
                },
                "math_group_type_index": {
                    "enum": [0, 1, 2, 3, 4],
                    "type": "number"
                },
                "math_property": {
                    "type": "string"
                },
                "math_property_revenue_currency": {
                    "$ref": "#/definitions/RevenueCurrencyPropertyConfig"
                },
                "math_property_type": {
                    "type": "string"
                },
                "name": {
                    "type": "string"
                },
                "properties": {
                    "items": {
                        "$ref": "#/definitions/AssistantPropertyFilter"
                    },
                    "type": "array"
                }
            },
            "required": ["kind"],
            "type": "object"
        },
        "AssistantTrendsFilter": {
            "additionalProperties": false,
            "properties": {
                "aggregationAxisFormat": {
                    "$ref": "#/definitions/AggregationAxisFormat",
                    "default": "numeric",
                    "description": "Formats the trends value axis. Do not use the formatting unless you are absolutely sure that formatting will match the data. `numeric` - no formatting. Prefer this option by default. `duration` - formats the value in seconds to a human-readable duration, e.g., `132` becomes `2 minutes 12 seconds`. Use this option only if you are sure that the values are in seconds. `duration_ms` - formats the value in miliseconds to a human-readable duration, e.g., `1050` becomes `1 second 50 milliseconds`. Use this option only if you are sure that the values are in miliseconds. `percentage` - adds a percentage sign to the value, e.g., `50` becomes `50%`. `percentage_scaled` - formats the value as a percentage scaled to 0-100, e.g., `0.5` becomes `50%`."
                },
                "aggregationAxisPostfix": {
                    "description": "Custom postfix to add to the aggregation axis, e.g., ` clicks` to format 5 as `5 clicks`. You may need to add a space before postfix.",
                    "type": "string"
                },
                "aggregationAxisPrefix": {
                    "description": "Custom prefix to add to the aggregation axis, e.g., `$` for USD dollars. You may need to add a space after prefix.",
                    "type": "string"
                },
                "decimalPlaces": {
                    "description": "Number of decimal places to show. Do not add this unless you are sure that values will have a decimal point.",
                    "type": "number"
                },
                "display": {
                    "default": "ActionsLineGraph",
                    "description": "Visualization type. Available values: `ActionsLineGraph` - time-series line chart; most common option, as it shows change over time. `ActionsBar` - time-series bar chart. `ActionsAreaGraph` - time-series area chart. `ActionsLineGraphCumulative` - cumulative time-series line chart; good for cumulative metrics. `BoldNumber` - total value single large number. You can't use this with breakdown or with multiple series; use when user explicitly asks for a single output number. `ActionsBarValue` - total value (NOT time-series) bar chart; good for categorical data. `ActionsPie` - total value pie chart; good for visualizing proportions. `ActionsTable` - total value table; good when using breakdown to list users or other entities. `WorldMap` - total value world map; use when breaking down by country name using property `$geoip_country_name`, and only then.",
                    "enum": [
                        "ActionsLineGraph",
                        "ActionsBar",
                        "ActionsAreaGraph",
                        "ActionsLineGraphCumulative",
                        "BoldNumber",
                        "ActionsPie",
                        "ActionsBarValue",
                        "ActionsTable",
                        "WorldMap"
                    ],
                    "type": "string"
                },
                "formulas": {
                    "description": "If the formula is provided, apply it here.",
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                },
                "showLegend": {
                    "default": false,
                    "description": "Whether to show the legend describing series and breakdowns.",
                    "type": "boolean"
                },
                "showPercentStackView": {
                    "default": false,
                    "description": "Whether to show a percentage of each series. Use only with",
                    "type": "boolean"
                },
                "showValuesOnSeries": {
                    "default": false,
                    "description": "Whether to show a value on each data point.",
                    "type": "boolean"
                },
                "yAxisScaleType": {
                    "default": "linear",
                    "description": "Whether to scale the y-axis.",
                    "enum": ["log10", "linear"],
                    "type": "string"
                }
            },
            "type": "object"
        },
        "AssistantTrendsQuery": {
            "additionalProperties": false,
            "properties": {
                "breakdownFilter": {
                    "$ref": "#/definitions/AssistantTrendsBreakdownFilter",
                    "description": "Breakdown of the series"
                },
                "compareFilter": {
                    "$ref": "#/definitions/CompareFilter",
                    "description": "Compare to date range"
                },
                "dateRange": {
                    "$ref": "#/definitions/AssistantDateRangeFilter",
                    "description": "Date range for the query"
                },
                "filterTestAccounts": {
                    "default": false,
                    "description": "Exclude internal and test users by applying the respective filters",
                    "type": "boolean"
                },
                "interval": {
                    "$ref": "#/definitions/IntervalType",
                    "default": "day",
                    "description": "Granularity of the response. Can be one of `hour`, `day`, `week` or `month`"
                },
                "kind": {
                    "const": "TrendsQuery",
                    "type": "string"
                },
                "properties": {
                    "default": [],
                    "description": "Property filters for all series",
                    "items": {
                        "$ref": "#/definitions/AssistantPropertyFilter"
                    },
                    "type": "array"
                },
                "samplingFactor": {
                    "description": "Sampling rate from 0 to 1 where 1 is 100% of the data.",
                    "type": ["number", "null"]
                },
                "series": {
                    "description": "Events or actions to include",
                    "items": {
                        "anyOf": [
                            {
                                "$ref": "#/definitions/AssistantTrendsEventsNode"
                            },
                            {
                                "$ref": "#/definitions/AssistantTrendsActionsNode"
                            }
                        ]
                    },
                    "type": "array"
                },
                "trendsFilter": {
                    "$ref": "#/definitions/AssistantTrendsFilter",
                    "description": "Properties specific to the trends insight"
                }
            },
            "required": ["kind", "series"],
            "type": "object"
        },
        "AutocompleteCompletionItem": {
            "additionalProperties": false,
            "properties": {
                "detail": {
                    "description": "A human-readable string with additional information about this item, like type or symbol information.",
                    "type": "string"
                },
                "documentation": {
                    "description": "A human-readable string that represents a doc-comment.",
                    "type": "string"
                },
                "insertText": {
                    "description": "A string or snippet that should be inserted in a document when selecting this completion.",
                    "type": "string"
                },
                "kind": {
                    "$ref": "#/definitions/AutocompleteCompletionItemKind",
                    "description": "The kind of this completion item. Based on the kind an icon is chosen by the editor."
                },
                "label": {
                    "description": "The label of this completion item. By default this is also the text that is inserted when selecting this completion.",
                    "type": "string"
                }
            },
            "required": ["label", "insertText", "kind"],
            "type": "object"
        },
        "AutocompleteCompletionItemKind": {
            "enum": [
                "Method",
                "Function",
                "Constructor",
                "Field",
                "Variable",
                "Class",
                "Struct",
                "Interface",
                "Module",
                "Property",
                "Event",
                "Operator",
                "Unit",
                "Value",
                "Constant",
                "Enum",
                "EnumMember",
                "Keyword",
                "Text",
                "Color",
                "File",
                "Reference",
                "Customcolor",
                "Folder",
                "TypeParameter",
                "User",
                "Issue",
                "Snippet"
            ],
            "type": "string"
        },
        "BaseAssistantMessage": {
            "additionalProperties": false,
            "properties": {
                "id": {
                    "type": "string"
                }
            },
            "type": "object"
        },
        "BaseMathType": {
            "enum": [
                "total",
                "dau",
                "weekly_active",
                "monthly_active",
                "unique_session",
                "first_time_for_user",
                "first_matching_event_for_user"
            ],
            "type": "string"
        },
        "BinCountValue": {
            "anyOf": [
                {
                    "type": "number"
                },
                {
                    "const": "auto",
                    "type": "string"
                }
            ]
        },
        "Breakdown": {
            "additionalProperties": false,
            "properties": {
                "group_type_index": {
                    "anyOf": [
                        {
                            "$ref": "#/definitions/integer"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "histogram_bin_count": {
                    "$ref": "#/definitions/integer"
                },
                "normalize_url": {
                    "type": "boolean"
                },
                "property": {
                    "type": "string"
                },
                "type": {
                    "anyOf": [
                        {
                            "$ref": "#/definitions/MultipleBreakdownType"
                        },
                        {
                            "type": "null"
                        }
                    ]
                }
            },
            "required": ["property"],
            "type": "object"
        },
        "BreakdownAttributionType": {
            "enum": ["first_touch", "last_touch", "all_events", "step"],
            "type": "string"
        },
        "BreakdownFilter": {
            "additionalProperties": false,
            "properties": {
                "breakdown": {
                    "anyOf": [
                        {
                            "type": "string"
                        },
                        {
                            "$ref": "#/definitions/integer"
                        },
                        {
                            "items": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "$ref": "#/definitions/integer"
                                    }
                                ]
                            },
                            "type": "array"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "breakdown_group_type_index": {
                    "anyOf": [
                        {
                            "$ref": "#/definitions/integer"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "breakdown_hide_other_aggregation": {
                    "type": ["boolean", "null"]
                },
                "breakdown_histogram_bin_count": {
                    "$ref": "#/definitions/integer"
                },
                "breakdown_limit": {
                    "$ref": "#/definitions/integer"
                },
                "breakdown_normalize_url": {
                    "type": "boolean"
                },
                "breakdown_type": {
                    "anyOf": [
                        {
                            "$ref": "#/definitions/BreakdownType"
                        },
                        {
                            "type": "null"
                        }
                    ],
                    "default": "event"
                },
                "breakdowns": {
                    "items": {
                        "$ref": "#/definitions/Breakdown"
                    },
                    "maxLength": 3,
                    "type": "array"
                }
            },
            "type": "object"
        },
        "BreakdownItem": {
            "additionalProperties": false,
            "properties": {
                "label": {
                    "type": "string"
                },
                "value": {
                    "anyOf": [
                        {
                            "type": "string"
                        },
                        {
                            "$ref": "#/definitions/BreakdownValueInt"
                        }
                    ]
                }
            },
            "required": ["label", "value"],
            "type": "object"
        },
        "BreakdownKeyType": {
            "anyOf": [
                {
                    "type": "integer"
                },
                {
                    "type": "string"
                },
                {
                    "type": "number"
                },
                {
                    "items": {
                        "anyOf": [
                            {
                                "type": "integer"
                            },
                            {
                                "type": "string"
                            },
                            {
                                "type": "number"
                            }
                        ]
                    },
                    "type": "array"
                },
                {
                    "type": "null"
                }
            ]
        },
        "BreakdownType": {
            "enum": [
                "cohort",
                "person",
                "event",
                "event_metadata",
                "group",
                "session",
                "hogql",
                "data_warehouse",
                "data_warehouse_person_property"
            ],
            "type": "string"
        },
        "BreakdownValueInt": {
            "$ref": "#/definitions/integer"
        },
        "CacheMissResponse": {
            "additionalProperties": false,
            "properties": {
                "cache_key": {
                    "type": ["string", "null"]
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus"
                }
            },
            "required": ["cache_key"],
            "type": "object"
        },
        "CachedActorsPropertyTaxonomyQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "cache_key": {
                    "type": "string"
                },
                "cache_target_age": {
                    "format": "date-time",
                    "type": "string"
                },
                "calculation_trigger": {
                    "description": "What triggered the calculation of the query, leave empty if user/immediate",
                    "type": "string"
                },
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "is_cached": {
                    "type": "boolean"
                },
                "last_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "next_allowed_client_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "$ref": "#/definitions/ActorsPropertyTaxonomyResponse"
                },
                "timezone": {
                    "type": "string"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                }
            },
            "required": [
                "cache_key",
                "is_cached",
                "last_refresh",
                "next_allowed_client_refresh",
                "results",
                "timezone"
            ],
            "type": "object"
        },
        "CachedActorsQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "cache_key": {
                    "type": "string"
                },
                "cache_target_age": {
                    "format": "date-time",
                    "type": "string"
                },
                "calculation_trigger": {
                    "description": "What triggered the calculation of the query, leave empty if user/immediate",
                    "type": "string"
                },
                "columns": {
                    "items": {},
                    "type": "array"
                },
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hasMore": {
                    "type": "boolean"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "is_cached": {
                    "type": "boolean"
                },
                "last_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "limit": {
                    "$ref": "#/definitions/integer"
                },
                "missing_actors_count": {
                    "$ref": "#/definitions/integer"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "next_allowed_client_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "offset": {
                    "$ref": "#/definitions/integer"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "items": {
                        "items": {},
                        "type": "array"
                    },
                    "type": "array"
                },
                "timezone": {
                    "type": "string"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                },
                "types": {
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                }
            },
            "required": [
                "cache_key",
                "columns",
                "hogql",
                "is_cached",
                "last_refresh",
                "limit",
                "next_allowed_client_refresh",
                "offset",
                "results",
                "timezone",
                "types"
            ],
            "type": "object"
        },
        "CachedErrorTrackingQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "cache_key": {
                    "type": "string"
                },
                "cache_target_age": {
                    "format": "date-time",
                    "type": "string"
                },
                "calculation_trigger": {
                    "description": "What triggered the calculation of the query, leave empty if user/immediate",
                    "type": "string"
                },
                "columns": {
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                },
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hasMore": {
                    "type": "boolean"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "is_cached": {
                    "type": "boolean"
                },
                "last_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "limit": {
                    "$ref": "#/definitions/integer"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "next_allowed_client_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "offset": {
                    "$ref": "#/definitions/integer"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "items": {
                        "$ref": "#/definitions/ErrorTrackingIssue"
                    },
                    "type": "array"
                },
                "timezone": {
                    "type": "string"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                }
            },
            "required": [
                "cache_key",
                "is_cached",
                "last_refresh",
                "next_allowed_client_refresh",
                "results",
                "timezone"
            ],
            "type": "object"
        },
        "CachedEventTaxonomyQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "cache_key": {
                    "type": "string"
                },
                "cache_target_age": {
                    "format": "date-time",
                    "type": "string"
                },
                "calculation_trigger": {
                    "description": "What triggered the calculation of the query, leave empty if user/immediate",
                    "type": "string"
                },
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "is_cached": {
                    "type": "boolean"
                },
                "last_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "next_allowed_client_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "$ref": "#/definitions/EventTaxonomyResponse"
                },
                "timezone": {
                    "type": "string"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                }
            },
            "required": [
                "cache_key",
                "is_cached",
                "last_refresh",
                "next_allowed_client_refresh",
                "results",
                "timezone"
            ],
            "type": "object"
        },
        "CachedEventsHeatMapQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "cache_key": {
                    "type": "string"
                },
                "cache_target_age": {
                    "format": "date-time",
                    "type": "string"
                },
                "calculation_trigger": {
                    "description": "What triggered the calculation of the query, leave empty if user/immediate",
                    "type": "string"
                },
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hasMore": {
                    "type": "boolean"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "is_cached": {
                    "type": "boolean"
                },
                "last_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "limit": {
                    "$ref": "#/definitions/integer"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "next_allowed_client_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "$ref": "#/definitions/EventsHeatMapStructuredResult"
                },
                "timezone": {
                    "type": "string"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                }
            },
            "required": [
                "cache_key",
                "is_cached",
                "last_refresh",
                "next_allowed_client_refresh",
                "results",
                "timezone"
            ],
            "type": "object"
        },
        "CachedEventsQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "cache_key": {
                    "type": "string"
                },
                "cache_target_age": {
                    "format": "date-time",
                    "type": "string"
                },
                "calculation_trigger": {
                    "description": "What triggered the calculation of the query, leave empty if user/immediate",
                    "type": "string"
                },
                "columns": {
                    "items": {},
                    "type": "array"
                },
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hasMore": {
                    "type": "boolean"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "is_cached": {
                    "type": "boolean"
                },
                "last_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "limit": {
                    "$ref": "#/definitions/integer"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "next_allowed_client_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "offset": {
                    "$ref": "#/definitions/integer"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "items": {
                        "items": {},
                        "type": "array"
                    },
                    "type": "array"
                },
                "timezone": {
                    "type": "string"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                },
                "types": {
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                }
            },
            "required": [
                "cache_key",
                "columns",
                "hogql",
                "is_cached",
                "last_refresh",
                "next_allowed_client_refresh",
                "results",
                "timezone",
                "types"
            ],
            "type": "object"
        },
        "CachedExperimentExposureQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "cache_key": {
                    "type": "string"
                },
                "cache_target_age": {
                    "format": "date-time",
                    "type": "string"
                },
                "calculation_trigger": {
                    "description": "What triggered the calculation of the query, leave empty if user/immediate",
                    "type": "string"
                },
                "date_range": {
                    "$ref": "#/definitions/DateRange"
                },
                "is_cached": {
                    "type": "boolean"
                },
                "kind": {
                    "const": "ExperimentExposureQuery",
                    "type": "string"
                },
                "last_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "next_allowed_client_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "timeseries": {
                    "items": {
                        "$ref": "#/definitions/ExperimentExposureTimeSeries"
                    },
                    "type": "array"
                },
                "timezone": {
                    "type": "string"
                },
                "total_exposures": {
                    "additionalProperties": {
                        "type": "number"
                    },
                    "type": "object"
                }
            },
            "required": [
                "cache_key",
                "date_range",
                "is_cached",
                "kind",
                "last_refresh",
                "next_allowed_client_refresh",
                "timeseries",
                "timezone",
                "total_exposures"
            ],
            "type": "object"
        },
        "CachedExperimentFunnelsQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "cache_key": {
                    "type": "string"
                },
                "cache_target_age": {
                    "format": "date-time",
                    "type": "string"
                },
                "calculation_trigger": {
                    "description": "What triggered the calculation of the query, leave empty if user/immediate",
                    "type": "string"
                },
                "credible_intervals": {
                    "additionalProperties": {
                        "items": {
                            "type": "number"
                        },
                        "maxItems": 2,
                        "minItems": 2,
                        "type": "array"
                    },
                    "type": "object"
                },
                "expected_loss": {
                    "type": "number"
                },
                "funnels_query": {
                    "$ref": "#/definitions/FunnelsQuery"
                },
                "insight": {
                    "items": {
                        "items": {
                            "type": "object"
                        },
                        "type": "array"
                    },
                    "type": "array"
                },
                "is_cached": {
                    "type": "boolean"
                },
                "kind": {
                    "const": "ExperimentFunnelsQuery",
                    "type": "string"
                },
                "last_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "next_allowed_client_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "probability": {
                    "additionalProperties": {
                        "type": "number"
                    },
                    "type": "object"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "significance_code": {
                    "$ref": "#/definitions/ExperimentSignificanceCode"
                },
                "significant": {
                    "type": "boolean"
                },
                "stats_version": {
                    "$ref": "#/definitions/integer"
                },
                "timezone": {
                    "type": "string"
                },
                "variants": {
                    "items": {
                        "$ref": "#/definitions/ExperimentVariantFunnelsBaseStats"
                    },
                    "type": "array"
                }
            },
            "required": [
                "cache_key",
                "credible_intervals",
                "expected_loss",
                "insight",
                "is_cached",
                "kind",
                "last_refresh",
                "next_allowed_client_refresh",
                "probability",
                "significance_code",
                "significant",
                "timezone",
                "variants"
            ],
            "type": "object"
        },
        "CachedExperimentQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "cache_key": {
                    "type": "string"
                },
                "cache_target_age": {
                    "format": "date-time",
                    "type": "string"
                },
                "calculation_trigger": {
                    "description": "What triggered the calculation of the query, leave empty if user/immediate",
                    "type": "string"
                },
                "credible_intervals": {
                    "additionalProperties": {
                        "items": {
                            "type": "number"
                        },
                        "maxItems": 2,
                        "minItems": 2,
                        "type": "array"
                    },
                    "type": "object"
                },
                "insight": {
                    "items": {
                        "type": "object"
                    },
                    "type": "array"
                },
                "is_cached": {
                    "type": "boolean"
                },
                "kind": {
                    "const": "ExperimentQuery",
                    "type": "string"
                },
                "last_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "metric": {
                    "$ref": "#/definitions/ExperimentMetric"
                },
                "next_allowed_client_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "p_value": {
                    "type": "number"
                },
                "probability": {
                    "additionalProperties": {
                        "type": "number"
                    },
                    "type": "object"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "significance_code": {
                    "$ref": "#/definitions/ExperimentSignificanceCode"
                },
                "significant": {
                    "type": "boolean"
                },
                "stats_version": {
                    "$ref": "#/definitions/integer"
                },
                "timezone": {
                    "type": "string"
                },
                "variants": {
                    "anyOf": [
                        {
                            "items": {
                                "$ref": "#/definitions/ExperimentVariantTrendsBaseStats"
                            },
                            "type": "array"
                        },
                        {
                            "items": {
                                "$ref": "#/definitions/ExperimentVariantFunnelsBaseStats"
                            },
                            "type": "array"
                        }
                    ]
                }
            },
            "required": [
                "cache_key",
                "credible_intervals",
                "insight",
                "is_cached",
                "kind",
                "last_refresh",
                "metric",
                "next_allowed_client_refresh",
                "p_value",
                "probability",
                "significance_code",
                "significant",
                "timezone",
                "variants"
            ],
            "type": "object"
        },
        "CachedExperimentTrendsQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "cache_key": {
                    "type": "string"
                },
                "cache_target_age": {
                    "format": "date-time",
                    "type": "string"
                },
                "calculation_trigger": {
                    "description": "What triggered the calculation of the query, leave empty if user/immediate",
                    "type": "string"
                },
                "count_query": {
                    "$ref": "#/definitions/TrendsQuery"
                },
                "credible_intervals": {
                    "additionalProperties": {
                        "items": {
                            "type": "number"
                        },
                        "maxItems": 2,
                        "minItems": 2,
                        "type": "array"
                    },
                    "type": "object"
                },
                "exposure_query": {
                    "$ref": "#/definitions/TrendsQuery"
                },
                "insight": {
                    "items": {
                        "type": "object"
                    },
                    "type": "array"
                },
                "is_cached": {
                    "type": "boolean"
                },
                "kind": {
                    "const": "ExperimentTrendsQuery",
                    "type": "string"
                },
                "last_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "next_allowed_client_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "p_value": {
                    "type": "number"
                },
                "probability": {
                    "additionalProperties": {
                        "type": "number"
                    },
                    "type": "object"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "significance_code": {
                    "$ref": "#/definitions/ExperimentSignificanceCode"
                },
                "significant": {
                    "type": "boolean"
                },
                "stats_version": {
                    "$ref": "#/definitions/integer"
                },
                "timezone": {
                    "type": "string"
                },
                "variants": {
                    "items": {
                        "$ref": "#/definitions/ExperimentVariantTrendsBaseStats"
                    },
                    "type": "array"
                }
            },
            "required": [
                "cache_key",
                "credible_intervals",
                "insight",
                "is_cached",
                "kind",
                "last_refresh",
                "next_allowed_client_refresh",
                "p_value",
                "probability",
                "significance_code",
                "significant",
                "timezone",
                "variants"
            ],
            "type": "object"
        },
        "CachedFunnelCorrelationResponse": {
            "additionalProperties": false,
            "properties": {
                "cache_key": {
                    "type": "string"
                },
                "cache_target_age": {
                    "format": "date-time",
                    "type": "string"
                },
                "calculation_trigger": {
                    "description": "What triggered the calculation of the query, leave empty if user/immediate",
                    "type": "string"
                },
                "columns": {
                    "items": {},
                    "type": "array"
                },
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hasMore": {
                    "type": "boolean"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "is_cached": {
                    "type": "boolean"
                },
                "last_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "limit": {
                    "$ref": "#/definitions/integer"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "next_allowed_client_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "offset": {
                    "$ref": "#/definitions/integer"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "$ref": "#/definitions/FunnelCorrelationResult"
                },
                "timezone": {
                    "type": "string"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                },
                "types": {
                    "items": {},
                    "type": "array"
                }
            },
            "required": [
                "cache_key",
                "is_cached",
                "last_refresh",
                "next_allowed_client_refresh",
                "results",
                "timezone"
            ],
            "type": "object"
        },
        "CachedFunnelsQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "cache_key": {
                    "type": "string"
                },
                "cache_target_age": {
                    "format": "date-time",
                    "type": "string"
                },
                "calculation_trigger": {
                    "description": "What triggered the calculation of the query, leave empty if user/immediate",
                    "type": "string"
                },
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "isUdf": {
                    "type": "boolean"
                },
                "is_cached": {
                    "type": "boolean"
                },
                "last_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "next_allowed_client_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "anyOf": [
                        {
                            "$ref": "#/definitions/FunnelStepsResults"
                        },
                        {
                            "$ref": "#/definitions/FunnelStepsBreakdownResults"
                        },
                        {
                            "$ref": "#/definitions/FunnelTimeToConvertResults"
                        },
                        {
                            "$ref": "#/definitions/FunnelTrendsResults"
                        }
                    ]
                },
                "timezone": {
                    "type": "string"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                }
            },
            "required": [
                "cache_key",
                "is_cached",
                "last_refresh",
                "next_allowed_client_refresh",
                "results",
                "timezone"
            ],
            "type": "object"
        },
        "CachedGroupsQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "cache_key": {
                    "type": "string"
                },
                "cache_target_age": {
                    "format": "date-time",
                    "type": "string"
                },
                "calculation_trigger": {
                    "description": "What triggered the calculation of the query, leave empty if user/immediate",
                    "type": "string"
                },
                "columns": {
                    "items": {},
                    "type": "array"
                },
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hasMore": {
                    "type": "boolean"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "is_cached": {
                    "type": "boolean"
                },
                "kind": {
                    "const": "GroupsQuery",
                    "type": "string"
                },
                "last_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "limit": {
                    "$ref": "#/definitions/integer"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "next_allowed_client_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "offset": {
                    "$ref": "#/definitions/integer"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "items": {
                        "items": {},
                        "type": "array"
                    },
                    "type": "array"
                },
                "timezone": {
                    "type": "string"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                },
                "types": {
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                }
            },
            "required": [
                "cache_key",
                "columns",
                "hogql",
                "is_cached",
                "kind",
                "last_refresh",
                "limit",
                "next_allowed_client_refresh",
                "offset",
                "results",
                "timezone",
                "types"
            ],
            "type": "object"
        },
        "CachedHogQLQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "cache_key": {
                    "type": "string"
                },
                "cache_target_age": {
                    "format": "date-time",
                    "type": "string"
                },
                "calculation_trigger": {
                    "description": "What triggered the calculation of the query, leave empty if user/immediate",
                    "type": "string"
                },
                "clickhouse": {
                    "description": "Executed ClickHouse query",
                    "type": "string"
                },
                "columns": {
                    "description": "Returned columns",
                    "items": {},
                    "type": "array"
                },
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "explain": {
                    "description": "Query explanation output",
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                },
                "hasMore": {
                    "type": "boolean"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "is_cached": {
                    "type": "boolean"
                },
                "last_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "limit": {
                    "$ref": "#/definitions/integer"
                },
                "metadata": {
                    "$ref": "#/definitions/HogQLMetadataResponse",
                    "description": "Query metadata output"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "next_allowed_client_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "offset": {
                    "$ref": "#/definitions/integer"
                },
                "query": {
                    "description": "Input query string",
                    "type": "string"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "items": {},
                    "type": "array"
                },
                "timezone": {
                    "type": "string"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                },
                "types": {
                    "description": "Types of returned columns",
                    "items": {},
                    "type": "array"
                }
            },
            "required": [
                "cache_key",
                "is_cached",
                "last_refresh",
                "next_allowed_client_refresh",
                "results",
                "timezone"
            ],
            "type": "object"
        },
        "CachedInsightActorsQueryOptionsResponse": {
            "additionalProperties": false,
            "properties": {
                "breakdown": {
                    "items": {
                        "$ref": "#/definitions/BreakdownItem"
                    },
                    "type": "array"
                },
                "breakdowns": {
                    "items": {
                        "$ref": "#/definitions/MultipleBreakdownOptions"
                    },
                    "type": "array"
                },
                "cache_key": {
                    "type": "string"
                },
                "cache_target_age": {
                    "format": "date-time",
                    "type": "string"
                },
                "calculation_trigger": {
                    "description": "What triggered the calculation of the query, leave empty if user/immediate",
                    "type": "string"
                },
                "compare": {
                    "items": {
                        "additionalProperties": false,
                        "properties": {
                            "label": {
                                "type": "string"
                            },
                            "value": {
                                "type": "string"
                            }
                        },
                        "required": ["label", "value"],
                        "type": "object"
                    },
                    "type": "array"
                },
                "day": {
                    "items": {
                        "additionalProperties": false,
                        "properties": {
                            "label": {
                                "type": "string"
                            },
                            "value": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "$ref": "#/definitions/DatetimeDay"
                                    },
                                    {
                                        "$ref": "#/definitions/Day"
                                    }
                                ]
                            }
                        },
                        "required": ["label", "value"],
                        "type": "object"
                    },
                    "type": "array"
                },
                "interval": {
                    "items": {
                        "additionalProperties": false,
                        "properties": {
                            "label": {
                                "type": "string"
                            },
                            "value": {
                                "$ref": "#/definitions/integer",
                                "description": "An interval selected out of available intervals in source query"
                            }
                        },
                        "required": ["label", "value"],
                        "type": "object"
                    },
                    "type": "array"
                },
                "is_cached": {
                    "type": "boolean"
                },
                "last_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "next_allowed_client_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "series": {
                    "items": {
                        "additionalProperties": false,
                        "properties": {
                            "label": {
                                "type": "string"
                            },
                            "value": {
                                "$ref": "#/definitions/integer"
                            }
                        },
                        "required": ["label", "value"],
                        "type": "object"
                    },
                    "type": "array"
                },
                "status": {
                    "items": {
                        "additionalProperties": false,
                        "properties": {
                            "label": {
                                "type": "string"
                            },
                            "value": {
                                "type": "string"
                            }
                        },
                        "required": ["label", "value"],
                        "type": "object"
                    },
                    "type": "array"
                },
                "timezone": {
                    "type": "string"
                }
            },
            "required": ["cache_key", "is_cached", "last_refresh", "next_allowed_client_refresh", "timezone"],
            "type": "object"
        },
        "CachedLifecycleQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "cache_key": {
                    "type": "string"
                },
                "cache_target_age": {
                    "format": "date-time",
                    "type": "string"
                },
                "calculation_trigger": {
                    "description": "What triggered the calculation of the query, leave empty if user/immediate",
                    "type": "string"
                },
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "is_cached": {
                    "type": "boolean"
                },
                "last_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "next_allowed_client_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "items": {
                        "type": "object"
                    },
                    "type": "array"
                },
                "timezone": {
                    "type": "string"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                }
            },
            "required": [
                "cache_key",
                "is_cached",
                "last_refresh",
                "next_allowed_client_refresh",
                "results",
                "timezone"
            ],
            "type": "object"
        },
        "CachedPathsQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "cache_key": {
                    "type": "string"
                },
                "cache_target_age": {
                    "format": "date-time",
                    "type": "string"
                },
                "calculation_trigger": {
                    "description": "What triggered the calculation of the query, leave empty if user/immediate",
                    "type": "string"
                },
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "is_cached": {
                    "type": "boolean"
                },
                "last_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "next_allowed_client_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "items": {
                        "$ref": "#/definitions/PathsLink"
                    },
                    "type": "array"
                },
                "timezone": {
                    "type": "string"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                }
            },
            "required": [
                "cache_key",
                "is_cached",
                "last_refresh",
                "next_allowed_client_refresh",
                "results",
                "timezone"
            ],
            "type": "object"
        },
        "CachedRetentionQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "cache_key": {
                    "type": "string"
                },
                "cache_target_age": {
                    "format": "date-time",
                    "type": "string"
                },
                "calculation_trigger": {
                    "description": "What triggered the calculation of the query, leave empty if user/immediate",
                    "type": "string"
                },
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "is_cached": {
                    "type": "boolean"
                },
                "last_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "next_allowed_client_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "items": {
                        "$ref": "#/definitions/RetentionResult"
                    },
                    "type": "array"
                },
                "timezone": {
                    "type": "string"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                }
            },
            "required": [
                "cache_key",
                "is_cached",
                "last_refresh",
                "next_allowed_client_refresh",
                "results",
                "timezone"
            ],
            "type": "object"
        },
        "CachedRevenueAnalyticsGrowthRateQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "cache_key": {
                    "type": "string"
                },
                "cache_target_age": {
                    "format": "date-time",
                    "type": "string"
                },
                "calculation_trigger": {
                    "description": "What triggered the calculation of the query, leave empty if user/immediate",
                    "type": "string"
                },
                "columns": {
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                },
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "is_cached": {
                    "type": "boolean"
                },
                "last_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "next_allowed_client_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {},
                "timezone": {
                    "type": "string"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                }
            },
            "required": [
                "cache_key",
                "is_cached",
                "last_refresh",
                "next_allowed_client_refresh",
                "results",
                "timezone"
            ],
            "type": "object"
        },
        "CachedRevenueAnalyticsOverviewQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "cache_key": {
                    "type": "string"
                },
                "cache_target_age": {
                    "format": "date-time",
                    "type": "string"
                },
                "calculation_trigger": {
                    "description": "What triggered the calculation of the query, leave empty if user/immediate",
                    "type": "string"
                },
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "is_cached": {
                    "type": "boolean"
                },
                "last_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "next_allowed_client_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "items": {
                        "$ref": "#/definitions/RevenueAnalyticsOverviewItem"
                    },
                    "type": "array"
                },
                "timezone": {
                    "type": "string"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                }
            },
            "required": [
                "cache_key",
                "is_cached",
                "last_refresh",
                "next_allowed_client_refresh",
                "results",
                "timezone"
            ],
            "type": "object"
        },
        "CachedRevenueAnalyticsTopCustomersQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "cache_key": {
                    "type": "string"
                },
                "cache_target_age": {
                    "format": "date-time",
                    "type": "string"
                },
                "calculation_trigger": {
                    "description": "What triggered the calculation of the query, leave empty if user/immediate",
                    "type": "string"
                },
                "columns": {
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                },
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "is_cached": {
                    "type": "boolean"
                },
                "last_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "next_allowed_client_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {},
                "timezone": {
                    "type": "string"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                }
            },
            "required": [
                "cache_key",
                "is_cached",
                "last_refresh",
                "next_allowed_client_refresh",
                "results",
                "timezone"
            ],
            "type": "object"
        },
        "CachedRevenueExampleDataWarehouseTablesQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "cache_key": {
                    "type": "string"
                },
                "cache_target_age": {
                    "format": "date-time",
                    "type": "string"
                },
                "calculation_trigger": {
                    "description": "What triggered the calculation of the query, leave empty if user/immediate",
                    "type": "string"
                },
                "columns": {
                    "items": {},
                    "type": "array"
                },
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hasMore": {
                    "type": "boolean"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "is_cached": {
                    "type": "boolean"
                },
                "last_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "limit": {
                    "$ref": "#/definitions/integer"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "next_allowed_client_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "offset": {
                    "$ref": "#/definitions/integer"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {},
                "timezone": {
                    "type": "string"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                },
                "types": {
                    "items": {},
                    "type": "array"
                }
            },
            "required": [
                "cache_key",
                "is_cached",
                "last_refresh",
                "next_allowed_client_refresh",
                "results",
                "timezone"
            ],
            "type": "object"
        },
        "CachedRevenueExampleEventsQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "cache_key": {
                    "type": "string"
                },
                "cache_target_age": {
                    "format": "date-time",
                    "type": "string"
                },
                "calculation_trigger": {
                    "description": "What triggered the calculation of the query, leave empty if user/immediate",
                    "type": "string"
                },
                "columns": {
                    "items": {},
                    "type": "array"
                },
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hasMore": {
                    "type": "boolean"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "is_cached": {
                    "type": "boolean"
                },
                "last_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "limit": {
                    "$ref": "#/definitions/integer"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "next_allowed_client_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "offset": {
                    "$ref": "#/definitions/integer"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {},
                "timezone": {
                    "type": "string"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                },
                "types": {
                    "items": {},
                    "type": "array"
                }
            },
            "required": [
                "cache_key",
                "is_cached",
                "last_refresh",
                "next_allowed_client_refresh",
                "results",
                "timezone"
            ],
            "type": "object"
        },
        "CachedSessionAttributionExplorerQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "cache_key": {
                    "type": "string"
                },
                "cache_target_age": {
                    "format": "date-time",
                    "type": "string"
                },
                "calculation_trigger": {
                    "description": "What triggered the calculation of the query, leave empty if user/immediate",
                    "type": "string"
                },
                "columns": {
                    "items": {},
                    "type": "array"
                },
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hasMore": {
                    "type": "boolean"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "is_cached": {
                    "type": "boolean"
                },
                "last_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "limit": {
                    "$ref": "#/definitions/integer"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "next_allowed_client_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "offset": {
                    "$ref": "#/definitions/integer"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {},
                "timezone": {
                    "type": "string"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                },
                "types": {
                    "items": {},
                    "type": "array"
                }
            },
            "required": [
                "cache_key",
                "is_cached",
                "last_refresh",
                "next_allowed_client_refresh",
                "results",
                "timezone"
            ],
            "type": "object"
        },
        "CachedSessionsTimelineQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "cache_key": {
                    "type": "string"
                },
                "cache_target_age": {
                    "format": "date-time",
                    "type": "string"
                },
                "calculation_trigger": {
                    "description": "What triggered the calculation of the query, leave empty if user/immediate",
                    "type": "string"
                },
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hasMore": {
                    "type": "boolean"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "is_cached": {
                    "type": "boolean"
                },
                "last_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "next_allowed_client_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "items": {
                        "$ref": "#/definitions/TimelineEntry"
                    },
                    "type": "array"
                },
                "timezone": {
                    "type": "string"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                }
            },
            "required": [
                "cache_key",
                "is_cached",
                "last_refresh",
                "next_allowed_client_refresh",
                "results",
                "timezone"
            ],
            "type": "object"
        },
        "CachedStickinessQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "cache_key": {
                    "type": "string"
                },
                "cache_target_age": {
                    "format": "date-time",
                    "type": "string"
                },
                "calculation_trigger": {
                    "description": "What triggered the calculation of the query, leave empty if user/immediate",
                    "type": "string"
                },
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "is_cached": {
                    "type": "boolean"
                },
                "last_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "next_allowed_client_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "items": {
                        "type": "object"
                    },
                    "type": "array"
                },
                "timezone": {
                    "type": "string"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                }
            },
            "required": [
                "cache_key",
                "is_cached",
                "last_refresh",
                "next_allowed_client_refresh",
                "results",
                "timezone"
            ],
            "type": "object"
        },
        "CachedSuggestedQuestionsQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "cache_key": {
                    "type": "string"
                },
                "cache_target_age": {
                    "format": "date-time",
                    "type": "string"
                },
                "calculation_trigger": {
                    "description": "What triggered the calculation of the query, leave empty if user/immediate",
                    "type": "string"
                },
                "is_cached": {
                    "type": "boolean"
                },
                "last_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "next_allowed_client_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "questions": {
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                },
                "timezone": {
                    "type": "string"
                }
            },
            "required": [
                "cache_key",
                "is_cached",
                "last_refresh",
                "next_allowed_client_refresh",
                "questions",
                "timezone"
            ],
            "type": "object"
        },
        "CachedTeamTaxonomyQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "cache_key": {
                    "type": "string"
                },
                "cache_target_age": {
                    "format": "date-time",
                    "type": "string"
                },
                "calculation_trigger": {
                    "description": "What triggered the calculation of the query, leave empty if user/immediate",
                    "type": "string"
                },
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "is_cached": {
                    "type": "boolean"
                },
                "last_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "next_allowed_client_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "$ref": "#/definitions/TeamTaxonomyResponse"
                },
                "timezone": {
                    "type": "string"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                }
            },
            "required": [
                "cache_key",
                "is_cached",
                "last_refresh",
                "next_allowed_client_refresh",
                "results",
                "timezone"
            ],
            "type": "object"
        },
        "CachedTracesQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "cache_key": {
                    "type": "string"
                },
                "cache_target_age": {
                    "format": "date-time",
                    "type": "string"
                },
                "calculation_trigger": {
                    "description": "What triggered the calculation of the query, leave empty if user/immediate",
                    "type": "string"
                },
                "columns": {
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                },
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hasMore": {
                    "type": "boolean"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "is_cached": {
                    "type": "boolean"
                },
                "last_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "limit": {
                    "$ref": "#/definitions/integer"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "next_allowed_client_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "offset": {
                    "$ref": "#/definitions/integer"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "items": {
                        "$ref": "#/definitions/LLMTrace"
                    },
                    "type": "array"
                },
                "timezone": {
                    "type": "string"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                }
            },
            "required": [
                "cache_key",
                "is_cached",
                "last_refresh",
                "next_allowed_client_refresh",
                "results",
                "timezone"
            ],
            "type": "object"
        },
        "CachedTrendsQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "cache_key": {
                    "type": "string"
                },
                "cache_target_age": {
                    "format": "date-time",
                    "type": "string"
                },
                "calculation_trigger": {
                    "description": "What triggered the calculation of the query, leave empty if user/immediate",
                    "type": "string"
                },
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hasMore": {
                    "description": "Wether more breakdown values are available.",
                    "type": "boolean"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "is_cached": {
                    "type": "boolean"
                },
                "last_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "next_allowed_client_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "items": {
                        "type": "object"
                    },
                    "type": "array"
                },
                "timezone": {
                    "type": "string"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                }
            },
            "required": [
                "cache_key",
                "is_cached",
                "last_refresh",
                "next_allowed_client_refresh",
                "results",
                "timezone"
            ],
            "type": "object"
        },
        "CachedVectorSearchQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "cache_key": {
                    "type": "string"
                },
                "cache_target_age": {
                    "format": "date-time",
                    "type": "string"
                },
                "calculation_trigger": {
                    "description": "What triggered the calculation of the query, leave empty if user/immediate",
                    "type": "string"
                },
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "is_cached": {
                    "type": "boolean"
                },
                "last_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "next_allowed_client_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "$ref": "#/definitions/VectorSearchResponse"
                },
                "timezone": {
                    "type": "string"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                }
            },
            "required": [
                "cache_key",
                "is_cached",
                "last_refresh",
                "next_allowed_client_refresh",
                "results",
                "timezone"
            ],
            "type": "object"
        },
        "CachedWebExternalClicksTableQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "cache_key": {
                    "type": "string"
                },
                "cache_target_age": {
                    "format": "date-time",
                    "type": "string"
                },
                "calculation_trigger": {
                    "description": "What triggered the calculation of the query, leave empty if user/immediate",
                    "type": "string"
                },
                "columns": {
                    "items": {},
                    "type": "array"
                },
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hasMore": {
                    "type": "boolean"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "is_cached": {
                    "type": "boolean"
                },
                "last_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "limit": {
                    "$ref": "#/definitions/integer"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "next_allowed_client_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "offset": {
                    "$ref": "#/definitions/integer"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "items": {},
                    "type": "array"
                },
                "samplingRate": {
                    "$ref": "#/definitions/SamplingRate"
                },
                "timezone": {
                    "type": "string"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                },
                "types": {
                    "items": {},
                    "type": "array"
                }
            },
            "required": [
                "cache_key",
                "is_cached",
                "last_refresh",
                "next_allowed_client_refresh",
                "results",
                "timezone"
            ],
            "type": "object"
        },
        "CachedWebGoalsQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "cache_key": {
                    "type": "string"
                },
                "cache_target_age": {
                    "format": "date-time",
                    "type": "string"
                },
                "calculation_trigger": {
                    "description": "What triggered the calculation of the query, leave empty if user/immediate",
                    "type": "string"
                },
                "columns": {
                    "items": {},
                    "type": "array"
                },
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hasMore": {
                    "type": "boolean"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "is_cached": {
                    "type": "boolean"
                },
                "last_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "limit": {
                    "$ref": "#/definitions/integer"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "next_allowed_client_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "offset": {
                    "$ref": "#/definitions/integer"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "items": {},
                    "type": "array"
                },
                "samplingRate": {
                    "$ref": "#/definitions/SamplingRate"
                },
                "timezone": {
                    "type": "string"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                },
                "types": {
                    "items": {},
                    "type": "array"
                }
            },
            "required": [
                "cache_key",
                "is_cached",
                "last_refresh",
                "next_allowed_client_refresh",
                "results",
                "timezone"
            ],
            "type": "object"
        },
        "CachedWebOverviewQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "cache_key": {
                    "type": "string"
                },
                "cache_target_age": {
                    "format": "date-time",
                    "type": "string"
                },
                "calculation_trigger": {
                    "description": "What triggered the calculation of the query, leave empty if user/immediate",
                    "type": "string"
                },
                "dateFrom": {
                    "type": "string"
                },
                "dateTo": {
                    "type": "string"
                },
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "is_cached": {
                    "type": "boolean"
                },
                "last_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "next_allowed_client_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "items": {
                        "$ref": "#/definitions/WebOverviewItem"
                    },
                    "type": "array"
                },
                "samplingRate": {
                    "$ref": "#/definitions/SamplingRate"
                },
                "timezone": {
                    "type": "string"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                }
            },
            "required": [
                "cache_key",
                "is_cached",
                "last_refresh",
                "next_allowed_client_refresh",
                "results",
                "timezone"
            ],
            "type": "object"
        },
        "CachedWebPageURLSearchQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "cache_key": {
                    "type": "string"
                },
                "cache_target_age": {
                    "format": "date-time",
                    "type": "string"
                },
                "calculation_trigger": {
                    "description": "What triggered the calculation of the query, leave empty if user/immediate",
                    "type": "string"
                },
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hasMore": {
                    "type": "boolean"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "is_cached": {
                    "type": "boolean"
                },
                "last_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "limit": {
                    "$ref": "#/definitions/integer"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "next_allowed_client_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "items": {
                        "$ref": "#/definitions/PageURL"
                    },
                    "type": "array"
                },
                "timezone": {
                    "type": "string"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                }
            },
            "required": [
                "cache_key",
                "is_cached",
                "last_refresh",
                "next_allowed_client_refresh",
                "results",
                "timezone"
            ],
            "type": "object"
        },
        "CachedWebStatsTableQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "cache_key": {
                    "type": "string"
                },
                "cache_target_age": {
                    "format": "date-time",
                    "type": "string"
                },
                "calculation_trigger": {
                    "description": "What triggered the calculation of the query, leave empty if user/immediate",
                    "type": "string"
                },
                "columns": {
                    "items": {},
                    "type": "array"
                },
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hasMore": {
                    "type": "boolean"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "is_cached": {
                    "type": "boolean"
                },
                "last_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "limit": {
                    "$ref": "#/definitions/integer"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "next_allowed_client_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "offset": {
                    "$ref": "#/definitions/integer"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "items": {},
                    "type": "array"
                },
                "samplingRate": {
                    "$ref": "#/definitions/SamplingRate"
                },
                "timezone": {
                    "type": "string"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                },
                "types": {
                    "items": {},
                    "type": "array"
                }
            },
            "required": [
                "cache_key",
                "is_cached",
                "last_refresh",
                "next_allowed_client_refresh",
                "results",
                "timezone"
            ],
            "type": "object"
        },
        "CachedWebVitalsPathBreakdownQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "cache_key": {
                    "type": "string"
                },
                "cache_target_age": {
                    "format": "date-time",
                    "type": "string"
                },
                "calculation_trigger": {
                    "description": "What triggered the calculation of the query, leave empty if user/immediate",
                    "type": "string"
                },
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "is_cached": {
                    "type": "boolean"
                },
                "last_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "next_allowed_client_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "items": {
                        "$ref": "#/definitions/WebVitalsPathBreakdownResult"
                    },
                    "maxItems": 1,
                    "minItems": 1,
                    "type": "array"
                },
                "timezone": {
                    "type": "string"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                }
            },
            "required": [
                "cache_key",
                "is_cached",
                "last_refresh",
                "next_allowed_client_refresh",
                "results",
                "timezone"
            ],
            "type": "object"
        },
        "CachedWebVitalsQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "cache_key": {
                    "type": "string"
                },
                "cache_target_age": {
                    "format": "date-time",
                    "type": "string"
                },
                "calculation_trigger": {
                    "description": "What triggered the calculation of the query, leave empty if user/immediate",
                    "type": "string"
                },
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "is_cached": {
                    "type": "boolean"
                },
                "last_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "next_allowed_client_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "items": {
                        "$ref": "#/definitions/WebVitalsItem"
                    },
                    "type": "array"
                },
                "timezone": {
                    "type": "string"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                }
            },
            "required": [
                "cache_key",
                "is_cached",
                "last_refresh",
                "next_allowed_client_refresh",
                "results",
                "timezone"
            ],
            "type": "object"
        },
        "ChartAxis": {
            "additionalProperties": false,
            "properties": {
                "column": {
                    "type": "string"
                },
                "settings": {
                    "additionalProperties": false,
                    "properties": {
                        "display": {
                            "$ref": "#/definitions/ChartSettingsDisplay"
                        },
                        "formatting": {
                            "$ref": "#/definitions/ChartSettingsFormatting"
                        }
                    },
                    "type": "object"
                }
            },
            "required": ["column"],
            "type": "object"
        },
        "ChartDisplayCategory": {
            "enum": ["TimeSeries", "CumulativeTimeSeries", "TotalValue"],
            "type": "string"
        },
        "ChartDisplayType": {
            "enum": [
                "ActionsLineGraph",
                "ActionsBar",
                "ActionsStackedBar",
                "ActionsAreaGraph",
                "ActionsLineGraphCumulative",
                "BoldNumber",
                "ActionsPie",
                "ActionsBarValue",
                "ActionsTable",
                "WorldMap"
            ],
            "type": "string"
        },
        "ChartSettings": {
            "additionalProperties": false,
            "properties": {
                "goalLines": {
                    "items": {
                        "$ref": "#/definitions/GoalLine"
                    },
                    "type": "array"
                },
                "leftYAxisSettings": {
                    "$ref": "#/definitions/YAxisSettings"
                },
                "rightYAxisSettings": {
                    "$ref": "#/definitions/YAxisSettings"
                },
                "seriesBreakdownColumn": {
                    "type": ["string", "null"]
                },
                "showLegend": {
                    "type": "boolean"
                },
                "stackBars100": {
                    "description": "Whether we fill the bars to 100% in stacked mode",
                    "type": "boolean"
                },
                "xAxis": {
                    "$ref": "#/definitions/ChartAxis"
                },
                "yAxis": {
                    "items": {
                        "$ref": "#/definitions/ChartAxis"
                    },
                    "type": "array"
                },
                "yAxisAtZero": {
                    "description": "Deprecated: use `[left|right]YAxisSettings`. Whether the Y axis should start at zero",
                    "type": "boolean"
                }
            },
            "type": "object"
        },
        "ChartSettingsDisplay": {
            "additionalProperties": false,
            "properties": {
                "color": {
                    "type": "string"
                },
                "displayType": {
                    "enum": ["auto", "line", "bar"],
                    "type": "string"
                },
                "label": {
                    "type": "string"
                },
                "trendLine": {
                    "type": "boolean"
                },
                "yAxisPosition": {
                    "enum": ["left", "right"],
                    "type": "string"
                }
            },
            "type": "object"
        },
        "ChartSettingsFormatting": {
            "additionalProperties": false,
            "properties": {
                "decimalPlaces": {
                    "type": "number"
                },
                "prefix": {
                    "type": "string"
                },
                "style": {
                    "enum": ["none", "number", "percent"],
                    "type": "string"
                },
                "suffix": {
                    "type": "string"
                }
            },
            "type": "object"
        },
        "ClickhouseQueryProgress": {
            "additionalProperties": false,
            "properties": {
                "active_cpu_time": {
                    "$ref": "#/definitions/integer"
                },
                "bytes_read": {
                    "$ref": "#/definitions/integer"
                },
                "estimated_rows_total": {
                    "$ref": "#/definitions/integer"
                },
                "rows_read": {
                    "$ref": "#/definitions/integer"
                },
                "time_elapsed": {
                    "$ref": "#/definitions/integer"
                }
            },
            "required": ["bytes_read", "rows_read", "estimated_rows_total", "time_elapsed", "active_cpu_time"],
            "type": "object"
        },
        "CohortPropertyFilter": {
            "additionalProperties": false,
            "description": "Sync with plugin-server/src/types.ts",
            "properties": {
                "cohort_name": {
                    "type": "string"
                },
                "key": {
                    "const": "id",
                    "type": "string"
                },
                "label": {
                    "type": "string"
                },
                "operator": {
                    "$ref": "#/definitions/PropertyOperator",
                    "default": "in"
                },
                "type": {
                    "const": "cohort",
                    "type": "string"
                },
                "value": {
                    "type": "integer"
                }
            },
            "required": ["key", "operator", "type", "value"],
            "type": "object"
        },
        "CompareFilter": {
            "additionalProperties": false,
            "properties": {
                "compare": {
                    "default": false,
                    "description": "Whether to compare the current date range to a previous date range.",
                    "type": "boolean"
                },
                "compare_to": {
                    "description": "The date range to compare to. The value is a relative date. Examples of relative dates are: `-1y` for 1 year ago, `-14m` for 14 months ago, `-100w` for 100 weeks ago, `-14d` for 14 days ago, `-30h` for 30 hours ago.",
                    "type": "string"
                }
            },
            "type": "object"
        },
        "ConditionalFormattingRule": {
            "additionalProperties": false,
            "properties": {
                "bytecode": {
                    "items": {},
                    "type": "array"
                },
                "color": {
                    "type": "string"
                },
                "colorMode": {
                    "enum": ["light", "dark"],
                    "type": "string"
                },
                "columnName": {
                    "type": "string"
                },
                "id": {
                    "type": "string"
                },
                "input": {
                    "type": "string"
                },
                "templateId": {
                    "type": "string"
                }
            },
            "required": ["id", "templateId", "columnName", "bytecode", "input", "color"],
            "type": "object"
        },
        "CountPerActorMathType": {
            "enum": [
                "avg_count_per_actor",
                "min_count_per_actor",
                "max_count_per_actor",
                "median_count_per_actor",
                "p75_count_per_actor",
                "p90_count_per_actor",
                "p95_count_per_actor",
                "p99_count_per_actor"
            ],
            "type": "string"
        },
        "CurrencyCode": {
            "enum": [
                "AED",
                "AFN",
                "ALL",
                "AMD",
                "ANG",
                "AOA",
                "ARS",
                "AUD",
                "AWG",
                "AZN",
                "BAM",
                "BBD",
                "BDT",
                "BGN",
                "BHD",
                "BIF",
                "BMD",
                "BND",
                "BOB",
                "BRL",
                "BSD",
                "BTC",
                "BTN",
                "BWP",
                "BYN",
                "BZD",
                "CAD",
                "CDF",
                "CHF",
                "CLP",
                "CNY",
                "COP",
                "CRC",
                "CVE",
                "CZK",
                "DJF",
                "DKK",
                "DOP",
                "DZD",
                "EGP",
                "ERN",
                "ETB",
                "EUR",
                "FJD",
                "GBP",
                "GEL",
                "GHS",
                "GIP",
                "GMD",
                "GNF",
                "GTQ",
                "GYD",
                "HKD",
                "HNL",
                "HRK",
                "HTG",
                "HUF",
                "IDR",
                "ILS",
                "INR",
                "IQD",
                "IRR",
                "ISK",
                "JMD",
                "JOD",
                "JPY",
                "KES",
                "KGS",
                "KHR",
                "KMF",
                "KRW",
                "KWD",
                "KYD",
                "KZT",
                "LAK",
                "LBP",
                "LKR",
                "LRD",
                "LTL",
                "LVL",
                "LSL",
                "LYD",
                "MAD",
                "MDL",
                "MGA",
                "MKD",
                "MMK",
                "MNT",
                "MOP",
                "MRU",
                "MTL",
                "MUR",
                "MVR",
                "MWK",
                "MXN",
                "MYR",
                "MZN",
                "NAD",
                "NGN",
                "NIO",
                "NOK",
                "NPR",
                "NZD",
                "OMR",
                "PAB",
                "PEN",
                "PGK",
                "PHP",
                "PKR",
                "PLN",
                "PYG",
                "QAR",
                "RON",
                "RSD",
                "RUB",
                "RWF",
                "SAR",
                "SBD",
                "SCR",
                "SDG",
                "SEK",
                "SGD",
                "SRD",
                "SSP",
                "STN",
                "SYP",
                "SZL",
                "THB",
                "TJS",
                "TMT",
                "TND",
                "TOP",
                "TRY",
                "TTD",
                "TWD",
                "TZS",
                "UAH",
                "UGX",
                "USD",
                "UYU",
                "UZS",
                "VES",
                "VND",
                "VUV",
                "WST",
                "XAF",
                "XCD",
                "XOF",
                "XPF",
                "YER",
                "ZAR",
                "ZMW"
            ],
            "type": "string"
        },
        "CustomChannelCondition": {
            "additionalProperties": false,
            "properties": {
                "id": {
                    "type": "string"
                },
                "key": {
                    "$ref": "#/definitions/CustomChannelField"
                },
                "op": {
                    "$ref": "#/definitions/CustomChannelOperator"
                },
                "value": {
                    "anyOf": [
                        {
                            "type": "string"
                        },
                        {
                            "items": {
                                "type": "string"
                            },
                            "type": "array"
                        }
                    ]
                }
            },
            "required": ["key", "op", "id"],
            "type": "object"
        },
        "CustomChannelField": {
            "enum": ["utm_source", "utm_medium", "utm_campaign", "referring_domain", "url", "pathname", "hostname"],
            "type": "string"
        },
        "CustomChannelOperator": {
            "enum": ["exact", "is_not", "is_set", "is_not_set", "icontains", "not_icontains", "regex", "not_regex"],
            "type": "string"
        },
        "CustomChannelRule": {
            "additionalProperties": false,
            "properties": {
                "channel_type": {
                    "type": "string"
                },
                "combiner": {
                    "$ref": "#/definitions/FilterLogicalOperator"
                },
                "id": {
                    "type": "string"
                },
                "items": {
                    "items": {
                        "$ref": "#/definitions/CustomChannelCondition"
                    },
                    "type": "array"
                }
            },
            "required": ["items", "combiner", "channel_type", "id"],
            "type": "object"
        },
        "CustomEventConversionGoal": {
            "additionalProperties": false,
            "properties": {
                "customEventName": {
                    "type": "string"
                }
            },
            "required": ["customEventName"],
            "type": "object"
        },
        "DashboardFilter": {
            "additionalProperties": false,
            "properties": {
                "breakdown_filter": {
                    "anyOf": [
                        {
                            "$ref": "#/definitions/BreakdownFilter"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "date_from": {
                    "type": ["string", "null"]
                },
                "date_to": {
                    "type": ["string", "null"]
                },
                "properties": {
                    "anyOf": [
                        {
                            "items": {
                                "$ref": "#/definitions/AnyPropertyFilter"
                            },
                            "type": "array"
                        },
                        {
                            "type": "null"
                        }
                    ]
                }
            },
            "type": "object"
        },
        "DataColorToken": {
            "enum": [
                "preset-1",
                "preset-2",
                "preset-3",
                "preset-4",
                "preset-5",
                "preset-6",
                "preset-7",
                "preset-8",
                "preset-9",
                "preset-10",
                "preset-11",
                "preset-12",
                "preset-13",
                "preset-14",
                "preset-15"
            ],
            "type": "string"
        },
        "DataTableNode": {
            "additionalProperties": false,
            "properties": {
                "allowSorting": {
                    "description": "Can the user click on column headers to sort the table? (default: true)",
                    "type": "boolean"
                },
                "columns": {
                    "description": "Columns shown in the table, unless the `source` provides them.",
                    "items": {
                        "$ref": "#/definitions/HogQLExpression"
                    },
                    "type": "array"
                },
                "context": {
                    "additionalProperties": false,
                    "description": "Context for the table, used by components like ColumnConfigurator",
                    "properties": {
                        "eventDefinitionId": {
                            "type": "string"
                        },
                        "type": {
                            "enum": ["event_definition", "team_columns"],
                            "type": "string"
                        }
                    },
                    "required": ["type"],
                    "type": "object"
                },
                "embedded": {
                    "description": "Uses the embedded version of LemonTable",
                    "type": "boolean"
                },
                "expandable": {
                    "description": "Can expand row to show raw event data (default: true)",
                    "type": "boolean"
                },
                "full": {
                    "description": "Show with most visual options enabled. Used in scenes.",
                    "type": "boolean"
                },
                "hiddenColumns": {
                    "description": "Columns that aren't shown in the table, even if in columns or returned data",
                    "items": {
                        "$ref": "#/definitions/HogQLExpression"
                    },
                    "type": "array"
                },
                "kind": {
                    "const": "DataTableNode",
                    "type": "string"
                },
                "propertiesViaUrl": {
                    "description": "Link properties via the URL (default: false)",
                    "type": "boolean"
                },
                "response": {
                    "anyOf": [
                        {
                            "properties": {},
                            "type": "object"
                        },
                        {
                            "additionalProperties": false,
                            "properties": {
                                "columns": {
                                    "items": {},
                                    "type": "array"
                                },
                                "error": {
                                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                                    "type": "string"
                                },
                                "hasMore": {
                                    "type": "boolean"
                                },
                                "hogql": {
                                    "description": "Generated HogQL query.",
                                    "type": "string"
                                },
                                "limit": {
                                    "$ref": "#/definitions/integer"
                                },
                                "modifiers": {
                                    "$ref": "#/definitions/HogQLQueryModifiers",
                                    "description": "Modifiers used when performing the query"
                                },
                                "offset": {
                                    "$ref": "#/definitions/integer"
                                },
                                "query_status": {
                                    "$ref": "#/definitions/QueryStatus",
                                    "description": "Query status indicates whether next to the provided data, a query is still running."
                                },
                                "results": {
                                    "items": {
                                        "items": {},
                                        "type": "array"
                                    },
                                    "type": "array"
                                },
                                "timings": {
                                    "description": "Measured timings for different parts of the query generation process",
                                    "items": {
                                        "$ref": "#/definitions/QueryTiming"
                                    },
                                    "type": "array"
                                },
                                "types": {
                                    "items": {
                                        "type": "string"
                                    },
                                    "type": "array"
                                }
                            },
                            "required": ["columns", "hogql", "results", "types"],
                            "type": "object"
                        },
                        {
                            "additionalProperties": false,
                            "properties": {
                                "columns": {
                                    "items": {},
                                    "type": "array"
                                },
                                "error": {
                                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                                    "type": "string"
                                },
                                "hasMore": {
                                    "type": "boolean"
                                },
                                "hogql": {
                                    "description": "Generated HogQL query.",
                                    "type": "string"
                                },
                                "limit": {
                                    "$ref": "#/definitions/integer"
                                },
                                "missing_actors_count": {
                                    "$ref": "#/definitions/integer"
                                },
                                "modifiers": {
                                    "$ref": "#/definitions/HogQLQueryModifiers",
                                    "description": "Modifiers used when performing the query"
                                },
                                "offset": {
                                    "$ref": "#/definitions/integer"
                                },
                                "query_status": {
                                    "$ref": "#/definitions/QueryStatus",
                                    "description": "Query status indicates whether next to the provided data, a query is still running."
                                },
                                "results": {
                                    "items": {
                                        "items": {},
                                        "type": "array"
                                    },
                                    "type": "array"
                                },
                                "timings": {
                                    "description": "Measured timings for different parts of the query generation process",
                                    "items": {
                                        "$ref": "#/definitions/QueryTiming"
                                    },
                                    "type": "array"
                                },
                                "types": {
                                    "items": {
                                        "type": "string"
                                    },
                                    "type": "array"
                                }
                            },
                            "required": ["columns", "hogql", "limit", "offset", "results", "types"],
                            "type": "object"
                        },
                        {
                            "additionalProperties": false,
                            "properties": {
                                "columns": {
                                    "items": {},
                                    "type": "array"
                                },
                                "error": {
                                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                                    "type": "string"
                                },
                                "hasMore": {
                                    "type": "boolean"
                                },
                                "hogql": {
                                    "description": "Generated HogQL query.",
                                    "type": "string"
                                },
                                "kind": {
                                    "const": "GroupsQuery",
                                    "type": "string"
                                },
                                "limit": {
                                    "$ref": "#/definitions/integer"
                                },
                                "modifiers": {
                                    "$ref": "#/definitions/HogQLQueryModifiers",
                                    "description": "Modifiers used when performing the query"
                                },
                                "offset": {
                                    "$ref": "#/definitions/integer"
                                },
                                "query_status": {
                                    "$ref": "#/definitions/QueryStatus",
                                    "description": "Query status indicates whether next to the provided data, a query is still running."
                                },
                                "results": {
                                    "items": {
                                        "items": {},
                                        "type": "array"
                                    },
                                    "type": "array"
                                },
                                "timings": {
                                    "description": "Measured timings for different parts of the query generation process",
                                    "items": {
                                        "$ref": "#/definitions/QueryTiming"
                                    },
                                    "type": "array"
                                },
                                "types": {
                                    "items": {
                                        "type": "string"
                                    },
                                    "type": "array"
                                }
                            },
                            "required": ["columns", "hogql", "kind", "limit", "offset", "results", "types"],
                            "type": "object"
                        },
                        {
                            "additionalProperties": false,
                            "properties": {
                                "clickhouse": {
                                    "description": "Executed ClickHouse query",
                                    "type": "string"
                                },
                                "columns": {
                                    "description": "Returned columns",
                                    "items": {},
                                    "type": "array"
                                },
                                "error": {
                                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                                    "type": "string"
                                },
                                "explain": {
                                    "description": "Query explanation output",
                                    "items": {
                                        "type": "string"
                                    },
                                    "type": "array"
                                },
                                "hasMore": {
                                    "type": "boolean"
                                },
                                "hogql": {
                                    "description": "Generated HogQL query.",
                                    "type": "string"
                                },
                                "limit": {
                                    "$ref": "#/definitions/integer"
                                },
                                "metadata": {
                                    "$ref": "#/definitions/HogQLMetadataResponse",
                                    "description": "Query metadata output"
                                },
                                "modifiers": {
                                    "$ref": "#/definitions/HogQLQueryModifiers",
                                    "description": "Modifiers used when performing the query"
                                },
                                "offset": {
                                    "$ref": "#/definitions/integer"
                                },
                                "query": {
                                    "description": "Input query string",
                                    "type": "string"
                                },
                                "query_status": {
                                    "$ref": "#/definitions/QueryStatus",
                                    "description": "Query status indicates whether next to the provided data, a query is still running."
                                },
                                "results": {
                                    "items": {},
                                    "type": "array"
                                },
                                "timings": {
                                    "description": "Measured timings for different parts of the query generation process",
                                    "items": {
                                        "$ref": "#/definitions/QueryTiming"
                                    },
                                    "type": "array"
                                },
                                "types": {
                                    "description": "Types of returned columns",
                                    "items": {},
                                    "type": "array"
                                }
                            },
                            "required": ["results"],
                            "type": "object"
                        },
                        {
                            "additionalProperties": false,
                            "properties": {
                                "dateFrom": {
                                    "type": "string"
                                },
                                "dateTo": {
                                    "type": "string"
                                },
                                "error": {
                                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                                    "type": "string"
                                },
                                "hogql": {
                                    "description": "Generated HogQL query.",
                                    "type": "string"
                                },
                                "modifiers": {
                                    "$ref": "#/definitions/HogQLQueryModifiers",
                                    "description": "Modifiers used when performing the query"
                                },
                                "query_status": {
                                    "$ref": "#/definitions/QueryStatus",
                                    "description": "Query status indicates whether next to the provided data, a query is still running."
                                },
                                "results": {
                                    "items": {
                                        "$ref": "#/definitions/WebOverviewItem"
                                    },
                                    "type": "array"
                                },
                                "samplingRate": {
                                    "$ref": "#/definitions/SamplingRate"
                                },
                                "timings": {
                                    "description": "Measured timings for different parts of the query generation process",
                                    "items": {
                                        "$ref": "#/definitions/QueryTiming"
                                    },
                                    "type": "array"
                                }
                            },
                            "required": ["results"],
                            "type": "object"
                        },
                        {
                            "additionalProperties": false,
                            "properties": {
                                "columns": {
                                    "items": {},
                                    "type": "array"
                                },
                                "error": {
                                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                                    "type": "string"
                                },
                                "hasMore": {
                                    "type": "boolean"
                                },
                                "hogql": {
                                    "description": "Generated HogQL query.",
                                    "type": "string"
                                },
                                "limit": {
                                    "$ref": "#/definitions/integer"
                                },
                                "modifiers": {
                                    "$ref": "#/definitions/HogQLQueryModifiers",
                                    "description": "Modifiers used when performing the query"
                                },
                                "offset": {
                                    "$ref": "#/definitions/integer"
                                },
                                "query_status": {
                                    "$ref": "#/definitions/QueryStatus",
                                    "description": "Query status indicates whether next to the provided data, a query is still running."
                                },
                                "results": {
                                    "items": {},
                                    "type": "array"
                                },
                                "samplingRate": {
                                    "$ref": "#/definitions/SamplingRate"
                                },
                                "timings": {
                                    "description": "Measured timings for different parts of the query generation process",
                                    "items": {
                                        "$ref": "#/definitions/QueryTiming"
                                    },
                                    "type": "array"
                                },
                                "types": {
                                    "items": {},
                                    "type": "array"
                                }
                            },
                            "required": ["results"],
                            "type": "object"
                        },
                        {
                            "additionalProperties": false,
                            "properties": {
                                "columns": {
                                    "items": {},
                                    "type": "array"
                                },
                                "error": {
                                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                                    "type": "string"
                                },
                                "hasMore": {
                                    "type": "boolean"
                                },
                                "hogql": {
                                    "description": "Generated HogQL query.",
                                    "type": "string"
                                },
                                "limit": {
                                    "$ref": "#/definitions/integer"
                                },
                                "modifiers": {
                                    "$ref": "#/definitions/HogQLQueryModifiers",
                                    "description": "Modifiers used when performing the query"
                                },
                                "offset": {
                                    "$ref": "#/definitions/integer"
                                },
                                "query_status": {
                                    "$ref": "#/definitions/QueryStatus",
                                    "description": "Query status indicates whether next to the provided data, a query is still running."
                                },
                                "results": {
                                    "items": {},
                                    "type": "array"
                                },
                                "samplingRate": {
                                    "$ref": "#/definitions/SamplingRate"
                                },
                                "timings": {
                                    "description": "Measured timings for different parts of the query generation process",
                                    "items": {
                                        "$ref": "#/definitions/QueryTiming"
                                    },
                                    "type": "array"
                                },
                                "types": {
                                    "items": {},
                                    "type": "array"
                                }
                            },
                            "required": ["results"],
                            "type": "object"
                        },
                        {
                            "additionalProperties": false,
                            "properties": {
                                "columns": {
                                    "items": {},
                                    "type": "array"
                                },
                                "error": {
                                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                                    "type": "string"
                                },
                                "hasMore": {
                                    "type": "boolean"
                                },
                                "hogql": {
                                    "description": "Generated HogQL query.",
                                    "type": "string"
                                },
                                "limit": {
                                    "$ref": "#/definitions/integer"
                                },
                                "modifiers": {
                                    "$ref": "#/definitions/HogQLQueryModifiers",
                                    "description": "Modifiers used when performing the query"
                                },
                                "offset": {
                                    "$ref": "#/definitions/integer"
                                },
                                "query_status": {
                                    "$ref": "#/definitions/QueryStatus",
                                    "description": "Query status indicates whether next to the provided data, a query is still running."
                                },
                                "results": {
                                    "items": {},
                                    "type": "array"
                                },
                                "samplingRate": {
                                    "$ref": "#/definitions/SamplingRate"
                                },
                                "timings": {
                                    "description": "Measured timings for different parts of the query generation process",
                                    "items": {
                                        "$ref": "#/definitions/QueryTiming"
                                    },
                                    "type": "array"
                                },
                                "types": {
                                    "items": {},
                                    "type": "array"
                                }
                            },
                            "required": ["results"],
                            "type": "object"
                        },
                        {
                            "additionalProperties": false,
                            "properties": {
                                "error": {
                                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                                    "type": "string"
                                },
                                "hogql": {
                                    "description": "Generated HogQL query.",
                                    "type": "string"
                                },
                                "modifiers": {
                                    "$ref": "#/definitions/HogQLQueryModifiers",
                                    "description": "Modifiers used when performing the query"
                                },
                                "query_status": {
                                    "$ref": "#/definitions/QueryStatus",
                                    "description": "Query status indicates whether next to the provided data, a query is still running."
                                },
                                "results": {
                                    "items": {
                                        "$ref": "#/definitions/WebVitalsPathBreakdownResult"
                                    },
                                    "maxItems": 1,
                                    "minItems": 1,
                                    "type": "array"
                                },
                                "timings": {
                                    "description": "Measured timings for different parts of the query generation process",
                                    "items": {
                                        "$ref": "#/definitions/QueryTiming"
                                    },
                                    "type": "array"
                                }
                            },
                            "required": ["results"],
                            "type": "object"
                        },
                        {
                            "additionalProperties": false,
                            "properties": {
                                "error": {
                                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                                    "type": "string"
                                },
                                "hasMore": {
                                    "type": "boolean"
                                },
                                "hogql": {
                                    "description": "Generated HogQL query.",
                                    "type": "string"
                                },
                                "limit": {
                                    "$ref": "#/definitions/integer"
                                },
                                "modifiers": {
                                    "$ref": "#/definitions/HogQLQueryModifiers",
                                    "description": "Modifiers used when performing the query"
                                },
                                "query_status": {
                                    "$ref": "#/definitions/QueryStatus",
                                    "description": "Query status indicates whether next to the provided data, a query is still running."
                                },
                                "results": {
                                    "$ref": "#/definitions/EventsHeatMapStructuredResult"
                                },
                                "timings": {
                                    "description": "Measured timings for different parts of the query generation process",
                                    "items": {
                                        "$ref": "#/definitions/QueryTiming"
                                    },
                                    "type": "array"
                                }
                            },
                            "required": ["results"],
                            "type": "object"
                        },
                        {
                            "additionalProperties": false,
                            "properties": {
                                "columns": {
                                    "items": {},
                                    "type": "array"
                                },
                                "error": {
                                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                                    "type": "string"
                                },
                                "hasMore": {
                                    "type": "boolean"
                                },
                                "hogql": {
                                    "description": "Generated HogQL query.",
                                    "type": "string"
                                },
                                "limit": {
                                    "$ref": "#/definitions/integer"
                                },
                                "modifiers": {
                                    "$ref": "#/definitions/HogQLQueryModifiers",
                                    "description": "Modifiers used when performing the query"
                                },
                                "offset": {
                                    "$ref": "#/definitions/integer"
                                },
                                "query_status": {
                                    "$ref": "#/definitions/QueryStatus",
                                    "description": "Query status indicates whether next to the provided data, a query is still running."
                                },
                                "results": {},
                                "timings": {
                                    "description": "Measured timings for different parts of the query generation process",
                                    "items": {
                                        "$ref": "#/definitions/QueryTiming"
                                    },
                                    "type": "array"
                                },
                                "types": {
                                    "items": {},
                                    "type": "array"
                                }
                            },
                            "required": ["results"],
                            "type": "object"
                        },
                        {
                            "additionalProperties": false,
                            "properties": {
                                "error": {
                                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                                    "type": "string"
                                },
                                "hogql": {
                                    "description": "Generated HogQL query.",
                                    "type": "string"
                                },
                                "modifiers": {
                                    "$ref": "#/definitions/HogQLQueryModifiers",
                                    "description": "Modifiers used when performing the query"
                                },
                                "query_status": {
                                    "$ref": "#/definitions/QueryStatus",
                                    "description": "Query status indicates whether next to the provided data, a query is still running."
                                },
                                "results": {
                                    "items": {
                                        "$ref": "#/definitions/RevenueAnalyticsOverviewItem"
                                    },
                                    "type": "array"
                                },
                                "timings": {
                                    "description": "Measured timings for different parts of the query generation process",
                                    "items": {
                                        "$ref": "#/definitions/QueryTiming"
                                    },
                                    "type": "array"
                                }
                            },
                            "required": ["results"],
                            "type": "object"
                        },
                        {
                            "additionalProperties": false,
                            "properties": {
                                "columns": {
                                    "items": {
                                        "type": "string"
                                    },
                                    "type": "array"
                                },
                                "error": {
                                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                                    "type": "string"
                                },
                                "hogql": {
                                    "description": "Generated HogQL query.",
                                    "type": "string"
                                },
                                "modifiers": {
                                    "$ref": "#/definitions/HogQLQueryModifiers",
                                    "description": "Modifiers used when performing the query"
                                },
                                "query_status": {
                                    "$ref": "#/definitions/QueryStatus",
                                    "description": "Query status indicates whether next to the provided data, a query is still running."
                                },
                                "results": {},
                                "timings": {
                                    "description": "Measured timings for different parts of the query generation process",
                                    "items": {
                                        "$ref": "#/definitions/QueryTiming"
                                    },
                                    "type": "array"
                                }
                            },
                            "required": ["results"],
                            "type": "object"
                        },
                        {
                            "additionalProperties": false,
                            "properties": {
                                "columns": {
                                    "items": {
                                        "type": "string"
                                    },
                                    "type": "array"
                                },
                                "error": {
                                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                                    "type": "string"
                                },
                                "hogql": {
                                    "description": "Generated HogQL query.",
                                    "type": "string"
                                },
                                "modifiers": {
                                    "$ref": "#/definitions/HogQLQueryModifiers",
                                    "description": "Modifiers used when performing the query"
                                },
                                "query_status": {
                                    "$ref": "#/definitions/QueryStatus",
                                    "description": "Query status indicates whether next to the provided data, a query is still running."
                                },
                                "results": {},
                                "timings": {
                                    "description": "Measured timings for different parts of the query generation process",
                                    "items": {
                                        "$ref": "#/definitions/QueryTiming"
                                    },
                                    "type": "array"
                                }
                            },
                            "required": ["results"],
                            "type": "object"
                        },
                        {
                            "additionalProperties": false,
                            "properties": {
                                "columns": {
                                    "items": {},
                                    "type": "array"
                                },
                                "error": {
                                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                                    "type": "string"
                                },
                                "hasMore": {
                                    "type": "boolean"
                                },
                                "hogql": {
                                    "description": "Generated HogQL query.",
                                    "type": "string"
                                },
                                "limit": {
                                    "$ref": "#/definitions/integer"
                                },
                                "modifiers": {
                                    "$ref": "#/definitions/HogQLQueryModifiers",
                                    "description": "Modifiers used when performing the query"
                                },
                                "offset": {
                                    "$ref": "#/definitions/integer"
                                },
                                "query_status": {
                                    "$ref": "#/definitions/QueryStatus",
                                    "description": "Query status indicates whether next to the provided data, a query is still running."
                                },
                                "results": {},
                                "timings": {
                                    "description": "Measured timings for different parts of the query generation process",
                                    "items": {
                                        "$ref": "#/definitions/QueryTiming"
                                    },
                                    "type": "array"
                                },
                                "types": {
                                    "items": {},
                                    "type": "array"
                                }
                            },
                            "required": ["results"],
                            "type": "object"
                        },
                        {
                            "additionalProperties": false,
                            "properties": {
                                "columns": {
                                    "items": {},
                                    "type": "array"
                                },
                                "error": {
                                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                                    "type": "string"
                                },
                                "hasMore": {
                                    "type": "boolean"
                                },
                                "hogql": {
                                    "description": "Generated HogQL query.",
                                    "type": "string"
                                },
                                "limit": {
                                    "$ref": "#/definitions/integer"
                                },
                                "modifiers": {
                                    "$ref": "#/definitions/HogQLQueryModifiers",
                                    "description": "Modifiers used when performing the query"
                                },
                                "offset": {
                                    "$ref": "#/definitions/integer"
                                },
                                "query_status": {
                                    "$ref": "#/definitions/QueryStatus",
                                    "description": "Query status indicates whether next to the provided data, a query is still running."
                                },
                                "results": {},
                                "timings": {
                                    "description": "Measured timings for different parts of the query generation process",
                                    "items": {
                                        "$ref": "#/definitions/QueryTiming"
                                    },
                                    "type": "array"
                                },
                                "types": {
                                    "items": {},
                                    "type": "array"
                                }
                            },
                            "required": ["results"],
                            "type": "object"
                        },
                        {
                            "additionalProperties": false,
                            "properties": {
                                "columns": {
                                    "items": {
                                        "type": "string"
                                    },
                                    "type": "array"
                                },
                                "error": {
                                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                                    "type": "string"
                                },
                                "hasMore": {
                                    "type": "boolean"
                                },
                                "hogql": {
                                    "description": "Generated HogQL query.",
                                    "type": "string"
                                },
                                "limit": {
                                    "$ref": "#/definitions/integer"
                                },
                                "modifiers": {
                                    "$ref": "#/definitions/HogQLQueryModifiers",
                                    "description": "Modifiers used when performing the query"
                                },
                                "offset": {
                                    "$ref": "#/definitions/integer"
                                },
                                "query_status": {
                                    "$ref": "#/definitions/QueryStatus",
                                    "description": "Query status indicates whether next to the provided data, a query is still running."
                                },
                                "results": {
                                    "items": {
                                        "$ref": "#/definitions/ErrorTrackingIssue"
                                    },
                                    "type": "array"
                                },
                                "timings": {
                                    "description": "Measured timings for different parts of the query generation process",
                                    "items": {
                                        "$ref": "#/definitions/QueryTiming"
                                    },
                                    "type": "array"
                                }
                            },
                            "required": ["results"],
                            "type": "object"
                        },
                        {
                            "additionalProperties": false,
                            "properties": {
                                "credible_intervals": {
                                    "additionalProperties": {
                                        "items": {
                                            "type": "number"
                                        },
                                        "maxItems": 2,
                                        "minItems": 2,
                                        "type": "array"
                                    },
                                    "type": "object"
                                },
                                "expected_loss": {
                                    "type": "number"
                                },
                                "funnels_query": {
                                    "$ref": "#/definitions/FunnelsQuery"
                                },
                                "insight": {
                                    "items": {
                                        "items": {
                                            "type": "object"
                                        },
                                        "type": "array"
                                    },
                                    "type": "array"
                                },
                                "kind": {
                                    "const": "ExperimentFunnelsQuery",
                                    "type": "string"
                                },
                                "probability": {
                                    "additionalProperties": {
                                        "type": "number"
                                    },
                                    "type": "object"
                                },
                                "significance_code": {
                                    "$ref": "#/definitions/ExperimentSignificanceCode"
                                },
                                "significant": {
                                    "type": "boolean"
                                },
                                "stats_version": {
                                    "$ref": "#/definitions/integer"
                                },
                                "variants": {
                                    "items": {
                                        "$ref": "#/definitions/ExperimentVariantFunnelsBaseStats"
                                    },
                                    "type": "array"
                                }
                            },
                            "required": [
                                "credible_intervals",
                                "expected_loss",
                                "insight",
                                "kind",
                                "probability",
                                "significance_code",
                                "significant",
                                "variants"
                            ],
                            "type": "object"
                        },
                        {
                            "additionalProperties": false,
                            "properties": {
                                "count_query": {
                                    "$ref": "#/definitions/TrendsQuery"
                                },
                                "credible_intervals": {
                                    "additionalProperties": {
                                        "items": {
                                            "type": "number"
                                        },
                                        "maxItems": 2,
                                        "minItems": 2,
                                        "type": "array"
                                    },
                                    "type": "object"
                                },
                                "exposure_query": {
                                    "$ref": "#/definitions/TrendsQuery"
                                },
                                "insight": {
                                    "items": {
                                        "type": "object"
                                    },
                                    "type": "array"
                                },
                                "kind": {
                                    "const": "ExperimentTrendsQuery",
                                    "type": "string"
                                },
                                "p_value": {
                                    "type": "number"
                                },
                                "probability": {
                                    "additionalProperties": {
                                        "type": "number"
                                    },
                                    "type": "object"
                                },
                                "significance_code": {
                                    "$ref": "#/definitions/ExperimentSignificanceCode"
                                },
                                "significant": {
                                    "type": "boolean"
                                },
                                "stats_version": {
                                    "$ref": "#/definitions/integer"
                                },
                                "variants": {
                                    "items": {
                                        "$ref": "#/definitions/ExperimentVariantTrendsBaseStats"
                                    },
                                    "type": "array"
                                }
                            },
                            "required": [
                                "credible_intervals",
                                "insight",
                                "kind",
                                "p_value",
                                "probability",
                                "significance_code",
                                "significant",
                                "variants"
                            ],
                            "type": "object"
                        },
                        {
                            "additionalProperties": false,
                            "properties": {
                                "columns": {
                                    "items": {
                                        "type": "string"
                                    },
                                    "type": "array"
                                },
                                "error": {
                                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                                    "type": "string"
                                },
                                "hasMore": {
                                    "type": "boolean"
                                },
                                "hogql": {
                                    "description": "Generated HogQL query.",
                                    "type": "string"
                                },
                                "limit": {
                                    "$ref": "#/definitions/integer"
                                },
                                "modifiers": {
                                    "$ref": "#/definitions/HogQLQueryModifiers",
                                    "description": "Modifiers used when performing the query"
                                },
                                "offset": {
                                    "$ref": "#/definitions/integer"
                                },
                                "query_status": {
                                    "$ref": "#/definitions/QueryStatus",
                                    "description": "Query status indicates whether next to the provided data, a query is still running."
                                },
                                "results": {
                                    "items": {
                                        "$ref": "#/definitions/LLMTrace"
                                    },
                                    "type": "array"
                                },
                                "timings": {
                                    "description": "Measured timings for different parts of the query generation process",
                                    "items": {
                                        "$ref": "#/definitions/QueryTiming"
                                    },
                                    "type": "array"
                                }
                            },
                            "required": ["results"],
                            "type": "object"
                        }
                    ]
                },
                "showActions": {
                    "description": "Show the kebab menu at the end of the row",
                    "type": "boolean"
                },
                "showColumnConfigurator": {
                    "description": "Show a button to configure the table's columns if possible",
                    "type": "boolean"
                },
                "showDateRange": {
                    "description": "Show date range selector",
                    "type": "boolean"
                },
                "showElapsedTime": {
                    "description": "Show the time it takes to run a query",
                    "type": "boolean"
                },
                "showEventFilter": {
                    "description": "Include an event filter above the table (EventsNode only)",
                    "type": "boolean"
                },
                "showExport": {
                    "description": "Show the export button",
                    "type": "boolean"
                },
                "showHogQLEditor": {
                    "description": "Include a HogQL query editor above HogQL tables",
                    "type": "boolean"
                },
                "showOpenEditorButton": {
                    "description": "Show a button to open the current query as a new insight. (default: true)",
                    "type": "boolean"
                },
                "showPersistentColumnConfigurator": {
                    "description": "Show a button to configure and persist the table's default columns if possible",
                    "type": "boolean"
                },
                "showPropertyFilter": {
                    "anyOf": [
                        {
                            "type": "boolean"
                        },
                        {
                            "items": {
                                "$ref": "#/definitions/TaxonomicFilterGroupType"
                            },
                            "type": "array"
                        }
                    ],
                    "description": "Include a property filter above the table"
                },
                "showReload": {
                    "description": "Show a reload button",
                    "type": "boolean"
                },
                "showResultsTable": {
                    "description": "Show a results table",
                    "type": "boolean"
                },
                "showSavedQueries": {
                    "description": "Shows a list of saved queries",
                    "type": "boolean"
                },
                "showSearch": {
                    "description": "Include a free text search field (PersonsNode only)",
                    "type": "boolean"
                },
                "showTestAccountFilters": {
                    "description": "Show filter to exclude test accounts",
                    "type": "boolean"
                },
                "showTimings": {
                    "description": "Show a detailed query timing breakdown",
                    "type": "boolean"
                },
                "source": {
                    "anyOf": [
                        {
                            "$ref": "#/definitions/EventsNode"
                        },
                        {
                            "$ref": "#/definitions/EventsQuery"
                        },
                        {
                            "$ref": "#/definitions/PersonsNode"
                        },
                        {
                            "$ref": "#/definitions/ActorsQuery"
                        },
                        {
                            "$ref": "#/definitions/GroupsQuery"
                        },
                        {
                            "$ref": "#/definitions/HogQLQuery"
                        },
                        {
                            "$ref": "#/definitions/WebOverviewQuery"
                        },
                        {
                            "$ref": "#/definitions/WebStatsTableQuery"
                        },
                        {
                            "$ref": "#/definitions/WebExternalClicksTableQuery"
                        },
                        {
                            "$ref": "#/definitions/WebGoalsQuery"
                        },
                        {
                            "$ref": "#/definitions/WebVitalsQuery"
                        },
                        {
                            "$ref": "#/definitions/WebVitalsPathBreakdownQuery"
                        },
                        {
                            "$ref": "#/definitions/EventsHeatMapQuery"
                        },
                        {
                            "$ref": "#/definitions/SessionAttributionExplorerQuery"
                        },
                        {
                            "$ref": "#/definitions/RevenueAnalyticsOverviewQuery"
                        },
                        {
                            "$ref": "#/definitions/RevenueAnalyticsGrowthRateQuery"
                        },
                        {
                            "$ref": "#/definitions/RevenueAnalyticsTopCustomersQuery"
                        },
                        {
                            "$ref": "#/definitions/RevenueExampleEventsQuery"
                        },
                        {
                            "$ref": "#/definitions/RevenueExampleDataWarehouseTablesQuery"
                        },
                        {
                            "$ref": "#/definitions/ErrorTrackingQuery"
                        },
                        {
                            "$ref": "#/definitions/ExperimentFunnelsQuery"
                        },
                        {
                            "$ref": "#/definitions/ExperimentTrendsQuery"
                        },
                        {
                            "$ref": "#/definitions/TracesQuery"
                        }
                    ],
                    "description": "Source of the events"
                }
            },
            "required": ["kind", "source"],
            "type": "object"
        },
        "DataVisualizationNode": {
            "additionalProperties": false,
            "properties": {
                "chartSettings": {
                    "$ref": "#/definitions/ChartSettings"
                },
                "display": {
                    "$ref": "#/definitions/ChartDisplayType"
                },
                "kind": {
                    "const": "DataVisualizationNode",
                    "type": "string"
                },
                "source": {
                    "$ref": "#/definitions/HogQLQuery"
                },
                "tableSettings": {
                    "$ref": "#/definitions/TableSettings"
                }
            },
            "required": ["kind", "source"],
            "type": "object"
        },
        "DataWarehouseEventsModifier": {
            "additionalProperties": false,
            "properties": {
                "distinct_id_field": {
                    "type": "string"
                },
                "id_field": {
                    "type": "string"
                },
                "table_name": {
                    "type": "string"
                },
                "timestamp_field": {
                    "type": "string"
                }
            },
            "required": ["table_name", "timestamp_field", "distinct_id_field", "id_field"],
            "type": "object"
        },
        "DataWarehouseNode": {
            "additionalProperties": false,
            "properties": {
                "custom_name": {
                    "type": "string"
                },
                "distinct_id_field": {
                    "type": "string"
                },
                "fixedProperties": {
                    "description": "Fixed properties in the query, can't be edited in the interface (e.g. scoping down by person)",
                    "items": {
                        "$ref": "#/definitions/AnyPropertyFilter"
                    },
                    "type": "array"
                },
                "id": {
                    "type": "string"
                },
                "id_field": {
                    "type": "string"
                },
                "kind": {
                    "const": "DataWarehouseNode",
                    "type": "string"
                },
                "math": {
                    "$ref": "#/definitions/MathType"
                },
                "math_group_type_index": {
                    "enum": [0, 1, 2, 3, 4],
                    "type": "number"
                },
                "math_hogql": {
                    "type": "string"
                },
                "math_property": {
                    "type": "string"
                },
                "math_property_revenue_currency": {
                    "$ref": "#/definitions/RevenueCurrencyPropertyConfig"
                },
                "math_property_type": {
                    "type": "string"
                },
                "name": {
                    "type": "string"
                },
                "properties": {
                    "description": "Properties configurable in the interface",
                    "items": {
                        "$ref": "#/definitions/AnyPropertyFilter"
                    },
                    "type": "array"
                },
                "response": {
                    "type": "object"
                },
                "table_name": {
                    "type": "string"
                },
                "timestamp_field": {
                    "type": "string"
                }
            },
            "required": ["distinct_id_field", "id", "id_field", "kind", "table_name", "timestamp_field"],
            "type": "object"
        },
        "DataWarehousePersonPropertyFilter": {
            "additionalProperties": false,
            "properties": {
                "key": {
                    "type": "string"
                },
                "label": {
                    "type": "string"
                },
                "operator": {
                    "$ref": "#/definitions/PropertyOperator"
                },
                "type": {
                    "const": "data_warehouse_person_property",
                    "type": "string"
                },
                "value": {
                    "$ref": "#/definitions/PropertyFilterValue"
                }
            },
            "required": ["key", "operator", "type"],
            "type": "object"
        },
        "DataWarehousePropertyFilter": {
            "additionalProperties": false,
            "properties": {
                "key": {
                    "type": "string"
                },
                "label": {
                    "type": "string"
                },
                "operator": {
                    "$ref": "#/definitions/PropertyOperator"
                },
                "type": {
                    "const": "data_warehouse",
                    "type": "string"
                },
                "value": {
                    "$ref": "#/definitions/PropertyFilterValue"
                }
            },
            "required": ["key", "operator", "type"],
            "type": "object"
        },
        "DatabaseSchemaBatchExportTable": {
            "additionalProperties": false,
            "properties": {
                "fields": {
                    "additionalProperties": {
                        "$ref": "#/definitions/DatabaseSchemaField"
                    },
                    "type": "object"
                },
                "id": {
                    "type": "string"
                },
                "name": {
                    "type": "string"
                },
                "row_count": {
                    "type": "number"
                },
                "type": {
                    "const": "batch_export",
                    "type": "string"
                }
            },
            "required": ["fields", "id", "name", "type"],
            "type": "object"
        },
        "DatabaseSchemaDataWarehouseTable": {
            "additionalProperties": false,
            "properties": {
                "fields": {
                    "additionalProperties": {
                        "$ref": "#/definitions/DatabaseSchemaField"
                    },
                    "type": "object"
                },
                "format": {
                    "type": "string"
                },
                "id": {
                    "type": "string"
                },
                "name": {
                    "type": "string"
                },
                "row_count": {
                    "type": "number"
                },
                "schema": {
                    "$ref": "#/definitions/DatabaseSchemaSchema"
                },
                "source": {
                    "$ref": "#/definitions/DatabaseSchemaSource"
                },
                "type": {
                    "const": "data_warehouse",
                    "type": "string"
                },
                "url_pattern": {
                    "type": "string"
                }
            },
            "required": ["fields", "format", "id", "name", "type", "url_pattern"],
            "type": "object"
        },
        "DatabaseSchemaField": {
            "additionalProperties": false,
            "properties": {
                "chain": {
                    "items": {
                        "anyOf": [
                            {
                                "type": "string"
                            },
                            {
                                "$ref": "#/definitions/integer"
                            }
                        ]
                    },
                    "type": "array"
                },
                "fields": {
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                },
                "hogql_value": {
                    "type": "string"
                },
                "id": {
                    "type": "string"
                },
                "name": {
                    "type": "string"
                },
                "schema_valid": {
                    "type": "boolean"
                },
                "table": {
                    "type": "string"
                },
                "type": {
                    "$ref": "#/definitions/DatabaseSerializedFieldType"
                }
            },
            "required": ["name", "hogql_value", "type", "schema_valid"],
            "type": "object"
        },
        "DatabaseSchemaManagedViewTable": {
            "additionalProperties": false,
            "properties": {
                "fields": {
                    "additionalProperties": {
                        "$ref": "#/definitions/DatabaseSchemaField"
                    },
                    "type": "object"
                },
                "id": {
                    "type": "string"
                },
                "name": {
                    "type": "string"
                },
                "query": {
                    "$ref": "#/definitions/HogQLQuery"
                },
                "row_count": {
                    "type": "number"
                },
                "type": {
                    "const": "managed_view",
                    "type": "string"
                }
            },
            "required": ["fields", "id", "name", "query", "type"],
            "type": "object"
        },
        "DatabaseSchemaMaterializedViewTable": {
            "additionalProperties": false,
            "properties": {
                "fields": {
                    "additionalProperties": {
                        "$ref": "#/definitions/DatabaseSchemaField"
                    },
                    "type": "object"
                },
                "id": {
                    "type": "string"
                },
                "last_run_at": {
                    "type": "string"
                },
                "name": {
                    "type": "string"
                },
                "query": {
                    "$ref": "#/definitions/HogQLQuery"
                },
                "row_count": {
                    "type": "number"
                },
                "status": {
                    "type": "string"
                },
                "type": {
                    "const": "materialized_view",
                    "type": "string"
                }
            },
            "required": ["fields", "id", "name", "query", "type"],
            "type": "object"
        },
        "DatabaseSchemaPostHogTable": {
            "additionalProperties": false,
            "properties": {
                "fields": {
                    "additionalProperties": {
                        "$ref": "#/definitions/DatabaseSchemaField"
                    },
                    "type": "object"
                },
                "id": {
                    "type": "string"
                },
                "name": {
                    "type": "string"
                },
                "row_count": {
                    "type": "number"
                },
                "type": {
                    "const": "posthog",
                    "type": "string"
                }
            },
            "required": ["fields", "id", "name", "type"],
            "type": "object"
        },
        "DatabaseSchemaQuery": {
            "additionalProperties": false,
            "properties": {
                "kind": {
                    "const": "DatabaseSchemaQuery",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "response": {
                    "$ref": "#/definitions/DatabaseSchemaQueryResponse"
                }
            },
            "required": ["kind"],
            "type": "object"
        },
        "DatabaseSchemaQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "tables": {
                    "additionalProperties": {
                        "$ref": "#/definitions/DatabaseSchemaTable"
                    },
                    "type": "object"
                }
            },
            "required": ["tables"],
            "type": "object"
        },
        "DatabaseSchemaSchema": {
            "additionalProperties": false,
            "properties": {
                "id": {
                    "type": "string"
                },
                "incremental": {
                    "type": "boolean"
                },
                "last_synced_at": {
                    "type": "string"
                },
                "name": {
                    "type": "string"
                },
                "should_sync": {
                    "type": "boolean"
                },
                "status": {
                    "type": "string"
                }
            },
            "required": ["id", "name", "should_sync", "incremental"],
            "type": "object"
        },
        "DatabaseSchemaSource": {
            "additionalProperties": false,
            "properties": {
                "id": {
                    "type": "string"
                },
                "last_synced_at": {
                    "type": "string"
                },
                "prefix": {
                    "type": "string"
                },
                "source_type": {
                    "type": "string"
                },
                "status": {
                    "type": "string"
                }
            },
            "required": ["id", "status", "source_type", "prefix"],
            "type": "object"
        },
        "DatabaseSchemaTable": {
            "anyOf": [
                {
                    "$ref": "#/definitions/DatabaseSchemaPostHogTable"
                },
                {
                    "$ref": "#/definitions/DatabaseSchemaDataWarehouseTable"
                },
                {
                    "$ref": "#/definitions/DatabaseSchemaViewTable"
                },
                {
                    "$ref": "#/definitions/DatabaseSchemaManagedViewTable"
                },
                {
                    "$ref": "#/definitions/DatabaseSchemaBatchExportTable"
                },
                {
                    "$ref": "#/definitions/DatabaseSchemaMaterializedViewTable"
                }
            ]
        },
        "DatabaseSchemaTableCommon": {
            "additionalProperties": false,
            "properties": {
                "fields": {
                    "additionalProperties": {
                        "$ref": "#/definitions/DatabaseSchemaField"
                    },
                    "type": "object"
                },
                "id": {
                    "type": "string"
                },
                "name": {
                    "type": "string"
                },
                "row_count": {
                    "type": "number"
                },
                "type": {
                    "enum": ["posthog", "data_warehouse", "view", "batch_export", "materialized_view", "managed_view"],
                    "type": "string"
                }
            },
            "required": ["type", "id", "name", "fields"],
            "type": "object"
        },
        "DatabaseSchemaViewTable": {
            "additionalProperties": false,
            "properties": {
                "fields": {
                    "additionalProperties": {
                        "$ref": "#/definitions/DatabaseSchemaField"
                    },
                    "type": "object"
                },
                "id": {
                    "type": "string"
                },
                "name": {
                    "type": "string"
                },
                "query": {
                    "$ref": "#/definitions/HogQLQuery"
                },
                "row_count": {
                    "type": "number"
                },
                "type": {
                    "const": "view",
                    "type": "string"
                }
            },
            "required": ["fields", "id", "name", "query", "type"],
            "type": "object"
        },
        "DatabaseSerializedFieldType": {
            "enum": [
                "integer",
                "float",
                "decimal",
                "string",
                "datetime",
                "date",
                "boolean",
                "array",
                "json",
                "lazy_table",
                "virtual_table",
                "field_traverser",
                "expression",
                "view",
                "materialized_view",
                "unknown"
            ],
            "type": "string"
        },
        "DateRange": {
            "additionalProperties": false,
            "properties": {
                "date_from": {
                    "type": ["string", "null"]
                },
                "date_to": {
                    "type": ["string", "null"]
                },
                "explicitDate": {
                    "default": false,
                    "description": "Whether the date_from and date_to should be used verbatim. Disables rounding to the start and end of period.",
                    "type": ["boolean", "null"]
                }
            },
            "type": "object"
        },
        "DatetimeDay": {
            "format": "date-time",
            "type": "string"
        },
        "Day": {
            "$ref": "#/definitions/integer"
        },
        "DefaultChannelTypes": {
            "enum": [
                "Cross Network",
                "Paid Search",
                "Paid Social",
                "Paid Video",
                "Paid Shopping",
                "Paid Unknown",
                "Direct",
                "Organic Search",
                "Organic Social",
                "Organic Video",
                "Organic Shopping",
                "Push",
                "SMS",
                "Audio",
                "Email",
                "Referral",
                "Affiliate",
                "Unknown"
            ],
            "type": "string"
        },
        "DurationType": {
            "enum": ["duration", "active_seconds", "inactive_seconds"],
            "type": "string"
        },
        "ElementPropertyFilter": {
            "additionalProperties": false,
            "description": "Sync with plugin-server/src/types.ts",
            "properties": {
                "key": {
                    "enum": ["tag_name", "text", "href", "selector"],
                    "type": "string"
                },
                "label": {
                    "type": "string"
                },
                "operator": {
                    "$ref": "#/definitions/PropertyOperator"
                },
                "type": {
                    "const": "element",
                    "type": "string"
                },
                "value": {
                    "$ref": "#/definitions/PropertyFilterValue"
                }
            },
            "required": ["key", "operator", "type"],
            "type": "object"
        },
        "ElementType": {
            "additionalProperties": false,
            "properties": {
                "attr_class": {
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                },
                "attr_id": {
                    "type": "string"
                },
                "attributes": {
                    "additionalProperties": {
                        "type": "string"
                    },
                    "type": "object"
                },
                "href": {
                    "type": "string"
                },
                "nth_child": {
                    "type": "number"
                },
                "nth_of_type": {
                    "type": "number"
                },
                "order": {
                    "type": "number"
                },
                "tag_name": {
                    "type": "string"
                },
                "text": {
                    "type": "string"
                }
            },
            "required": ["attributes", "tag_name"],
            "type": "object"
        },
        "EmptyPropertyFilter": {
            "additionalProperties": false,
            "type": "object"
        },
        "EntityNode": {
            "additionalProperties": false,
            "properties": {
                "custom_name": {
                    "type": "string"
                },
                "fixedProperties": {
                    "description": "Fixed properties in the query, can't be edited in the interface (e.g. scoping down by person)",
                    "items": {
                        "$ref": "#/definitions/AnyPropertyFilter"
                    },
                    "type": "array"
                },
                "kind": {
                    "$ref": "#/definitions/NodeKind"
                },
                "math": {
                    "$ref": "#/definitions/MathType"
                },
                "math_group_type_index": {
                    "enum": [0, 1, 2, 3, 4],
                    "type": "number"
                },
                "math_hogql": {
                    "type": "string"
                },
                "math_property": {
                    "type": "string"
                },
                "math_property_revenue_currency": {
                    "$ref": "#/definitions/RevenueCurrencyPropertyConfig"
                },
                "math_property_type": {
                    "type": "string"
                },
                "name": {
                    "type": "string"
                },
                "properties": {
                    "description": "Properties configurable in the interface",
                    "items": {
                        "$ref": "#/definitions/AnyPropertyFilter"
                    },
                    "type": "array"
                },
                "response": {
                    "type": "object"
                }
            },
            "required": ["kind"],
            "type": "object"
        },
        "EntityType": {
            "enum": ["actions", "events", "data_warehouse", "new_entity"],
            "type": "string"
        },
        "ErrorTrackingIssue": {
            "additionalProperties": false,
            "properties": {
                "aggregations": {
                    "$ref": "#/definitions/ErrorTrackingIssueAggregations"
                },
                "assignee": {
                    "anyOf": [
                        {
                            "$ref": "#/definitions/ErrorTrackingIssueAssignee"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "description": {
                    "type": ["string", "null"]
                },
                "earliest": {
                    "type": "string"
                },
                "first_seen": {
                    "format": "date-time",
                    "type": "string"
                },
                "id": {
                    "type": "string"
                },
                "last_seen": {
                    "format": "date-time",
                    "type": "string"
                },
                "library": {
                    "type": ["string", "null"]
                },
                "name": {
                    "type": ["string", "null"]
                },
                "status": {
                    "enum": ["archived", "active", "resolved", "pending_release", "suppressed"],
                    "type": "string"
                }
            },
            "required": [
                "aggregations",
                "assignee",
                "description",
                "first_seen",
                "id",
                "last_seen",
                "library",
                "name",
                "status"
            ],
            "type": "object"
        },
        "ErrorTrackingIssueAggregations": {
            "additionalProperties": false,
            "properties": {
                "occurrences": {
                    "type": "number"
                },
                "sessions": {
                    "type": "number"
                },
                "users": {
                    "type": "number"
                },
                "volumeDay": {
                    "items": {
                        "type": "number"
                    },
                    "type": "array"
                },
                "volumeRange": {
                    "items": {
                        "type": "number"
                    },
                    "type": "array"
                }
            },
            "required": ["occurrences", "sessions", "users", "volumeDay", "volumeRange"],
            "type": "object"
        },
        "ErrorTrackingIssueAssignee": {
            "additionalProperties": false,
            "properties": {
                "id": {
                    "anyOf": [
                        {
                            "$ref": "#/definitions/integer"
                        },
                        {
                            "type": "string"
                        }
                    ]
                },
                "type": {
                    "enum": ["user_group", "user", "role"],
                    "type": "string"
                }
            },
            "required": ["type", "id"],
            "type": "object"
        },
        "ErrorTrackingIssueFilter": {
            "additionalProperties": false,
            "properties": {
                "key": {
                    "type": "string"
                },
                "label": {
                    "type": "string"
                },
                "operator": {
                    "$ref": "#/definitions/PropertyOperator"
                },
                "type": {
                    "const": "error_tracking_issue",
                    "type": "string"
                },
                "value": {
                    "$ref": "#/definitions/PropertyFilterValue"
                }
            },
            "required": ["key", "operator", "type"],
            "type": "object"
        },
        "ErrorTrackingQuery": {
            "additionalProperties": false,
            "properties": {
                "assignee": {
                    "anyOf": [
                        {
                            "$ref": "#/definitions/ErrorTrackingIssueAssignee"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "dateRange": {
                    "$ref": "#/definitions/DateRange"
                },
                "filterGroup": {
                    "$ref": "#/definitions/PropertyGroupFilter"
                },
                "filterTestAccounts": {
                    "type": "boolean"
                },
                "issueId": {
                    "type": "string"
                },
                "kind": {
                    "const": "ErrorTrackingQuery",
                    "type": "string"
                },
                "limit": {
                    "$ref": "#/definitions/integer"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "offset": {
                    "$ref": "#/definitions/integer"
                },
                "orderBy": {
                    "enum": ["last_seen", "first_seen", "occurrences", "users", "sessions"],
                    "type": "string"
                },
                "orderDirection": {
                    "enum": ["ASC", "DESC"],
                    "type": "string"
                },
                "response": {
                    "$ref": "#/definitions/ErrorTrackingQueryResponse"
                },
                "searchQuery": {
                    "type": "string"
                },
                "status": {
                    "enum": ["archived", "active", "resolved", "pending_release", "suppressed", "all"],
                    "type": "string"
                },
                "volumeResolution": {
                    "$ref": "#/definitions/integer"
                }
            },
            "required": ["dateRange", "kind", "volumeResolution"],
            "type": "object"
        },
        "ErrorTrackingQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "columns": {
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                },
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hasMore": {
                    "type": "boolean"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "limit": {
                    "$ref": "#/definitions/integer"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "offset": {
                    "$ref": "#/definitions/integer"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "items": {
                        "$ref": "#/definitions/ErrorTrackingIssue"
                    },
                    "type": "array"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                }
            },
            "required": ["results"],
            "type": "object"
        },
        "ErrorTrackingRelationalIssue": {
            "additionalProperties": false,
            "properties": {
                "assignee": {
                    "anyOf": [
                        {
                            "$ref": "#/definitions/ErrorTrackingIssueAssignee"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "description": {
                    "type": ["string", "null"]
                },
                "first_seen": {
                    "format": "date-time",
                    "type": "string"
                },
                "id": {
                    "type": "string"
                },
                "name": {
                    "type": ["string", "null"]
                },
                "status": {
                    "enum": ["archived", "active", "resolved", "pending_release", "suppressed"],
                    "type": "string"
                }
            },
            "required": ["id", "name", "description", "assignee", "status", "first_seen"],
            "type": "object"
        },
        "EventDefinition": {
            "additionalProperties": false,
            "properties": {
                "elements": {
                    "items": {},
                    "type": "array"
                },
                "event": {
                    "type": "string"
                },
                "properties": {
                    "type": "object"
                }
            },
            "required": ["event", "properties", "elements"],
            "type": "object"
        },
        "EventMetadataPropertyFilter": {
            "additionalProperties": false,
            "properties": {
                "key": {
                    "type": "string"
                },
                "label": {
                    "type": "string"
                },
                "operator": {
                    "$ref": "#/definitions/PropertyOperator"
                },
                "type": {
                    "const": "event_metadata",
                    "type": "string"
                },
                "value": {
                    "$ref": "#/definitions/PropertyFilterValue"
                }
            },
            "required": ["key", "operator", "type"],
            "type": "object"
        },
        "EventOddsRatioSerialized": {
            "additionalProperties": false,
            "properties": {
                "correlation_type": {
                    "enum": ["success", "failure"],
                    "type": "string"
                },
                "event": {
                    "$ref": "#/definitions/EventDefinition"
                },
                "failure_count": {
                    "$ref": "#/definitions/integer"
                },
                "odds_ratio": {
                    "type": "number"
                },
                "success_count": {
                    "$ref": "#/definitions/integer"
                }
            },
            "required": ["event", "success_count", "failure_count", "odds_ratio", "correlation_type"],
            "type": "object"
        },
        "EventPropertyFilter": {
            "additionalProperties": false,
            "description": "Sync with plugin-server/src/types.ts",
            "properties": {
                "key": {
                    "type": "string"
                },
                "label": {
                    "type": "string"
                },
                "operator": {
                    "$ref": "#/definitions/PropertyOperator",
                    "default": "exact"
                },
                "type": {
                    "const": "event",
                    "description": "Event properties",
                    "type": "string"
                },
                "value": {
                    "$ref": "#/definitions/PropertyFilterValue"
                }
            },
            "required": ["key", "operator", "type"],
            "type": "object"
        },
        "EventTaxonomyItem": {
            "additionalProperties": false,
            "properties": {
                "property": {
                    "type": "string"
                },
                "sample_count": {
                    "$ref": "#/definitions/integer"
                },
                "sample_values": {
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                }
            },
            "required": ["property", "sample_values", "sample_count"],
            "type": "object"
        },
        "EventTaxonomyQuery": {
            "additionalProperties": false,
            "properties": {
                "actionId": {
                    "$ref": "#/definitions/integer"
                },
                "event": {
                    "type": "string"
                },
                "kind": {
                    "const": "EventTaxonomyQuery",
                    "type": "string"
                },
                "maxPropertyValues": {
                    "$ref": "#/definitions/integer"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "properties": {
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                },
                "response": {
                    "$ref": "#/definitions/EventTaxonomyQueryResponse"
                }
            },
            "required": ["kind"],
            "type": "object"
        },
        "EventTaxonomyQueryResponse": {
            "additionalProperties": false,
            "description": "All analytics query responses must inherit from this.",
            "properties": {
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "$ref": "#/definitions/EventTaxonomyResponse"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                }
            },
            "required": ["results"],
            "type": "object"
        },
        "EventTaxonomyResponse": {
            "items": {
                "$ref": "#/definitions/EventTaxonomyItem"
            },
            "type": "array"
        },
        "EventType": {
            "additionalProperties": false,
            "properties": {
                "distinct_id": {
                    "type": "string"
                },
                "elements": {
                    "items": {
                        "$ref": "#/definitions/ElementType"
                    },
                    "type": "array"
                },
                "elements_chain": {
                    "type": ["string", "null"]
                },
                "event": {
                    "type": "string"
                },
                "id": {
                    "type": "string"
                },
                "person": {
                    "additionalProperties": false,
                    "properties": {
                        "distinct_ids": {
                            "items": {
                                "type": "string"
                            },
                            "type": "array"
                        },
                        "is_identified": {
                            "type": "boolean"
                        },
                        "properties": {
                            "type": "object"
                        }
                    },
                    "required": ["distinct_ids", "properties"],
                    "type": "object"
                },
                "properties": {
                    "type": "object"
                },
                "timestamp": {
                    "type": "string"
                },
                "uuid": {
                    "type": "string"
                }
            },
            "required": ["id", "distinct_id", "properties", "event", "timestamp", "elements"],
            "type": "object"
        },
        "EventsHeatMapColumnAggregationResult": {
            "additionalProperties": false,
            "properties": {
                "column": {
                    "$ref": "#/definitions/integer"
                },
                "value": {
                    "$ref": "#/definitions/integer"
                }
            },
            "required": ["column", "value"],
            "type": "object"
        },
        "EventsHeatMapDataResult": {
            "additionalProperties": false,
            "properties": {
                "column": {
                    "$ref": "#/definitions/integer"
                },
                "row": {
                    "$ref": "#/definitions/integer"
                },
                "value": {
                    "$ref": "#/definitions/integer"
                }
            },
            "required": ["row", "column", "value"],
            "type": "object"
        },
        "EventsHeatMapQuery": {
            "additionalProperties": false,
            "properties": {
                "compareFilter": {
                    "$ref": "#/definitions/CompareFilter"
                },
                "conversionGoal": {
                    "anyOf": [
                        {
                            "$ref": "#/definitions/WebAnalyticsConversionGoal"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "dateRange": {
                    "$ref": "#/definitions/DateRange"
                },
                "doPathCleaning": {
                    "type": "boolean"
                },
                "filterTestAccounts": {
                    "type": "boolean"
                },
                "includeRevenue": {
                    "type": "boolean"
                },
                "kind": {
                    "const": "EventsHeatMapQuery",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "orderBy": {
                    "$ref": "#/definitions/WebAnalyticsOrderBy"
                },
                "properties": {
                    "$ref": "#/definitions/WebAnalyticsPropertyFilters"
                },
                "response": {
                    "$ref": "#/definitions/EventsHeatMapQueryResponse"
                },
                "sampling": {
                    "additionalProperties": false,
                    "properties": {
                        "enabled": {
                            "type": "boolean"
                        },
                        "forceSamplingRate": {
                            "$ref": "#/definitions/SamplingRate"
                        }
                    },
                    "type": "object"
                },
                "source": {
                    "$ref": "#/definitions/HeatMapQuerySource"
                },
                "useSessionsTable": {
                    "deprecated": "ignored, always treated as enabled *",
                    "type": "boolean"
                }
            },
            "required": ["kind", "properties", "source"],
            "type": "object"
        },
        "EventsHeatMapQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hasMore": {
                    "type": "boolean"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "limit": {
                    "$ref": "#/definitions/integer"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "$ref": "#/definitions/EventsHeatMapStructuredResult"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                }
            },
            "required": ["results"],
            "type": "object"
        },
        "EventsHeatMapRowAggregationResult": {
            "additionalProperties": false,
            "properties": {
                "row": {
                    "$ref": "#/definitions/integer"
                },
                "value": {
                    "$ref": "#/definitions/integer"
                }
            },
            "required": ["row", "value"],
            "type": "object"
        },
        "EventsHeatMapStructuredResult": {
            "additionalProperties": false,
            "properties": {
                "allAggregations": {
                    "$ref": "#/definitions/integer"
                },
                "columnAggregations": {
                    "items": {
                        "$ref": "#/definitions/EventsHeatMapColumnAggregationResult"
                    },
                    "type": "array"
                },
                "data": {
                    "items": {
                        "$ref": "#/definitions/EventsHeatMapDataResult"
                    },
                    "type": "array"
                },
                "rowAggregations": {
                    "items": {
                        "$ref": "#/definitions/EventsHeatMapRowAggregationResult"
                    },
                    "type": "array"
                }
            },
            "required": ["data", "rowAggregations", "columnAggregations", "allAggregations"],
            "type": "object"
        },
        "EventsNode": {
            "additionalProperties": false,
            "properties": {
                "custom_name": {
                    "type": "string"
                },
                "event": {
                    "description": "The event or `null` for all events.",
                    "type": ["string", "null"]
                },
                "fixedProperties": {
                    "description": "Fixed properties in the query, can't be edited in the interface (e.g. scoping down by person)",
                    "items": {
                        "$ref": "#/definitions/AnyPropertyFilter"
                    },
                    "type": "array"
                },
                "kind": {
                    "const": "EventsNode",
                    "type": "string"
                },
                "limit": {
                    "$ref": "#/definitions/integer"
                },
                "math": {
                    "$ref": "#/definitions/MathType"
                },
                "math_group_type_index": {
                    "enum": [0, 1, 2, 3, 4],
                    "type": "number"
                },
                "math_hogql": {
                    "type": "string"
                },
                "math_property": {
                    "type": "string"
                },
                "math_property_revenue_currency": {
                    "$ref": "#/definitions/RevenueCurrencyPropertyConfig"
                },
                "math_property_type": {
                    "type": "string"
                },
                "name": {
                    "type": "string"
                },
                "orderBy": {
                    "description": "Columns to order by",
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                },
                "properties": {
                    "description": "Properties configurable in the interface",
                    "items": {
                        "$ref": "#/definitions/AnyPropertyFilter"
                    },
                    "type": "array"
                },
                "response": {
                    "type": "object"
                }
            },
            "required": ["kind"],
            "type": "object"
        },
        "EventsQuery": {
            "additionalProperties": false,
            "properties": {
                "actionId": {
                    "$ref": "#/definitions/integer",
                    "description": "Show events matching a given action"
                },
                "after": {
                    "description": "Only fetch events that happened after this timestamp",
                    "type": "string"
                },
                "before": {
                    "description": "Only fetch events that happened before this timestamp",
                    "type": "string"
                },
                "event": {
                    "description": "Limit to events matching this string",
                    "type": ["string", "null"]
                },
                "filterTestAccounts": {
                    "description": "Filter test accounts",
                    "type": "boolean"
                },
                "fixedProperties": {
                    "description": "Fixed properties in the query, can't be edited in the interface (e.g. scoping down by person)",
                    "items": {
                        "$ref": "#/definitions/AnyFilterLike"
                    },
                    "type": "array"
                },
                "kind": {
                    "const": "EventsQuery",
                    "type": "string"
                },
                "limit": {
                    "$ref": "#/definitions/integer",
                    "description": "Number of rows to return"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "offset": {
                    "$ref": "#/definitions/integer",
                    "description": "Number of rows to skip before returning rows"
                },
                "orderBy": {
                    "description": "Columns to order by",
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                },
                "personId": {
                    "description": "Show events for a given person",
                    "type": "string"
                },
                "properties": {
                    "description": "Properties configurable in the interface",
                    "items": {
                        "$ref": "#/definitions/AnyPropertyFilter"
                    },
                    "type": "array"
                },
                "response": {
                    "$ref": "#/definitions/EventsQueryResponse"
                },
                "select": {
                    "description": "Return a limited set of data. Required.",
                    "items": {
                        "$ref": "#/definitions/HogQLExpression"
                    },
                    "type": "array"
                },
                "source": {
                    "$ref": "#/definitions/InsightActorsQuery",
                    "description": "source for querying events for insights"
                },
                "where": {
                    "description": "HogQL filters to apply on returned data",
                    "items": {
                        "$ref": "#/definitions/HogQLExpression"
                    },
                    "type": "array"
                }
            },
            "required": ["kind", "select"],
            "type": "object"
        },
        "EventsQueryPersonColumn": {
            "additionalProperties": false,
            "properties": {
                "created_at": {
                    "type": "string"
                },
                "distinct_id": {
                    "type": "string"
                },
                "properties": {
                    "additionalProperties": false,
                    "properties": {
                        "email": {
                            "type": "string"
                        },
                        "name": {
                            "type": "string"
                        }
                    },
                    "type": "object"
                },
                "uuid": {
                    "type": "string"
                }
            },
            "required": ["uuid", "created_at", "properties", "distinct_id"],
            "type": "object"
        },
        "EventsQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "columns": {
                    "items": {},
                    "type": "array"
                },
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hasMore": {
                    "type": "boolean"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "limit": {
                    "$ref": "#/definitions/integer"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "offset": {
                    "$ref": "#/definitions/integer"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "items": {
                        "items": {},
                        "type": "array"
                    },
                    "type": "array"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                },
                "types": {
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                }
            },
            "required": ["columns", "hogql", "results", "types"],
            "type": "object"
        },
        "ExperimentDataWarehouseNode": {
            "additionalProperties": false,
            "properties": {
                "custom_name": {
                    "type": "string"
                },
                "data_warehouse_join_key": {
                    "type": "string"
                },
                "events_join_key": {
                    "type": "string"
                },
                "fixedProperties": {
                    "description": "Fixed properties in the query, can't be edited in the interface (e.g. scoping down by person)",
                    "items": {
                        "$ref": "#/definitions/AnyPropertyFilter"
                    },
                    "type": "array"
                },
                "kind": {
                    "const": "ExperimentDataWarehouseNode",
                    "type": "string"
                },
                "math": {
                    "$ref": "#/definitions/MathType"
                },
                "math_group_type_index": {
                    "enum": [0, 1, 2, 3, 4],
                    "type": "number"
                },
                "math_hogql": {
                    "type": "string"
                },
                "math_property": {
                    "type": "string"
                },
                "math_property_revenue_currency": {
                    "$ref": "#/definitions/RevenueCurrencyPropertyConfig"
                },
                "math_property_type": {
                    "type": "string"
                },
                "name": {
                    "type": "string"
                },
                "properties": {
                    "description": "Properties configurable in the interface",
                    "items": {
                        "$ref": "#/definitions/AnyPropertyFilter"
                    },
                    "type": "array"
                },
                "response": {
                    "type": "object"
                },
                "table_name": {
                    "type": "string"
                },
                "timestamp_field": {
                    "type": "string"
                }
            },
            "required": ["data_warehouse_join_key", "events_join_key", "kind", "table_name", "timestamp_field"],
            "type": "object"
        },
        "ExperimentEventExposureConfig": {
            "additionalProperties": false,
            "properties": {
                "event": {
                    "type": "string"
                },
                "kind": {
                    "const": "ExperimentEventExposureConfig",
                    "type": "string"
                },
                "properties": {
                    "items": {
                        "$ref": "#/definitions/AnyPropertyFilter"
                    },
                    "type": "array"
                }
            },
            "required": ["kind", "event", "properties"],
            "type": "object"
        },
        "ExperimentExposureCriteria": {
            "additionalProperties": false,
            "properties": {
                "exposure_config": {
                    "$ref": "#/definitions/ExperimentEventExposureConfig"
                },
                "filterTestAccounts": {
                    "type": "boolean"
                }
            },
            "type": "object"
        },
        "ExperimentExposureQuery": {
            "additionalProperties": false,
            "properties": {
                "experiment_id": {
                    "$ref": "#/definitions/integer"
                },
                "kind": {
                    "const": "ExperimentExposureQuery",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "response": {
                    "$ref": "#/definitions/ExperimentExposureQueryResponse"
                }
            },
            "required": ["kind"],
            "type": "object"
        },
        "ExperimentExposureQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "date_range": {
                    "$ref": "#/definitions/DateRange"
                },
                "kind": {
                    "const": "ExperimentExposureQuery",
                    "type": "string"
                },
                "timeseries": {
                    "items": {
                        "$ref": "#/definitions/ExperimentExposureTimeSeries"
                    },
                    "type": "array"
                },
                "total_exposures": {
                    "additionalProperties": {
                        "type": "number"
                    },
                    "type": "object"
                }
            },
            "required": ["kind", "timeseries", "total_exposures", "date_range"],
            "type": "object"
        },
        "ExperimentExposureTimeSeries": {
            "additionalProperties": false,
            "properties": {
                "days": {
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                },
                "exposure_counts": {
                    "items": {
                        "type": "number"
                    },
                    "type": "array"
                },
                "variant": {
                    "type": "string"
                }
            },
            "required": ["variant", "days", "exposure_counts"],
            "type": "object"
        },
        "ExperimentFunnelMetric": {
            "additionalProperties": false,
            "properties": {
                "conversion_window": {
                    "$ref": "#/definitions/integer"
                },
                "conversion_window_unit": {
                    "$ref": "#/definitions/FunnelConversionWindowTimeUnit"
                },
                "kind": {
                    "const": "ExperimentMetric",
                    "type": "string"
                },
                "metric_type": {
                    "const": "funnel",
                    "type": "string"
                },
                "name": {
                    "type": "string"
                },
                "series": {
                    "items": {
                        "$ref": "#/definitions/ExperimentFunnelMetricStep"
                    },
                    "type": "array"
                }
            },
            "required": ["kind", "metric_type", "series"],
            "type": "object"
        },
        "ExperimentFunnelMetricStep": {
            "anyOf": [
                {
                    "$ref": "#/definitions/EventsNode"
                },
                {
                    "$ref": "#/definitions/ActionsNode"
                }
            ]
        },
        "ExperimentFunnelMetricTypeProps": {
            "additionalProperties": false,
            "properties": {
                "metric_type": {
                    "const": "funnel",
                    "type": "string"
                },
                "series": {
                    "items": {
                        "$ref": "#/definitions/ExperimentFunnelMetricStep"
                    },
                    "type": "array"
                }
            },
            "required": ["metric_type", "series"],
            "type": "object"
        },
        "ExperimentFunnelsQuery": {
            "additionalProperties": false,
            "properties": {
                "experiment_id": {
                    "$ref": "#/definitions/integer"
                },
                "funnels_query": {
                    "$ref": "#/definitions/FunnelsQuery"
                },
                "kind": {
                    "const": "ExperimentFunnelsQuery",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "name": {
                    "type": "string"
                },
                "response": {
                    "$ref": "#/definitions/ExperimentFunnelsQueryResponse"
                }
            },
            "required": ["funnels_query", "kind"],
            "type": "object"
        },
        "ExperimentFunnelsQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "credible_intervals": {
                    "additionalProperties": {
                        "items": {
                            "type": "number"
                        },
                        "maxItems": 2,
                        "minItems": 2,
                        "type": "array"
                    },
                    "type": "object"
                },
                "expected_loss": {
                    "type": "number"
                },
                "funnels_query": {
                    "$ref": "#/definitions/FunnelsQuery"
                },
                "insight": {
                    "items": {
                        "items": {
                            "type": "object"
                        },
                        "type": "array"
                    },
                    "type": "array"
                },
                "kind": {
                    "const": "ExperimentFunnelsQuery",
                    "type": "string"
                },
                "probability": {
                    "additionalProperties": {
                        "type": "number"
                    },
                    "type": "object"
                },
                "significance_code": {
                    "$ref": "#/definitions/ExperimentSignificanceCode"
                },
                "significant": {
                    "type": "boolean"
                },
                "stats_version": {
                    "$ref": "#/definitions/integer"
                },
                "variants": {
                    "items": {
                        "$ref": "#/definitions/ExperimentVariantFunnelsBaseStats"
                    },
                    "type": "array"
                }
            },
            "required": [
                "kind",
                "insight",
                "variants",
                "probability",
                "significant",
                "significance_code",
                "expected_loss",
                "credible_intervals"
            ],
            "type": "object"
        },
        "ExperimentMeanMetric": {
            "additionalProperties": false,
            "properties": {
                "conversion_window": {
                    "$ref": "#/definitions/integer"
                },
                "conversion_window_unit": {
                    "$ref": "#/definitions/FunnelConversionWindowTimeUnit"
                },
                "kind": {
                    "const": "ExperimentMetric",
                    "type": "string"
                },
                "lower_bound_percentile": {
                    "type": "number"
                },
                "metric_type": {
                    "const": "mean",
                    "type": "string"
                },
                "name": {
                    "type": "string"
                },
                "source": {
                    "$ref": "#/definitions/ExperimentMetricSource"
                },
                "upper_bound_percentile": {
                    "type": "number"
                }
            },
            "required": ["kind", "metric_type", "source"],
            "type": "object"
        },
        "ExperimentMeanMetricTypeProps": {
            "additionalProperties": false,
            "properties": {
                "lower_bound_percentile": {
                    "type": "number"
                },
                "metric_type": {
                    "const": "mean",
                    "type": "string"
                },
                "source": {
                    "$ref": "#/definitions/ExperimentMetricSource"
                },
                "upper_bound_percentile": {
                    "type": "number"
                }
            },
            "required": ["metric_type", "source"],
            "type": "object"
        },
        "ExperimentMetric": {
            "anyOf": [
                {
                    "$ref": "#/definitions/ExperimentMeanMetric"
                },
                {
                    "$ref": "#/definitions/ExperimentFunnelMetric"
                }
            ]
        },
        "ExperimentMetricBaseProperties": {
            "additionalProperties": false,
            "properties": {
                "conversion_window": {
                    "$ref": "#/definitions/integer"
                },
                "conversion_window_unit": {
                    "$ref": "#/definitions/FunnelConversionWindowTimeUnit"
                },
                "kind": {
                    "const": "ExperimentMetric",
                    "type": "string"
                },
                "name": {
                    "type": "string"
                }
            },
            "required": ["kind"],
            "type": "object"
        },
        "ExperimentMetricMathType": {
            "enum": ["total", "sum"],
            "type": "string"
        },
        "ExperimentMetricOutlierHandling": {
            "additionalProperties": false,
            "properties": {
                "lower_bound_percentile": {
                    "type": "number"
                },
                "upper_bound_percentile": {
                    "type": "number"
                }
            },
            "type": "object"
        },
        "ExperimentMetricSource": {
            "anyOf": [
                {
                    "$ref": "#/definitions/EventsNode"
                },
                {
                    "$ref": "#/definitions/ActionsNode"
                },
                {
                    "$ref": "#/definitions/ExperimentDataWarehouseNode"
                }
            ]
        },
        "ExperimentMetricType": {
            "enum": ["funnel", "mean"],
            "type": "string"
        },
        "ExperimentMetricTypeProps": {
            "anyOf": [
                {
                    "$ref": "#/definitions/ExperimentMeanMetricTypeProps"
                },
                {
                    "$ref": "#/definitions/ExperimentFunnelMetricTypeProps"
                }
            ]
        },
        "ExperimentQuery": {
            "additionalProperties": false,
            "properties": {
                "experiment_id": {
                    "$ref": "#/definitions/integer"
                },
                "kind": {
                    "const": "ExperimentQuery",
                    "type": "string"
                },
                "metric": {
                    "$ref": "#/definitions/ExperimentMetric"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "name": {
                    "type": "string"
                },
                "response": {
                    "$ref": "#/definitions/ExperimentQueryResponse"
                }
            },
            "required": ["kind", "metric"],
            "type": "object"
        },
        "ExperimentQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "credible_intervals": {
                    "additionalProperties": {
                        "items": {
                            "type": "number"
                        },
                        "maxItems": 2,
                        "minItems": 2,
                        "type": "array"
                    },
                    "type": "object"
                },
                "insight": {
                    "items": {
                        "type": "object"
                    },
                    "type": "array"
                },
                "kind": {
                    "const": "ExperimentQuery",
                    "type": "string"
                },
                "metric": {
                    "$ref": "#/definitions/ExperimentMetric"
                },
                "p_value": {
                    "type": "number"
                },
                "probability": {
                    "additionalProperties": {
                        "type": "number"
                    },
                    "type": "object"
                },
                "significance_code": {
                    "$ref": "#/definitions/ExperimentSignificanceCode"
                },
                "significant": {
                    "type": "boolean"
                },
                "stats_version": {
                    "$ref": "#/definitions/integer"
                },
                "variants": {
                    "anyOf": [
                        {
                            "items": {
                                "$ref": "#/definitions/ExperimentVariantTrendsBaseStats"
                            },
                            "type": "array"
                        },
                        {
                            "items": {
                                "$ref": "#/definitions/ExperimentVariantFunnelsBaseStats"
                            },
                            "type": "array"
                        }
                    ]
                }
            },
            "required": [
                "kind",
                "insight",
                "metric",
                "variants",
                "probability",
                "significant",
                "significance_code",
                "p_value",
                "credible_intervals"
            ],
            "type": "object"
        },
        "ExperimentSignificanceCode": {
            "enum": ["significant", "not_enough_exposure", "low_win_probability", "high_loss", "high_p_value"],
            "type": "string"
        },
        "ExperimentTrendsQuery": {
            "additionalProperties": false,
            "properties": {
                "count_query": {
                    "$ref": "#/definitions/TrendsQuery"
                },
                "experiment_id": {
                    "$ref": "#/definitions/integer"
                },
                "exposure_query": {
                    "$ref": "#/definitions/TrendsQuery"
                },
                "kind": {
                    "const": "ExperimentTrendsQuery",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "name": {
                    "type": "string"
                },
                "response": {
                    "$ref": "#/definitions/ExperimentTrendsQueryResponse"
                }
            },
            "required": ["count_query", "kind"],
            "type": "object"
        },
        "ExperimentTrendsQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "count_query": {
                    "$ref": "#/definitions/TrendsQuery"
                },
                "credible_intervals": {
                    "additionalProperties": {
                        "items": {
                            "type": "number"
                        },
                        "maxItems": 2,
                        "minItems": 2,
                        "type": "array"
                    },
                    "type": "object"
                },
                "exposure_query": {
                    "$ref": "#/definitions/TrendsQuery"
                },
                "insight": {
                    "items": {
                        "type": "object"
                    },
                    "type": "array"
                },
                "kind": {
                    "const": "ExperimentTrendsQuery",
                    "type": "string"
                },
                "p_value": {
                    "type": "number"
                },
                "probability": {
                    "additionalProperties": {
                        "type": "number"
                    },
                    "type": "object"
                },
                "significance_code": {
                    "$ref": "#/definitions/ExperimentSignificanceCode"
                },
                "significant": {
                    "type": "boolean"
                },
                "stats_version": {
                    "$ref": "#/definitions/integer"
                },
                "variants": {
                    "items": {
                        "$ref": "#/definitions/ExperimentVariantTrendsBaseStats"
                    },
                    "type": "array"
                }
            },
            "required": [
                "kind",
                "insight",
                "variants",
                "probability",
                "significant",
                "significance_code",
                "p_value",
                "credible_intervals"
            ],
            "type": "object"
        },
        "ExperimentVariantFunnelsBaseStats": {
            "additionalProperties": false,
            "properties": {
                "failure_count": {
                    "type": "number"
                },
                "key": {
                    "type": "string"
                },
                "success_count": {
                    "type": "number"
                }
            },
            "required": ["key", "success_count", "failure_count"],
            "type": "object"
        },
        "ExperimentVariantTrendsBaseStats": {
            "additionalProperties": false,
            "properties": {
                "absolute_exposure": {
                    "type": "number"
                },
                "count": {
                    "type": "number"
                },
                "exposure": {
                    "type": "number"
                },
                "key": {
                    "type": "string"
                }
            },
            "required": ["key", "count", "exposure", "absolute_exposure"],
            "type": "object"
        },
        "FailureMessage": {
            "additionalProperties": false,
            "properties": {
                "content": {
                    "type": "string"
                },
                "id": {
                    "type": "string"
                },
                "type": {
                    "const": "ai/failure",
                    "type": "string"
                }
            },
            "required": ["type"],
            "type": "object"
        },
        "FeaturePropertyFilter": {
            "additionalProperties": false,
            "properties": {
                "key": {
                    "type": "string"
                },
                "label": {
                    "type": "string"
                },
                "operator": {
                    "$ref": "#/definitions/PropertyOperator"
                },
                "type": {
                    "const": "feature",
                    "description": "Event property with \"$feature/\" prepended",
                    "type": "string"
                },
                "value": {
                    "$ref": "#/definitions/PropertyFilterValue"
                }
            },
            "required": ["key", "operator", "type"],
            "type": "object"
        },
        "FileSystemCount": {
            "additionalProperties": false,
            "properties": {
                "count": {
                    "type": "number"
                }
            },
            "required": ["count"],
            "type": "object"
        },
        "FileSystemEntry": {
            "additionalProperties": false,
            "properties": {
                "_loading": {
                    "description": "Used to indicate pending actions, frontend only",
                    "type": "boolean"
                },
                "created_at": {
                    "description": "Timestamp when file was added. Used to check persistence",
                    "type": "string"
                },
                "href": {
                    "description": "Object's URL",
                    "type": "string"
                },
                "id": {
                    "description": "Unique UUID for tree entry",
                    "type": "string"
                },
                "meta": {
                    "description": "Metadata",
                    "type": "object"
                },
                "path": {
                    "description": "Object's name and folder",
                    "type": "string"
                },
                "ref": {
                    "description": "Object's ID or other unique reference",
                    "type": "string"
                },
                "shortcut": {
                    "description": "Whether this is a shortcut or the actual item",
                    "type": "boolean"
                },
                "type": {
                    "description": "Type of object, used for icon, e.g. feature_flag, insight, etc",
                    "type": "string"
                }
            },
            "required": ["id", "path"],
            "type": "object"
        },
        "FileSystemImport": {
            "additionalProperties": false,
            "properties": {
                "_loading": {
                    "description": "Used to indicate pending actions, frontend only",
                    "type": "boolean"
                },
                "created_at": {
                    "description": "Timestamp when file was added. Used to check persistence",
                    "type": "string"
                },
                "flag": {
                    "type": "string"
                },
                "href": {
                    "$comment": "(ref?: string) => string",
                    "properties": {
                        "namedArgs": {
                            "additionalProperties": false,
                            "properties": {
                                "ref": {
                                    "type": "string"
                                }
                            },
                            "type": "object"
                        }
                    },
                    "type": "object"
                },
                "icon": {},
                "id": {
                    "type": "string"
                },
                "meta": {
                    "description": "Metadata",
                    "type": "object"
                },
                "path": {
                    "description": "Object's name and folder",
                    "type": "string"
                },
                "ref": {
                    "description": "Object's ID or other unique reference",
                    "type": "string"
                },
                "shortcut": {
                    "description": "Whether this is a shortcut or the actual item",
                    "type": "boolean"
                },
                "type": {
                    "description": "Type of object, used for icon, e.g. feature_flag, insight, etc",
                    "type": "string"
                }
            },
            "required": ["href", "path"],
            "type": "object"
        },
        "FilterLogicalOperator": {
            "enum": ["AND", "OR"],
            "type": "string"
        },
        "FunnelConversionWindowTimeUnit": {
            "enum": ["second", "minute", "hour", "day", "week", "month"],
            "type": "string"
        },
        "FunnelCorrelationActorsQuery": {
            "additionalProperties": false,
            "properties": {
                "funnelCorrelationPersonConverted": {
                    "type": "boolean"
                },
                "funnelCorrelationPersonEntity": {
                    "$ref": "#/definitions/AnyEntityNode"
                },
                "funnelCorrelationPropertyValues": {
                    "items": {
                        "$ref": "#/definitions/AnyPropertyFilter"
                    },
                    "type": "array"
                },
                "includeRecordings": {
                    "type": "boolean"
                },
                "kind": {
                    "const": "FunnelCorrelationActorsQuery",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "response": {
                    "$ref": "#/definitions/ActorsQueryResponse"
                },
                "source": {
                    "$ref": "#/definitions/FunnelCorrelationQuery"
                }
            },
            "required": ["kind", "source"],
            "type": "object"
        },
        "FunnelCorrelationQuery": {
            "additionalProperties": false,
            "properties": {
                "funnelCorrelationEventExcludePropertyNames": {
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                },
                "funnelCorrelationEventNames": {
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                },
                "funnelCorrelationExcludeEventNames": {
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                },
                "funnelCorrelationExcludeNames": {
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                },
                "funnelCorrelationNames": {
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                },
                "funnelCorrelationType": {
                    "$ref": "#/definitions/FunnelCorrelationResultsType"
                },
                "kind": {
                    "const": "FunnelCorrelationQuery",
                    "type": "string"
                },
                "response": {
                    "$ref": "#/definitions/FunnelCorrelationResponse"
                },
                "source": {
                    "$ref": "#/definitions/FunnelsActorsQuery"
                }
            },
            "required": ["funnelCorrelationType", "kind", "source"],
            "type": "object"
        },
        "FunnelCorrelationResponse": {
            "additionalProperties": false,
            "properties": {
                "columns": {
                    "items": {},
                    "type": "array"
                },
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hasMore": {
                    "type": "boolean"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "limit": {
                    "$ref": "#/definitions/integer"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "offset": {
                    "$ref": "#/definitions/integer"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "$ref": "#/definitions/FunnelCorrelationResult"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                },
                "types": {
                    "items": {},
                    "type": "array"
                }
            },
            "required": ["results"],
            "type": "object"
        },
        "FunnelCorrelationResult": {
            "additionalProperties": false,
            "properties": {
                "events": {
                    "items": {
                        "$ref": "#/definitions/EventOddsRatioSerialized"
                    },
                    "type": "array"
                },
                "skewed": {
                    "type": "boolean"
                }
            },
            "required": ["events", "skewed"],
            "type": "object"
        },
        "FunnelCorrelationResultsType": {
            "enum": ["events", "properties", "event_with_properties"],
            "type": "string"
        },
        "FunnelExclusion": {
            "anyOf": [
                {
                    "$ref": "#/definitions/FunnelExclusionEventsNode"
                },
                {
                    "$ref": "#/definitions/FunnelExclusionActionsNode"
                }
            ]
        },
        "FunnelExclusionActionsNode": {
            "additionalProperties": false,
            "properties": {
                "custom_name": {
                    "type": "string"
                },
                "fixedProperties": {
                    "description": "Fixed properties in the query, can't be edited in the interface (e.g. scoping down by person)",
                    "items": {
                        "$ref": "#/definitions/AnyPropertyFilter"
                    },
                    "type": "array"
                },
                "funnelFromStep": {
                    "$ref": "#/definitions/integer"
                },
                "funnelToStep": {
                    "$ref": "#/definitions/integer"
                },
                "id": {
                    "$ref": "#/definitions/integer"
                },
                "kind": {
                    "const": "ActionsNode",
                    "type": "string"
                },
                "math": {
                    "$ref": "#/definitions/MathType"
                },
                "math_group_type_index": {
                    "enum": [0, 1, 2, 3, 4],
                    "type": "number"
                },
                "math_hogql": {
                    "type": "string"
                },
                "math_property": {
                    "type": "string"
                },
                "math_property_revenue_currency": {
                    "$ref": "#/definitions/RevenueCurrencyPropertyConfig"
                },
                "math_property_type": {
                    "type": "string"
                },
                "name": {
                    "type": "string"
                },
                "properties": {
                    "description": "Properties configurable in the interface",
                    "items": {
                        "$ref": "#/definitions/AnyPropertyFilter"
                    },
                    "type": "array"
                },
                "response": {
                    "type": "object"
                }
            },
            "required": ["funnelFromStep", "funnelToStep", "id", "kind"],
            "type": "object"
        },
        "FunnelExclusionEventsNode": {
            "additionalProperties": false,
            "properties": {
                "custom_name": {
                    "type": "string"
                },
                "event": {
                    "description": "The event or `null` for all events.",
                    "type": ["string", "null"]
                },
                "fixedProperties": {
                    "description": "Fixed properties in the query, can't be edited in the interface (e.g. scoping down by person)",
                    "items": {
                        "$ref": "#/definitions/AnyPropertyFilter"
                    },
                    "type": "array"
                },
                "funnelFromStep": {
                    "$ref": "#/definitions/integer"
                },
                "funnelToStep": {
                    "$ref": "#/definitions/integer"
                },
                "kind": {
                    "const": "EventsNode",
                    "type": "string"
                },
                "limit": {
                    "$ref": "#/definitions/integer"
                },
                "math": {
                    "$ref": "#/definitions/MathType"
                },
                "math_group_type_index": {
                    "enum": [0, 1, 2, 3, 4],
                    "type": "number"
                },
                "math_hogql": {
                    "type": "string"
                },
                "math_property": {
                    "type": "string"
                },
                "math_property_revenue_currency": {
                    "$ref": "#/definitions/RevenueCurrencyPropertyConfig"
                },
                "math_property_type": {
                    "type": "string"
                },
                "name": {
                    "type": "string"
                },
                "orderBy": {
                    "description": "Columns to order by",
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                },
                "properties": {
                    "description": "Properties configurable in the interface",
                    "items": {
                        "$ref": "#/definitions/AnyPropertyFilter"
                    },
                    "type": "array"
                },
                "response": {
                    "type": "object"
                }
            },
            "required": ["funnelFromStep", "funnelToStep", "kind"],
            "type": "object"
        },
        "FunnelExclusionLegacy": {
            "additionalProperties": false,
            "properties": {
                "custom_name": {
                    "type": ["string", "null"]
                },
                "funnel_from_step": {
                    "type": "number"
                },
                "funnel_to_step": {
                    "type": "number"
                },
                "id": {
                    "type": ["string", "number", "null"]
                },
                "index": {
                    "type": "number"
                },
                "name": {
                    "type": ["string", "null"]
                },
                "order": {
                    "type": "number"
                },
                "type": {
                    "$ref": "#/definitions/EntityType"
                }
            },
            "required": ["funnel_from_step", "funnel_to_step"],
            "type": "object"
        },
        "FunnelExclusionSteps": {
            "additionalProperties": false,
            "properties": {
                "funnelFromStep": {
                    "$ref": "#/definitions/integer"
                },
                "funnelToStep": {
                    "$ref": "#/definitions/integer"
                }
            },
            "required": ["funnelFromStep", "funnelToStep"],
            "type": "object"
        },
        "FunnelLayout": {
            "enum": ["horizontal", "vertical"],
            "type": "string"
        },
        "FunnelMathType": {
            "enum": ["total", "first_time_for_user", "first_time_for_user_with_filters"],
            "type": "string"
        },
        "FunnelPathType": {
            "enum": ["funnel_path_before_step", "funnel_path_between_steps", "funnel_path_after_step"],
            "type": "string"
        },
        "FunnelPathsFilter": {
            "additionalProperties": false,
            "properties": {
                "funnelPathType": {
                    "$ref": "#/definitions/FunnelPathType"
                },
                "funnelSource": {
                    "$ref": "#/definitions/FunnelsQuery"
                },
                "funnelStep": {
                    "$ref": "#/definitions/integer"
                }
            },
            "required": ["funnelSource"],
            "type": "object"
        },
        "FunnelStepReference": {
            "enum": ["total", "previous"],
            "type": "string"
        },
        "FunnelStepsBreakdownResults": {
            "items": {
                "items": {
                    "type": "object"
                },
                "type": "array"
            },
            "type": "array"
        },
        "FunnelStepsResults": {
            "items": {
                "type": "object"
            },
            "type": "array"
        },
        "FunnelTimeToConvertResults": {
            "additionalProperties": false,
            "properties": {
                "average_conversion_time": {
                    "type": ["number", "null"]
                },
                "bins": {
                    "items": {
                        "items": {
                            "type": "integer"
                        },
                        "maxItems": 2,
                        "minItems": 2,
                        "type": "array"
                    },
                    "type": "array"
                }
            },
            "required": ["average_conversion_time", "bins"],
            "type": "object"
        },
        "FunnelTrendsResults": {
            "items": {
                "type": "object"
            },
            "type": "array"
        },
        "FunnelVizType": {
            "enum": ["steps", "time_to_convert", "trends"],
            "type": "string"
        },
        "FunnelsActorsQuery": {
            "additionalProperties": false,
            "properties": {
                "funnelCustomSteps": {
                    "description": "Custom step numbers to get persons for. This overrides `funnelStep`. Primarily for correlation use.",
                    "items": {
                        "$ref": "#/definitions/integer"
                    },
                    "type": "array"
                },
                "funnelStep": {
                    "$ref": "#/definitions/integer",
                    "description": "Index of the step for which we want to get the timestamp for, per person. Positive for converted persons, negative for dropped of persons."
                },
                "funnelStepBreakdown": {
                    "$ref": "#/definitions/BreakdownKeyType",
                    "description": "The breakdown value for which to get persons for. This is an array for person and event properties, a string for groups and an integer for cohorts."
                },
                "funnelTrendsDropOff": {
                    "type": "boolean"
                },
                "funnelTrendsEntrancePeriodStart": {
                    "description": "Used together with `funnelTrendsDropOff` for funnels time conversion date for the persons modal.",
                    "type": "string"
                },
                "includeRecordings": {
                    "type": "boolean"
                },
                "kind": {
                    "const": "FunnelsActorsQuery",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "response": {
                    "$ref": "#/definitions/ActorsQueryResponse"
                },
                "source": {
                    "$ref": "#/definitions/FunnelsQuery"
                }
            },
            "required": ["kind", "source"],
            "type": "object"
        },
        "FunnelsFilter": {
            "additionalProperties": false,
            "properties": {
                "binCount": {
                    "type": "integer"
                },
                "breakdownAttributionType": {
                    "$ref": "#/definitions/BreakdownAttributionType",
                    "default": "first_touch"
                },
                "breakdownAttributionValue": {
                    "$ref": "#/definitions/integer"
                },
                "exclusions": {
                    "default": [],
                    "items": {
                        "$ref": "#/definitions/FunnelExclusion"
                    },
                    "type": "array"
                },
                "funnelAggregateByHogQL": {
                    "type": "string"
                },
                "funnelFromStep": {
                    "$ref": "#/definitions/integer"
                },
                "funnelOrderType": {
                    "$ref": "#/definitions/StepOrderValue",
                    "default": "ordered"
                },
                "funnelStepReference": {
                    "$ref": "#/definitions/FunnelStepReference",
                    "default": "total"
                },
                "funnelToStep": {
                    "$ref": "#/definitions/integer",
                    "description": "To select the range of steps for trends & time to convert funnels, 0-indexed"
                },
                "funnelVizType": {
                    "$ref": "#/definitions/FunnelVizType",
                    "default": "steps"
                },
                "funnelWindowInterval": {
                    "$ref": "#/definitions/integer",
                    "default": 14
                },
                "funnelWindowIntervalUnit": {
                    "$ref": "#/definitions/FunnelConversionWindowTimeUnit",
                    "default": "day"
                },
                "hiddenLegendBreakdowns": {
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                },
                "layout": {
                    "$ref": "#/definitions/FunnelLayout",
                    "default": "vertical"
                },
                "resultCustomizations": {
                    "additionalProperties": {
                        "$ref": "#/definitions/ResultCustomizationByValue"
                    },
                    "description": "Customizations for the appearance of result datasets.",
                    "type": "object"
                },
                "useUdf": {
                    "type": "boolean"
                }
            },
            "type": "object"
        },
        "FunnelsFilterLegacy": {
            "additionalProperties": false,
            "description": "`FunnelsFilterType` minus everything inherited from `FilterType` and persons modal related params",
            "properties": {
                "bin_count": {
                    "$ref": "#/definitions/BinCountValue"
                },
                "breakdown_attribution_type": {
                    "$ref": "#/definitions/BreakdownAttributionType"
                },
                "breakdown_attribution_value": {
                    "type": "number"
                },
                "exclusions": {
                    "items": {
                        "$ref": "#/definitions/FunnelExclusionLegacy"
                    },
                    "type": "array"
                },
                "funnel_aggregate_by_hogql": {
                    "type": "string"
                },
                "funnel_from_step": {
                    "type": "number"
                },
                "funnel_order_type": {
                    "$ref": "#/definitions/StepOrderValue"
                },
                "funnel_step_reference": {
                    "$ref": "#/definitions/FunnelStepReference"
                },
                "funnel_to_step": {
                    "type": "number"
                },
                "funnel_viz_type": {
                    "$ref": "#/definitions/FunnelVizType"
                },
                "funnel_window_interval": {
                    "type": "number"
                },
                "funnel_window_interval_unit": {
                    "$ref": "#/definitions/FunnelConversionWindowTimeUnit"
                },
                "hidden_legend_keys": {
                    "additionalProperties": {
                        "anyOf": [
                            {
                                "type": "boolean"
                            },
                            {
                                "not": {}
                            }
                        ]
                    },
                    "type": "object"
                },
                "layout": {
                    "$ref": "#/definitions/FunnelLayout"
                }
            },
            "type": "object"
        },
        "FunnelsQuery": {
            "additionalProperties": false,
            "properties": {
                "aggregation_group_type_index": {
                    "anyOf": [
                        {
                            "$ref": "#/definitions/integer"
                        },
                        {
                            "type": "null"
                        }
                    ],
                    "description": "Groups aggregation"
                },
                "breakdownFilter": {
                    "$ref": "#/definitions/BreakdownFilter",
                    "description": "Breakdown of the events and actions"
                },
                "dataColorTheme": {
                    "description": "Colors used in the insight's visualization",
                    "type": ["number", "null"]
                },
                "dateRange": {
                    "$ref": "#/definitions/DateRange",
                    "description": "Date range for the query"
                },
                "filterTestAccounts": {
                    "default": false,
                    "description": "Exclude internal and test users by applying the respective filters",
                    "type": "boolean"
                },
                "funnelsFilter": {
                    "$ref": "#/definitions/FunnelsFilter",
                    "description": "Properties specific to the funnels insight"
                },
                "interval": {
                    "$ref": "#/definitions/IntervalType",
                    "description": "Granularity of the response. Can be one of `hour`, `day`, `week` or `month`"
                },
                "kind": {
                    "const": "FunnelsQuery",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "properties": {
                    "anyOf": [
                        {
                            "items": {
                                "$ref": "#/definitions/AnyPropertyFilter"
                            },
                            "type": "array"
                        },
                        {
                            "$ref": "#/definitions/PropertyGroupFilter"
                        }
                    ],
                    "default": [],
                    "description": "Property filters for all series"
                },
                "response": {
                    "$ref": "#/definitions/FunnelsQueryResponse"
                },
                "samplingFactor": {
                    "description": "Sampling rate",
                    "type": ["number", "null"]
                },
                "series": {
                    "description": "Events and actions to include",
                    "items": {
                        "$ref": "#/definitions/AnyEntityNode"
                    },
                    "type": "array"
                }
            },
            "required": ["kind", "series"],
            "type": "object"
        },
        "FunnelsQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "isUdf": {
                    "type": "boolean"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "anyOf": [
                        {
                            "$ref": "#/definitions/FunnelStepsResults"
                        },
                        {
                            "$ref": "#/definitions/FunnelStepsBreakdownResults"
                        },
                        {
                            "$ref": "#/definitions/FunnelTimeToConvertResults"
                        },
                        {
                            "$ref": "#/definitions/FunnelTrendsResults"
                        }
                    ]
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                }
            },
            "required": ["results"],
            "type": "object"
        },
        "GenericCachedQueryResponse": {
            "properties": {
                "cache_key": {
                    "type": "string"
                },
                "cache_target_age": {
                    "format": "date-time",
                    "type": "string"
                },
                "calculation_trigger": {
                    "description": "What triggered the calculation of the query, leave empty if user/immediate",
                    "type": "string"
                },
                "is_cached": {
                    "type": "boolean"
                },
                "last_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "next_allowed_client_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "timezone": {
                    "type": "string"
                }
            },
            "required": ["cache_key", "is_cached", "last_refresh", "next_allowed_client_refresh", "timezone"],
            "type": "object"
        },
        "GoalLine": {
            "additionalProperties": false,
            "properties": {
                "borderColor": {
                    "type": "string"
                },
                "displayLabel": {
                    "type": "boolean"
                },
                "label": {
                    "type": "string"
                },
                "value": {
                    "type": "number"
                }
            },
            "required": ["label", "value"],
            "type": "object"
        },
        "GroupMathType": {
            "const": "unique_group",
            "type": "string"
        },
        "GroupPropertyFilter": {
            "additionalProperties": false,
            "properties": {
                "group_type_index": {
                    "anyOf": [
                        {
                            "type": "integer"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "key": {
                    "type": "string"
                },
                "label": {
                    "type": "string"
                },
                "operator": {
                    "$ref": "#/definitions/PropertyOperator"
                },
                "type": {
                    "const": "group",
                    "type": "string"
                },
                "value": {
                    "$ref": "#/definitions/PropertyFilterValue"
                }
            },
            "required": ["key", "operator", "type"],
            "type": "object"
        },
        "GroupsQuery": {
            "additionalProperties": false,
            "properties": {
                "group_type_index": {
                    "$ref": "#/definitions/integer"
                },
                "kind": {
                    "const": "GroupsQuery",
                    "type": "string"
                },
                "limit": {
                    "$ref": "#/definitions/integer"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "offset": {
                    "$ref": "#/definitions/integer"
                },
                "orderBy": {
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                },
                "properties": {
                    "items": {
                        "$ref": "#/definitions/AnyGroupScopeFilter"
                    },
                    "type": "array"
                },
                "response": {
                    "$ref": "#/definitions/GroupsQueryResponse"
                },
                "search": {
                    "type": "string"
                },
                "select": {
                    "items": {
                        "$ref": "#/definitions/HogQLExpression"
                    },
                    "type": "array"
                }
            },
            "required": ["group_type_index", "kind"],
            "type": "object"
        },
        "GroupsQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "columns": {
                    "items": {},
                    "type": "array"
                },
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hasMore": {
                    "type": "boolean"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "kind": {
                    "const": "GroupsQuery",
                    "type": "string"
                },
                "limit": {
                    "$ref": "#/definitions/integer"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "offset": {
                    "$ref": "#/definitions/integer"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "items": {
                        "items": {},
                        "type": "array"
                    },
                    "type": "array"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                },
                "types": {
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                }
            },
            "required": ["columns", "hogql", "kind", "limit", "offset", "results", "types"],
            "type": "object"
        },
        "HasPropertiesNode": {
            "anyOf": [
                {
                    "$ref": "#/definitions/EventsNode"
                },
                {
                    "$ref": "#/definitions/EventsQuery"
                },
                {
                    "$ref": "#/definitions/PersonsNode"
                }
            ]
        },
        "HeatMapQuerySource": {
            "$ref": "#/definitions/EventsNode"
        },
        "HogCompileResponse": {
            "additionalProperties": false,
            "properties": {
                "bytecode": {
                    "items": {},
                    "type": "array"
                },
                "locals": {
                    "items": {},
                    "type": "array"
                }
            },
            "required": ["bytecode", "locals"],
            "type": "object"
        },
        "HogLanguage": {
            "enum": ["hog", "hogJson", "hogQL", "hogQLExpr", "hogTemplate"],
            "type": "string"
        },
        "HogQLASTQuery": {
            "additionalProperties": false,
            "properties": {
                "explain": {
                    "deprecated": "use modifiers.debug instead",
                    "type": "boolean"
                },
                "filters": {
                    "$ref": "#/definitions/HogQLFilters"
                },
                "kind": {
                    "const": "HogQLASTQuery",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "name": {
                    "description": "Client provided name of the query",
                    "type": "string"
                },
                "query": {
                    "type": "object"
                },
                "response": {
                    "$ref": "#/definitions/HogQLQueryResponse"
                },
                "values": {
                    "description": "Constant values that can be referenced with the {placeholder} syntax in the query",
                    "type": "object"
                },
                "variables": {
                    "additionalProperties": {
                        "$ref": "#/definitions/HogQLVariable"
                    },
                    "description": "Variables to be substituted into the query",
                    "type": "object"
                }
            },
            "required": ["kind", "query"],
            "type": "object"
        },
        "HogQLAutocomplete": {
            "additionalProperties": false,
            "properties": {
                "endPosition": {
                    "$ref": "#/definitions/integer",
                    "description": "End position of the editor word"
                },
                "filters": {
                    "$ref": "#/definitions/HogQLFilters",
                    "description": "Table to validate the expression against"
                },
                "globals": {
                    "description": "Global values in scope",
                    "type": "object"
                },
                "kind": {
                    "const": "HogQLAutocomplete",
                    "type": "string"
                },
                "language": {
                    "$ref": "#/definitions/HogLanguage",
                    "description": "Language to validate"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "query": {
                    "description": "Query to validate",
                    "type": "string"
                },
                "response": {
                    "$ref": "#/definitions/HogQLAutocompleteResponse"
                },
                "sourceQuery": {
                    "$ref": "#/definitions/AnyDataNode",
                    "description": "Query in whose context to validate."
                },
                "startPosition": {
                    "$ref": "#/definitions/integer",
                    "description": "Start position of the editor word"
                }
            },
            "required": ["endPosition", "kind", "language", "query", "startPosition"],
            "type": "object"
        },
        "HogQLAutocompleteResponse": {
            "additionalProperties": false,
            "properties": {
                "incomplete_list": {
                    "description": "Whether or not the suggestions returned are complete",
                    "type": "boolean"
                },
                "suggestions": {
                    "items": {
                        "$ref": "#/definitions/AutocompleteCompletionItem"
                    },
                    "type": "array"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                }
            },
            "required": ["suggestions", "incomplete_list"],
            "type": "object"
        },
        "HogQLExpression": {
            "type": "string"
        },
        "HogQLFilters": {
            "additionalProperties": false,
            "description": "Filters object that will be converted to a HogQL {filters} placeholder",
            "properties": {
                "dateRange": {
                    "$ref": "#/definitions/DateRange"
                },
                "filterTestAccounts": {
                    "type": "boolean"
                },
                "properties": {
                    "items": {
                        "$ref": "#/definitions/AnyPropertyFilter"
                    },
                    "type": "array"
                }
            },
            "type": "object"
        },
        "HogQLMathType": {
            "const": "hogql",
            "type": "string"
        },
        "HogQLMetadata": {
            "additionalProperties": false,
            "properties": {
                "debug": {
                    "description": "Enable more verbose output, usually run from the /debug page",
                    "type": "boolean"
                },
                "filters": {
                    "$ref": "#/definitions/HogQLFilters",
                    "description": "Extra filters applied to query via {filters}"
                },
                "globals": {
                    "description": "Extra globals for the query",
                    "type": "object"
                },
                "kind": {
                    "const": "HogQLMetadata",
                    "type": "string"
                },
                "language": {
                    "$ref": "#/definitions/HogLanguage",
                    "description": "Language to validate"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "query": {
                    "description": "Query to validate",
                    "type": "string"
                },
                "response": {
                    "$ref": "#/definitions/HogQLMetadataResponse"
                },
                "sourceQuery": {
                    "$ref": "#/definitions/AnyDataNode",
                    "description": "Query within which \"expr\" and \"template\" are validated. Defaults to \"select * from events\""
                },
                "variables": {
                    "additionalProperties": {
                        "$ref": "#/definitions/HogQLVariable"
                    },
                    "description": "Variables to be subsituted into the query",
                    "type": "object"
                }
            },
            "required": ["kind", "language", "query"],
            "type": "object"
        },
        "HogQLMetadataResponse": {
            "additionalProperties": false,
            "properties": {
                "errors": {
                    "items": {
                        "$ref": "#/definitions/HogQLNotice"
                    },
                    "type": "array"
                },
                "isUsingIndices": {
                    "$ref": "#/definitions/QueryIndexUsage"
                },
                "isValid": {
                    "type": "boolean"
                },
                "notices": {
                    "items": {
                        "$ref": "#/definitions/HogQLNotice"
                    },
                    "type": "array"
                },
                "query": {
                    "type": "string"
                },
                "table_names": {
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                },
                "warnings": {
                    "items": {
                        "$ref": "#/definitions/HogQLNotice"
                    },
                    "type": "array"
                }
            },
            "required": ["errors", "warnings", "notices"],
            "type": "object"
        },
        "HogQLNotice": {
            "additionalProperties": false,
            "properties": {
                "end": {
                    "$ref": "#/definitions/integer"
                },
                "fix": {
                    "type": "string"
                },
                "message": {
                    "type": "string"
                },
                "start": {
                    "$ref": "#/definitions/integer"
                }
            },
            "required": ["message"],
            "type": "object"
        },
        "HogQLPropertyFilter": {
            "additionalProperties": false,
            "properties": {
                "key": {
                    "type": "string"
                },
                "label": {
                    "type": "string"
                },
                "type": {
                    "const": "hogql",
                    "type": "string"
                },
                "value": {
                    "$ref": "#/definitions/PropertyFilterValue"
                }
            },
            "required": ["key", "type"],
            "type": "object"
        },
        "HogQLQuery": {
            "additionalProperties": false,
            "properties": {
                "explain": {
                    "deprecated": "use modifiers.debug instead",
                    "type": "boolean"
                },
                "filters": {
                    "$ref": "#/definitions/HogQLFilters"
                },
                "kind": {
                    "const": "HogQLQuery",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "name": {
                    "description": "Client provided name of the query",
                    "type": "string"
                },
                "query": {
                    "type": "string"
                },
                "response": {
                    "$ref": "#/definitions/HogQLQueryResponse"
                },
                "values": {
                    "description": "Constant values that can be referenced with the {placeholder} syntax in the query",
                    "type": "object"
                },
                "variables": {
                    "additionalProperties": {
                        "$ref": "#/definitions/HogQLVariable"
                    },
                    "description": "Variables to be substituted into the query",
                    "type": "object"
                }
            },
            "required": ["kind", "query"],
            "type": "object"
        },
        "HogQLQueryModifiers": {
            "additionalProperties": false,
            "description": "HogQL Query Options are automatically set per team. However, they can be overridden in the query.",
            "properties": {
                "bounceRateDurationSeconds": {
                    "type": "number"
                },
                "bounceRatePageViewMode": {
                    "enum": ["count_pageviews", "uniq_urls", "uniq_page_screen_autocaptures"],
                    "type": "string"
                },
                "customChannelTypeRules": {
                    "items": {
                        "$ref": "#/definitions/CustomChannelRule"
                    },
                    "type": "array"
                },
                "dataWarehouseEventsModifiers": {
                    "items": {
                        "$ref": "#/definitions/DataWarehouseEventsModifier"
                    },
                    "type": "array"
                },
                "debug": {
                    "type": "boolean"
                },
                "inCohortVia": {
                    "enum": ["auto", "leftjoin", "subquery", "leftjoin_conjoined"],
                    "type": "string"
                },
                "materializationMode": {
                    "enum": ["auto", "legacy_null_as_string", "legacy_null_as_null", "disabled"],
                    "type": "string"
                },
                "optimizeJoinedFilters": {
                    "type": "boolean"
                },
                "personsArgMaxVersion": {
                    "enum": ["auto", "v1", "v2"],
                    "type": "string"
                },
                "personsJoinMode": {
                    "enum": ["inner", "left"],
                    "type": "string"
                },
                "personsOnEventsMode": {
                    "enum": [
                        "disabled",
                        "person_id_no_override_properties_on_events",
                        "person_id_override_properties_on_events",
                        "person_id_override_properties_joined"
                    ],
                    "type": "string"
                },
                "propertyGroupsMode": {
                    "enum": ["enabled", "disabled", "optimized"],
                    "type": "string"
                },
                "s3TableUseInvalidColumns": {
                    "type": "boolean"
                },
                "sessionTableVersion": {
                    "enum": ["auto", "v1", "v2"],
                    "type": "string"
                },
                "sessionsV2JoinMode": {
                    "enum": ["string", "uuid"],
                    "type": "string"
                },
                "useMaterializedViews": {
                    "type": "boolean"
                },
                "usePresortedEventsTable": {
                    "type": "boolean"
                }
            },
            "type": "object"
        },
        "HogQLQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "clickhouse": {
                    "description": "Executed ClickHouse query",
                    "type": "string"
                },
                "columns": {
                    "description": "Returned columns",
                    "items": {},
                    "type": "array"
                },
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "explain": {
                    "description": "Query explanation output",
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                },
                "hasMore": {
                    "type": "boolean"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "limit": {
                    "$ref": "#/definitions/integer"
                },
                "metadata": {
                    "$ref": "#/definitions/HogQLMetadataResponse",
                    "description": "Query metadata output"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "offset": {
                    "$ref": "#/definitions/integer"
                },
                "query": {
                    "description": "Input query string",
                    "type": "string"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "items": {},
                    "type": "array"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                },
                "types": {
                    "description": "Types of returned columns",
                    "items": {},
                    "type": "array"
                }
            },
            "required": ["results"],
            "type": "object"
        },
        "HogQLVariable": {
            "additionalProperties": false,
            "properties": {
                "code_name": {
                    "type": "string"
                },
                "isNull": {
                    "type": "boolean"
                },
                "value": {},
                "variableId": {
                    "type": "string"
                }
            },
            "required": ["variableId", "code_name"],
            "type": "object"
        },
        "HogQuery": {
            "additionalProperties": false,
            "properties": {
                "code": {
                    "type": "string"
                },
                "kind": {
                    "const": "HogQuery",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "response": {
                    "$ref": "#/definitions/HogQueryResponse"
                }
            },
            "required": ["kind"],
            "type": "object"
        },
        "HogQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "bytecode": {
                    "items": {},
                    "type": "array"
                },
                "coloredBytecode": {
                    "items": {},
                    "type": "array"
                },
                "results": {},
                "stdout": {
                    "type": "string"
                }
            },
            "required": ["results"],
            "type": "object"
        },
        "HumanMessage": {
            "additionalProperties": false,
            "properties": {
                "content": {
                    "type": "string"
                },
                "id": {
                    "type": "string"
                },
                "type": {
                    "const": "human",
                    "type": "string"
                }
            },
            "required": ["type", "content"],
            "type": "object"
        },
        "InsightActorsQuery": {
            "additionalProperties": false,
            "properties": {
                "breakdown": {
                    "anyOf": [
                        {
                            "type": "string"
                        },
                        {
                            "$ref": "#/definitions/BreakdownValueInt"
                        },
                        {
                            "items": {
                                "type": "string"
                            },
                            "type": "array"
                        }
                    ]
                },
                "compare": {
                    "enum": ["current", "previous"],
                    "type": "string"
                },
                "day": {
                    "anyOf": [
                        {
                            "type": "string"
                        },
                        {
                            "$ref": "#/definitions/Day"
                        }
                    ]
                },
                "includeRecordings": {
                    "type": "boolean"
                },
                "interval": {
                    "$ref": "#/definitions/integer",
                    "description": "An interval selected out of available intervals in source query."
                },
                "kind": {
                    "const": "InsightActorsQuery",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "response": {
                    "$ref": "#/definitions/ActorsQueryResponse"
                },
                "series": {
                    "$ref": "#/definitions/integer"
                },
                "source": {
                    "$ref": "#/definitions/InsightQuerySource"
                },
                "status": {
                    "type": "string"
                }
            },
            "required": ["kind", "source"],
            "type": "object"
        },
        "InsightActorsQueryBase": {
            "additionalProperties": false,
            "properties": {
                "includeRecordings": {
                    "type": "boolean"
                },
                "kind": {
                    "$ref": "#/definitions/NodeKind"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "response": {
                    "$ref": "#/definitions/ActorsQueryResponse"
                }
            },
            "required": ["kind"],
            "type": "object"
        },
        "InsightActorsQueryOptions": {
            "additionalProperties": false,
            "properties": {
                "kind": {
                    "const": "InsightActorsQueryOptions",
                    "type": "string"
                },
                "response": {
                    "$ref": "#/definitions/InsightActorsQueryOptionsResponse"
                },
                "source": {
                    "anyOf": [
                        {
                            "$ref": "#/definitions/InsightActorsQuery"
                        },
                        {
                            "$ref": "#/definitions/FunnelsActorsQuery"
                        },
                        {
                            "$ref": "#/definitions/FunnelCorrelationActorsQuery"
                        },
                        {
                            "$ref": "#/definitions/StickinessActorsQuery"
                        }
                    ]
                }
            },
            "required": ["kind", "source"],
            "type": "object"
        },
        "InsightActorsQueryOptionsResponse": {
            "additionalProperties": false,
            "properties": {
                "breakdown": {
                    "items": {
                        "$ref": "#/definitions/BreakdownItem"
                    },
                    "type": "array"
                },
                "breakdowns": {
                    "items": {
                        "$ref": "#/definitions/MultipleBreakdownOptions"
                    },
                    "type": "array"
                },
                "compare": {
                    "items": {
                        "additionalProperties": false,
                        "properties": {
                            "label": {
                                "type": "string"
                            },
                            "value": {
                                "type": "string"
                            }
                        },
                        "required": ["label", "value"],
                        "type": "object"
                    },
                    "type": "array"
                },
                "day": {
                    "items": {
                        "additionalProperties": false,
                        "properties": {
                            "label": {
                                "type": "string"
                            },
                            "value": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "$ref": "#/definitions/DatetimeDay"
                                    },
                                    {
                                        "$ref": "#/definitions/Day"
                                    }
                                ]
                            }
                        },
                        "required": ["label", "value"],
                        "type": "object"
                    },
                    "type": "array"
                },
                "interval": {
                    "items": {
                        "additionalProperties": false,
                        "properties": {
                            "label": {
                                "type": "string"
                            },
                            "value": {
                                "$ref": "#/definitions/integer",
                                "description": "An interval selected out of available intervals in source query"
                            }
                        },
                        "required": ["label", "value"],
                        "type": "object"
                    },
                    "type": "array"
                },
                "series": {
                    "items": {
                        "additionalProperties": false,
                        "properties": {
                            "label": {
                                "type": "string"
                            },
                            "value": {
                                "$ref": "#/definitions/integer"
                            }
                        },
                        "required": ["label", "value"],
                        "type": "object"
                    },
                    "type": "array"
                },
                "status": {
                    "items": {
                        "additionalProperties": false,
                        "properties": {
                            "label": {
                                "type": "string"
                            },
                            "value": {
                                "type": "string"
                            }
                        },
                        "required": ["label", "value"],
                        "type": "object"
                    },
                    "type": "array"
                }
            },
            "type": "object"
        },
        "InsightFilter": {
            "anyOf": [
                {
                    "$ref": "#/definitions/TrendsFilter"
                },
                {
                    "$ref": "#/definitions/FunnelsFilter"
                },
                {
                    "$ref": "#/definitions/RetentionFilter"
                },
                {
                    "$ref": "#/definitions/PathsFilter"
                },
                {
                    "$ref": "#/definitions/StickinessFilter"
                },
                {
                    "$ref": "#/definitions/LifecycleFilter"
                }
            ]
        },
        "InsightFilterProperty": {
            "enum": [
                "trendsFilter",
                "funnelsFilter",
                "retentionFilter",
                "pathsFilter",
                "stickinessFilter",
                "lifecycleFilter"
            ],
            "type": "string"
        },
        "InsightNodeKind": {
            "enum": [
                "TrendsQuery",
                "FunnelsQuery",
                "RetentionQuery",
                "PathsQuery",
                "StickinessQuery",
                "LifecycleQuery"
            ],
            "type": "string"
        },
        "InsightQueryNode": {
            "discriminator": {
                "propertyName": "kind"
            },
            "oneOf": [
                {
                    "$ref": "#/definitions/TrendsQuery"
                },
                {
                    "$ref": "#/definitions/FunnelsQuery"
                },
                {
                    "$ref": "#/definitions/RetentionQuery"
                },
                {
                    "$ref": "#/definitions/PathsQuery"
                },
                {
                    "$ref": "#/definitions/StickinessQuery"
                },
                {
                    "$ref": "#/definitions/LifecycleQuery"
                }
            ],
            "required": ["kind"],
            "type": "object"
        },
        "InsightQuerySource": {
            "$ref": "#/definitions/InsightQueryNode"
        },
        "InsightShortId": {
            "type": "string"
        },
        "InsightThreshold": {
            "additionalProperties": false,
            "properties": {
                "bounds": {
                    "$ref": "#/definitions/InsightsThresholdBounds"
                },
                "type": {
                    "$ref": "#/definitions/InsightThresholdType"
                }
            },
            "required": ["type"],
            "type": "object"
        },
        "InsightThresholdType": {
            "enum": ["absolute", "percentage"],
            "type": "string"
        },
        "InsightVizNode": {
            "additionalProperties": false,
            "properties": {
                "embedded": {
                    "description": "Query is embedded inside another bordered component",
                    "type": "boolean"
                },
                "full": {
                    "description": "Show with most visual options enabled. Used in insight scene.",
                    "type": "boolean"
                },
                "hidePersonsModal": {
                    "type": "boolean"
                },
                "hideTooltipOnScroll": {
                    "type": "boolean"
                },
                "kind": {
                    "const": "InsightVizNode",
                    "type": "string"
                },
                "showCorrelationTable": {
                    "type": "boolean"
                },
                "showFilters": {
                    "type": "boolean"
                },
                "showHeader": {
                    "type": "boolean"
                },
                "showLastComputation": {
                    "type": "boolean"
                },
                "showLastComputationRefresh": {
                    "type": "boolean"
                },
                "showResults": {
                    "type": "boolean"
                },
                "showTable": {
                    "type": "boolean"
                },
                "source": {
                    "$ref": "#/definitions/InsightQueryNode"
                },
                "suppressSessionAnalysisWarning": {
                    "type": "boolean"
                },
                "vizSpecificOptions": {
                    "$ref": "#/definitions/VizSpecificOptions"
                }
            },
            "required": ["kind", "source"],
            "type": "object"
        },
        "InsightsQueryBase<FunnelsQueryResponse>": {
            "additionalProperties": false,
            "description": "Base class for insight query nodes. Should not be used directly.",
            "properties": {
                "aggregation_group_type_index": {
                    "anyOf": [
                        {
                            "$ref": "#/definitions/integer"
                        },
                        {
                            "type": "null"
                        }
                    ],
                    "description": "Groups aggregation"
                },
                "dataColorTheme": {
                    "description": "Colors used in the insight's visualization",
                    "type": ["number", "null"]
                },
                "dateRange": {
                    "$ref": "#/definitions/DateRange",
                    "description": "Date range for the query"
                },
                "filterTestAccounts": {
                    "default": false,
                    "description": "Exclude internal and test users by applying the respective filters",
                    "type": "boolean"
                },
                "kind": {
                    "$ref": "#/definitions/NodeKind"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "properties": {
                    "anyOf": [
                        {
                            "items": {
                                "$ref": "#/definitions/AnyPropertyFilter"
                            },
                            "type": "array"
                        },
                        {
                            "$ref": "#/definitions/PropertyGroupFilter"
                        }
                    ],
                    "default": [],
                    "description": "Property filters for all series"
                },
                "response": {
                    "$ref": "#/definitions/FunnelsQueryResponse"
                },
                "samplingFactor": {
                    "description": "Sampling rate",
                    "type": ["number", "null"]
                }
            },
            "required": ["kind"],
            "type": "object"
        },
        "InsightsQueryBase<LifecycleQueryResponse>": {
            "additionalProperties": false,
            "description": "Base class for insight query nodes. Should not be used directly.",
            "properties": {
                "aggregation_group_type_index": {
                    "anyOf": [
                        {
                            "$ref": "#/definitions/integer"
                        },
                        {
                            "type": "null"
                        }
                    ],
                    "description": "Groups aggregation"
                },
                "dataColorTheme": {
                    "description": "Colors used in the insight's visualization",
                    "type": ["number", "null"]
                },
                "dateRange": {
                    "$ref": "#/definitions/DateRange",
                    "description": "Date range for the query"
                },
                "filterTestAccounts": {
                    "default": false,
                    "description": "Exclude internal and test users by applying the respective filters",
                    "type": "boolean"
                },
                "kind": {
                    "$ref": "#/definitions/NodeKind"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "properties": {
                    "anyOf": [
                        {
                            "items": {
                                "$ref": "#/definitions/AnyPropertyFilter"
                            },
                            "type": "array"
                        },
                        {
                            "$ref": "#/definitions/PropertyGroupFilter"
                        }
                    ],
                    "default": [],
                    "description": "Property filters for all series"
                },
                "response": {
                    "$ref": "#/definitions/LifecycleQueryResponse"
                },
                "samplingFactor": {
                    "description": "Sampling rate",
                    "type": ["number", "null"]
                }
            },
            "required": ["kind"],
            "type": "object"
        },
        "InsightsQueryBase<PathsQueryResponse>": {
            "additionalProperties": false,
            "description": "Base class for insight query nodes. Should not be used directly.",
            "properties": {
                "aggregation_group_type_index": {
                    "anyOf": [
                        {
                            "$ref": "#/definitions/integer"
                        },
                        {
                            "type": "null"
                        }
                    ],
                    "description": "Groups aggregation"
                },
                "dataColorTheme": {
                    "description": "Colors used in the insight's visualization",
                    "type": ["number", "null"]
                },
                "dateRange": {
                    "$ref": "#/definitions/DateRange",
                    "description": "Date range for the query"
                },
                "filterTestAccounts": {
                    "default": false,
                    "description": "Exclude internal and test users by applying the respective filters",
                    "type": "boolean"
                },
                "kind": {
                    "$ref": "#/definitions/NodeKind"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "properties": {
                    "anyOf": [
                        {
                            "items": {
                                "$ref": "#/definitions/AnyPropertyFilter"
                            },
                            "type": "array"
                        },
                        {
                            "$ref": "#/definitions/PropertyGroupFilter"
                        }
                    ],
                    "default": [],
                    "description": "Property filters for all series"
                },
                "response": {
                    "$ref": "#/definitions/PathsQueryResponse"
                },
                "samplingFactor": {
                    "description": "Sampling rate",
                    "type": ["number", "null"]
                }
            },
            "required": ["kind"],
            "type": "object"
        },
        "InsightsQueryBase<RetentionQueryResponse>": {
            "additionalProperties": false,
            "description": "Base class for insight query nodes. Should not be used directly.",
            "properties": {
                "aggregation_group_type_index": {
                    "anyOf": [
                        {
                            "$ref": "#/definitions/integer"
                        },
                        {
                            "type": "null"
                        }
                    ],
                    "description": "Groups aggregation"
                },
                "dataColorTheme": {
                    "description": "Colors used in the insight's visualization",
                    "type": ["number", "null"]
                },
                "dateRange": {
                    "$ref": "#/definitions/DateRange",
                    "description": "Date range for the query"
                },
                "filterTestAccounts": {
                    "default": false,
                    "description": "Exclude internal and test users by applying the respective filters",
                    "type": "boolean"
                },
                "kind": {
                    "$ref": "#/definitions/NodeKind"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "properties": {
                    "anyOf": [
                        {
                            "items": {
                                "$ref": "#/definitions/AnyPropertyFilter"
                            },
                            "type": "array"
                        },
                        {
                            "$ref": "#/definitions/PropertyGroupFilter"
                        }
                    ],
                    "default": [],
                    "description": "Property filters for all series"
                },
                "response": {
                    "$ref": "#/definitions/RetentionQueryResponse"
                },
                "samplingFactor": {
                    "description": "Sampling rate",
                    "type": ["number", "null"]
                }
            },
            "required": ["kind"],
            "type": "object"
        },
        "InsightsQueryBase<TrendsQueryResponse>": {
            "additionalProperties": false,
            "description": "Base class for insight query nodes. Should not be used directly.",
            "properties": {
                "aggregation_group_type_index": {
                    "anyOf": [
                        {
                            "$ref": "#/definitions/integer"
                        },
                        {
                            "type": "null"
                        }
                    ],
                    "description": "Groups aggregation"
                },
                "dataColorTheme": {
                    "description": "Colors used in the insight's visualization",
                    "type": ["number", "null"]
                },
                "dateRange": {
                    "$ref": "#/definitions/DateRange",
                    "description": "Date range for the query"
                },
                "filterTestAccounts": {
                    "default": false,
                    "description": "Exclude internal and test users by applying the respective filters",
                    "type": "boolean"
                },
                "kind": {
                    "$ref": "#/definitions/NodeKind"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "properties": {
                    "anyOf": [
                        {
                            "items": {
                                "$ref": "#/definitions/AnyPropertyFilter"
                            },
                            "type": "array"
                        },
                        {
                            "$ref": "#/definitions/PropertyGroupFilter"
                        }
                    ],
                    "default": [],
                    "description": "Property filters for all series"
                },
                "response": {
                    "$ref": "#/definitions/TrendsQueryResponse"
                },
                "samplingFactor": {
                    "description": "Sampling rate",
                    "type": ["number", "null"]
                }
            },
            "required": ["kind"],
            "type": "object"
        },
        "InsightsThresholdBounds": {
            "additionalProperties": false,
            "properties": {
                "lower": {
                    "type": "number"
                },
                "upper": {
                    "type": "number"
                }
            },
            "type": "object"
        },
        "IntervalType": {
            "enum": ["minute", "hour", "day", "week", "month"],
            "type": "string"
        },
        "LLMTrace": {
            "additionalProperties": false,
            "properties": {
                "createdAt": {
                    "type": "string"
                },
                "events": {
                    "items": {
                        "$ref": "#/definitions/LLMTraceEvent"
                    },
                    "type": "array"
                },
                "id": {
                    "type": "string"
                },
                "inputCost": {
                    "type": "number"
                },
                "inputState": {},
                "inputTokens": {
                    "type": "number"
                },
                "outputCost": {
                    "type": "number"
                },
                "outputState": {},
                "outputTokens": {
                    "type": "number"
                },
                "person": {
                    "$ref": "#/definitions/LLMTracePerson"
                },
                "totalCost": {
                    "type": "number"
                },
                "totalLatency": {
                    "type": "number"
                },
                "traceName": {
                    "type": "string"
                }
            },
            "required": ["id", "createdAt", "person", "events"],
            "type": "object"
        },
        "LLMTraceEvent": {
            "additionalProperties": false,
            "properties": {
                "createdAt": {
                    "type": "string"
                },
                "event": {
                    "type": "string"
                },
                "id": {
                    "type": "string"
                },
                "properties": {
                    "type": "object"
                }
            },
            "required": ["id", "event", "properties", "createdAt"],
            "type": "object"
        },
        "LLMTracePerson": {
            "additionalProperties": false,
            "properties": {
                "created_at": {
                    "type": "string"
                },
                "distinct_id": {
                    "type": "string"
                },
                "properties": {
                    "type": "object"
                },
                "uuid": {
                    "type": "string"
                }
            },
            "required": ["uuid", "created_at", "properties", "distinct_id"],
            "type": "object"
        },
        "LifecycleFilter": {
            "additionalProperties": false,
            "properties": {
                "showLegend": {
                    "default": false,
                    "type": "boolean"
                },
                "showValuesOnSeries": {
                    "type": "boolean"
                },
                "toggledLifecycles": {
                    "items": {
                        "$ref": "#/definitions/LifecycleToggle"
                    },
                    "type": "array"
                }
            },
            "type": "object"
        },
        "LifecycleFilterLegacy": {
            "additionalProperties": false,
            "description": "`LifecycleFilterType` minus everything inherited from `FilterType`",
            "properties": {
                "show_legend": {
                    "type": "boolean"
                },
                "show_values_on_series": {
                    "type": "boolean"
                },
                "toggledLifecycles": {
                    "items": {
                        "$ref": "#/definitions/LifecycleToggle"
                    },
                    "type": "array"
                }
            },
            "type": "object"
        },
        "LifecycleQuery": {
            "additionalProperties": false,
            "properties": {
                "aggregation_group_type_index": {
                    "anyOf": [
                        {
                            "$ref": "#/definitions/integer"
                        },
                        {
                            "type": "null"
                        }
                    ],
                    "description": "Groups aggregation"
                },
                "dataColorTheme": {
                    "description": "Colors used in the insight's visualization",
                    "type": ["number", "null"]
                },
                "dateRange": {
                    "$ref": "#/definitions/DateRange",
                    "description": "Date range for the query"
                },
                "filterTestAccounts": {
                    "default": false,
                    "description": "Exclude internal and test users by applying the respective filters",
                    "type": "boolean"
                },
                "interval": {
                    "$ref": "#/definitions/IntervalType",
                    "default": "day",
                    "description": "Granularity of the response. Can be one of `hour`, `day`, `week` or `month`"
                },
                "kind": {
                    "const": "LifecycleQuery",
                    "type": "string"
                },
                "lifecycleFilter": {
                    "$ref": "#/definitions/LifecycleFilter",
                    "description": "Properties specific to the lifecycle insight"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "properties": {
                    "anyOf": [
                        {
                            "items": {
                                "$ref": "#/definitions/AnyPropertyFilter"
                            },
                            "type": "array"
                        },
                        {
                            "$ref": "#/definitions/PropertyGroupFilter"
                        }
                    ],
                    "default": [],
                    "description": "Property filters for all series"
                },
                "response": {
                    "$ref": "#/definitions/LifecycleQueryResponse"
                },
                "samplingFactor": {
                    "description": "Sampling rate",
                    "type": ["number", "null"]
                },
                "series": {
                    "description": "Events and actions to include",
                    "items": {
                        "$ref": "#/definitions/AnyEntityNode"
                    },
                    "type": "array"
                }
            },
            "required": ["kind", "series"],
            "type": "object"
        },
        "LifecycleQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "items": {
                        "type": "object"
                    },
                    "type": "array"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                }
            },
            "required": ["results"],
            "type": "object"
        },
        "LifecycleToggle": {
            "enum": ["new", "resurrecting", "returning", "dormant"],
            "type": "string"
        },
        "LogEntryPropertyFilter": {
            "additionalProperties": false,
            "properties": {
                "key": {
                    "type": "string"
                },
                "label": {
                    "type": "string"
                },
                "operator": {
                    "$ref": "#/definitions/PropertyOperator"
                },
                "type": {
                    "const": "log_entry",
                    "type": "string"
                },
                "value": {
                    "$ref": "#/definitions/PropertyFilterValue"
                }
            },
            "required": ["key", "operator", "type"],
            "type": "object"
        },
        "MatchedRecording": {
            "additionalProperties": false,
            "properties": {
                "events": {
                    "items": {
                        "$ref": "#/definitions/MatchedRecordingEvent"
                    },
                    "type": "array"
                },
                "session_id": {
                    "type": "string"
                }
            },
            "required": ["events"],
            "type": "object"
        },
        "MatchedRecordingEvent": {
            "additionalProperties": false,
            "properties": {
                "uuid": {
                    "type": "string"
                }
            },
            "required": ["uuid"],
            "type": "object"
        },
        "MathType": {
            "anyOf": [
                {
                    "$ref": "#/definitions/BaseMathType"
                },
                {
                    "$ref": "#/definitions/FunnelMathType"
                },
                {
                    "$ref": "#/definitions/PropertyMathType"
                },
                {
                    "$ref": "#/definitions/CountPerActorMathType"
                },
                {
                    "$ref": "#/definitions/GroupMathType"
                },
                {
                    "$ref": "#/definitions/HogQLMathType"
                },
                {
                    "$ref": "#/definitions/ExperimentMetricMathType"
                }
            ]
        },
        "MaxInnerUniversalFiltersGroup": {
            "additionalProperties": false,
            "properties": {
                "type": {
                    "$ref": "#/definitions/FilterLogicalOperator"
                },
                "values": {
                    "items": {
                        "$ref": "#/definitions/MaxUniversalFilterValue"
                    },
                    "type": "array"
                }
            },
            "required": ["type", "values"],
            "type": "object"
        },
        "MaxOuterUniversalFiltersGroup": {
            "additionalProperties": false,
            "properties": {
                "type": {
                    "$ref": "#/definitions/FilterLogicalOperator"
                },
                "values": {
                    "items": {
                        "$ref": "#/definitions/MaxInnerUniversalFiltersGroup"
                    },
                    "type": "array"
                }
            },
            "required": ["type", "values"],
            "type": "object"
        },
        "MaxRecordingUniversalFilters": {
            "additionalProperties": false,
            "properties": {
                "date_from": {
                    "type": ["string", "null"]
                },
                "date_to": {
                    "type": ["string", "null"]
                },
                "duration": {
                    "items": {
                        "$ref": "#/definitions/RecordingDurationFilter"
                    },
                    "type": "array"
                },
                "filter_group": {
                    "$ref": "#/definitions/MaxOuterUniversalFiltersGroup"
                },
                "filter_test_accounts": {
                    "type": "boolean"
                },
                "order": {
                    "$ref": "#/definitions/RecordingOrder",
                    "default": "start_time"
                }
            },
            "required": ["duration", "filter_group"],
            "type": "object"
        },
        "MaxUniversalFilterValue": {
            "anyOf": [
                {
                    "$ref": "#/definitions/EventPropertyFilter"
                },
                {
                    "$ref": "#/definitions/PersonPropertyFilter"
                },
                {
                    "$ref": "#/definitions/SessionPropertyFilter"
                },
                {
                    "$ref": "#/definitions/RecordingPropertyFilter"
                }
            ]
        },
        "MultipleBreakdownOptions": {
            "additionalProperties": false,
            "properties": {
                "values": {
                    "items": {
                        "$ref": "#/definitions/BreakdownItem"
                    },
                    "type": "array"
                }
            },
            "required": ["values"],
            "type": "object"
        },
        "MultipleBreakdownType": {
            "enum": ["person", "event", "event_metadata", "group", "session", "hogql"],
            "type": "string"
        },
        "NodeKind": {
            "description": "PostHog Query Schema definition.\n\nThis file acts as the source of truth for:\n\n- frontend/src/queries/schema.json   - generated from typescript via \"pnpm --filter=@posthog/frontend run schema:build:json\"\n\n- posthog/schema.py   - generated from json the above json via \"pnpm -w run schema:build:python\"",
            "enum": [
                "EventsNode",
                "ActionsNode",
                "DataWarehouseNode",
                "EventsQuery",
                "PersonsNode",
                "HogQuery",
                "HogQLQuery",
                "HogQLASTQuery",
                "HogQLMetadata",
                "HogQLAutocomplete",
                "ActorsQuery",
                "GroupsQuery",
                "FunnelsActorsQuery",
                "FunnelCorrelationActorsQuery",
                "SessionsTimelineQuery",
                "RecordingsQuery",
                "SessionAttributionExplorerQuery",
                "RevenueExampleEventsQuery",
                "RevenueExampleDataWarehouseTablesQuery",
                "ErrorTrackingQuery",
                "DataTableNode",
                "DataVisualizationNode",
                "SavedInsightNode",
                "InsightVizNode",
                "TrendsQuery",
                "FunnelsQuery",
                "RetentionQuery",
                "PathsQuery",
                "StickinessQuery",
                "LifecycleQuery",
                "InsightActorsQuery",
                "InsightActorsQueryOptions",
                "FunnelCorrelationQuery",
                "WebOverviewQuery",
                "WebStatsTableQuery",
                "WebExternalClicksTableQuery",
                "WebGoalsQuery",
                "WebVitalsQuery",
                "WebVitalsPathBreakdownQuery",
                "WebPageURLSearchQuery",
                "EventsHeatMapQuery",
                "RevenueAnalyticsOverviewQuery",
                "RevenueAnalyticsGrowthRateQuery",
                "RevenueAnalyticsTopCustomersQuery",
                "ExperimentMetric",
                "ExperimentQuery",
                "ExperimentExposureQuery",
                "ExperimentEventExposureConfig",
                "ExperimentTrendsQuery",
                "ExperimentFunnelsQuery",
                "ExperimentDataWarehouseNode",
                "DatabaseSchemaQuery",
                "SuggestedQuestionsQuery",
                "TeamTaxonomyQuery",
                "EventTaxonomyQuery",
                "ActorsPropertyTaxonomyQuery",
                "TracesQuery",
                "VectorSearchQuery"
            ],
            "type": "string"
        },
        "PageURL": {
            "additionalProperties": false,
            "properties": {
                "count": {
                    "type": "number"
                },
                "url": {
                    "type": "string"
                }
            },
            "required": ["url", "count"],
            "type": "object"
        },
        "PathCleaningFilter": {
            "additionalProperties": false,
            "properties": {
                "alias": {
                    "type": "string"
                },
                "regex": {
                    "type": "string"
                }
            },
            "type": "object"
        },
        "PathType": {
            "enum": ["$pageview", "$screen", "custom_event", "hogql"],
            "type": "string"
        },
        "PathsFilter": {
            "additionalProperties": false,
            "properties": {
                "edgeLimit": {
                    "$ref": "#/definitions/integer",
                    "default": 50
                },
                "endPoint": {
                    "type": "string"
                },
                "excludeEvents": {
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                },
                "includeEventTypes": {
                    "items": {
                        "$ref": "#/definitions/PathType"
                    },
                    "type": "array"
                },
                "localPathCleaningFilters": {
                    "anyOf": [
                        {
                            "items": {
                                "$ref": "#/definitions/PathCleaningFilter"
                            },
                            "type": "array"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "maxEdgeWeight": {
                    "type": "integer"
                },
                "minEdgeWeight": {
                    "type": "integer"
                },
                "pathDropoffKey": {
                    "description": "Relevant only within actors query",
                    "type": "string"
                },
                "pathEndKey": {
                    "description": "Relevant only within actors query",
                    "type": "string"
                },
                "pathGroupings": {
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                },
                "pathReplacements": {
                    "type": "boolean"
                },
                "pathStartKey": {
                    "description": "Relevant only within actors query",
                    "type": "string"
                },
                "pathsHogQLExpression": {
                    "type": "string"
                },
                "startPoint": {
                    "type": "string"
                },
                "stepLimit": {
                    "$ref": "#/definitions/integer",
                    "default": 5
                }
            },
            "type": "object"
        },
        "PathsFilterLegacy": {
            "additionalProperties": false,
            "description": "`PathsFilterType` minus everything inherited from `FilterType` and persons modal related params",
            "properties": {
                "edge_limit": {
                    "type": "integer"
                },
                "end_point": {
                    "type": "string"
                },
                "exclude_events": {
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                },
                "funnel_filter": {
                    "type": "object"
                },
                "funnel_paths": {
                    "$ref": "#/definitions/FunnelPathType"
                },
                "include_event_types": {
                    "items": {
                        "$ref": "#/definitions/PathType"
                    },
                    "type": "array"
                },
                "local_path_cleaning_filters": {
                    "anyOf": [
                        {
                            "items": {
                                "$ref": "#/definitions/PathCleaningFilter"
                            },
                            "type": "array"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "max_edge_weight": {
                    "type": "integer"
                },
                "min_edge_weight": {
                    "type": "integer"
                },
                "path_groupings": {
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                },
                "path_replacements": {
                    "type": "boolean"
                },
                "path_type": {
                    "$ref": "#/definitions/PathType"
                },
                "paths_hogql_expression": {
                    "type": "string"
                },
                "start_point": {
                    "type": "string"
                },
                "step_limit": {
                    "type": "integer"
                }
            },
            "type": "object"
        },
        "PathsLink": {
            "additionalProperties": false,
            "properties": {
                "average_conversion_time": {
                    "type": "number"
                },
                "source": {
                    "type": "string"
                },
                "target": {
                    "type": "string"
                },
                "value": {
                    "type": "number"
                }
            },
            "required": ["source", "target", "value", "average_conversion_time"],
            "type": "object"
        },
        "PathsQuery": {
            "additionalProperties": false,
            "properties": {
                "aggregation_group_type_index": {
                    "anyOf": [
                        {
                            "$ref": "#/definitions/integer"
                        },
                        {
                            "type": "null"
                        }
                    ],
                    "description": "Groups aggregation"
                },
                "dataColorTheme": {
                    "description": "Colors used in the insight's visualization",
                    "type": ["number", "null"]
                },
                "dateRange": {
                    "$ref": "#/definitions/DateRange",
                    "description": "Date range for the query"
                },
                "filterTestAccounts": {
                    "default": false,
                    "description": "Exclude internal and test users by applying the respective filters",
                    "type": "boolean"
                },
                "funnelPathsFilter": {
                    "$ref": "#/definitions/FunnelPathsFilter",
                    "description": "Used for displaying paths in relation to funnel steps."
                },
                "kind": {
                    "const": "PathsQuery",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "pathsFilter": {
                    "$ref": "#/definitions/PathsFilter",
                    "description": "Properties specific to the paths insight"
                },
                "properties": {
                    "anyOf": [
                        {
                            "items": {
                                "$ref": "#/definitions/AnyPropertyFilter"
                            },
                            "type": "array"
                        },
                        {
                            "$ref": "#/definitions/PropertyGroupFilter"
                        }
                    ],
                    "default": [],
                    "description": "Property filters for all series"
                },
                "response": {
                    "$ref": "#/definitions/PathsQueryResponse"
                },
                "samplingFactor": {
                    "description": "Sampling rate",
                    "type": ["number", "null"]
                }
            },
            "required": ["kind", "pathsFilter"],
            "type": "object"
        },
        "PathsQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "items": {
                        "$ref": "#/definitions/PathsLink"
                    },
                    "type": "array"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                }
            },
            "required": ["results"],
            "type": "object"
        },
        "PersonPropertyFilter": {
            "additionalProperties": false,
            "description": "Sync with plugin-server/src/types.ts",
            "properties": {
                "key": {
                    "type": "string"
                },
                "label": {
                    "type": "string"
                },
                "operator": {
                    "$ref": "#/definitions/PropertyOperator"
                },
                "type": {
                    "const": "person",
                    "description": "Person properties",
                    "type": "string"
                },
                "value": {
                    "$ref": "#/definitions/PropertyFilterValue"
                }
            },
            "required": ["key", "operator", "type"],
            "type": "object"
        },
        "PersonType": {
            "additionalProperties": false,
            "properties": {
                "created_at": {
                    "type": "string"
                },
                "distinct_ids": {
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                },
                "id": {
                    "type": "string"
                },
                "is_identified": {
                    "type": "boolean"
                },
                "name": {
                    "type": "string"
                },
                "properties": {
                    "type": "object"
                },
                "uuid": {
                    "type": "string"
                }
            },
            "required": ["distinct_ids", "properties"],
            "type": "object"
        },
        "PersonsNode": {
            "additionalProperties": false,
            "deprecated": "Use `ActorsQuery` instead.",
            "properties": {
                "cohort": {
                    "$ref": "#/definitions/integer"
                },
                "distinctId": {
                    "type": "string"
                },
                "fixedProperties": {
                    "description": "Fixed properties in the query, can't be edited in the interface (e.g. scoping down by person)",
                    "items": {
                        "$ref": "#/definitions/AnyPropertyFilter"
                    },
                    "type": "array"
                },
                "kind": {
                    "const": "PersonsNode",
                    "type": "string"
                },
                "limit": {
                    "$ref": "#/definitions/integer"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "offset": {
                    "$ref": "#/definitions/integer"
                },
                "properties": {
                    "description": "Properties configurable in the interface",
                    "items": {
                        "$ref": "#/definitions/AnyPropertyFilter"
                    },
                    "type": "array"
                },
                "response": {
                    "type": "object"
                },
                "search": {
                    "type": "string"
                }
            },
            "required": ["kind"],
            "type": "object"
        },
        "PropertyFilterBaseValue": {
            "anyOf": [
                {
                    "type": "string"
                },
                {
                    "type": "number"
                },
                {
                    "$ref": "#/definitions/ErrorTrackingIssueAssignee"
                }
            ]
        },
        "PropertyFilterType": {
            "enum": [
                "meta",
                "event",
                "event_metadata",
                "person",
                "element",
                "feature",
                "session",
                "cohort",
                "recording",
                "log_entry",
                "group",
                "hogql",
                "data_warehouse",
                "data_warehouse_person_property",
                "error_tracking_issue"
            ],
            "type": "string"
        },
        "PropertyFilterValue": {
            "anyOf": [
                {
                    "$ref": "#/definitions/PropertyFilterBaseValue"
                },
                {
                    "items": {
                        "$ref": "#/definitions/PropertyFilterBaseValue"
                    },
                    "type": "array"
                },
                {
                    "type": "null"
                }
            ]
        },
        "PropertyGroupFilter": {
            "additionalProperties": false,
            "properties": {
                "type": {
                    "$ref": "#/definitions/FilterLogicalOperator"
                },
                "values": {
                    "items": {
                        "$ref": "#/definitions/PropertyGroupFilterValue"
                    },
                    "type": "array"
                }
            },
            "required": ["type", "values"],
            "type": "object"
        },
        "PropertyGroupFilterValue": {
            "additionalProperties": false,
            "properties": {
                "type": {
                    "$ref": "#/definitions/FilterLogicalOperator"
                },
                "values": {
                    "items": {
                        "anyOf": [
                            {
                                "$ref": "#/definitions/AnyPropertyFilter"
                            },
                            {
                                "$ref": "#/definitions/PropertyGroupFilterValue"
                            }
                        ]
                    },
                    "type": "array"
                }
            },
            "required": ["type", "values"],
            "type": "object"
        },
        "PropertyMathType": {
            "enum": ["avg", "sum", "min", "max", "median", "p75", "p90", "p95", "p99"],
            "type": "string"
        },
        "PropertyOperator": {
            "description": "Sync with plugin-server/src/types.ts",
            "enum": [
                "exact",
                "is_not",
                "icontains",
                "not_icontains",
                "regex",
                "not_regex",
                "gt",
                "gte",
                "lt",
                "lte",
                "is_set",
                "is_not_set",
                "is_date_exact",
                "is_date_before",
                "is_date_after",
                "between",
                "not_between",
                "min",
                "max",
                "in",
                "not_in",
                "is_cleaned_path_exact"
            ],
            "type": "string"
        },
        "QueryIndexUsage": {
            "enum": ["undecisive", "no", "partial", "yes"],
            "type": "string"
        },
        "QueryRequest": {
            "additionalProperties": false,
            "properties": {
                "async": {
                    "deprecated": "Use `refresh` instead.",
                    "type": "boolean"
                },
                "client_query_id": {
                    "description": "Client provided query ID. Can be used to retrieve the status or cancel the query.",
                    "type": "string"
                },
                "filters_override": {
                    "$ref": "#/definitions/DashboardFilter"
                },
                "query": {
                    "$ref": "#/definitions/QuerySchema",
                    "description": "Submit a JSON string representing a query for PostHog data analysis, for example a HogQL query.\n\nExample payload:\n\n```\n\n{\"query\": {\"kind\": \"HogQLQuery\", \"query\": \"select * from events limit 100\"}}\n\n```\n\nFor more details on HogQL queries, see the [PostHog HogQL documentation](/docs/hogql#api-access)."
                },
                "refresh": {
                    "$ref": "#/definitions/RefreshType",
                    "default": "blocking",
                    "description": "Whether results should be calculated sync or async, and how much to rely on the cache:\n- `'blocking'` - calculate synchronously (returning only when the query is done), UNLESS there are very fresh results in the cache\n- `'async'` - kick off background calculation (returning immediately with a query status), UNLESS there are very fresh results in the cache\n- `'lazy_async'` - kick off background calculation, UNLESS there are somewhat fresh results in the cache\n- `'force_blocking'` - calculate synchronously, even if fresh results are already cached\n- `'force_async'` - kick off background calculation, even if fresh results are already cached\n- `'force_cache'` - return cached data or a cache miss; always completes immediately as it never calculates Background calculation can be tracked using the `query_status` response field."
                },
                "variables_override": {
                    "additionalProperties": {
                        "type": "object"
                    },
                    "type": "object"
                }
            },
            "required": ["query"],
            "type": "object"
        },
        "QueryResponseAlternative": {
            "anyOf": [
                {
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "columns": {
                            "items": {},
                            "type": "array"
                        },
                        "error": {
                            "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                            "type": "string"
                        },
                        "hasMore": {
                            "type": "boolean"
                        },
                        "hogql": {
                            "description": "Generated HogQL query.",
                            "type": "string"
                        },
                        "limit": {
                            "$ref": "#/definitions/integer"
                        },
                        "modifiers": {
                            "$ref": "#/definitions/HogQLQueryModifiers",
                            "description": "Modifiers used when performing the query"
                        },
                        "offset": {
                            "$ref": "#/definitions/integer"
                        },
                        "query_status": {
                            "$ref": "#/definitions/QueryStatus",
                            "description": "Query status indicates whether next to the provided data, a query is still running."
                        },
                        "results": {
                            "items": {
                                "items": {},
                                "type": "array"
                            },
                            "type": "array"
                        },
                        "timings": {
                            "description": "Measured timings for different parts of the query generation process",
                            "items": {
                                "$ref": "#/definitions/QueryTiming"
                            },
                            "type": "array"
                        },
                        "types": {
                            "items": {
                                "type": "string"
                            },
                            "type": "array"
                        }
                    },
                    "required": ["columns", "hogql", "results", "types"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "columns": {
                            "items": {},
                            "type": "array"
                        },
                        "error": {
                            "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                            "type": "string"
                        },
                        "hasMore": {
                            "type": "boolean"
                        },
                        "hogql": {
                            "description": "Generated HogQL query.",
                            "type": "string"
                        },
                        "limit": {
                            "$ref": "#/definitions/integer"
                        },
                        "missing_actors_count": {
                            "$ref": "#/definitions/integer"
                        },
                        "modifiers": {
                            "$ref": "#/definitions/HogQLQueryModifiers",
                            "description": "Modifiers used when performing the query"
                        },
                        "offset": {
                            "$ref": "#/definitions/integer"
                        },
                        "query_status": {
                            "$ref": "#/definitions/QueryStatus",
                            "description": "Query status indicates whether next to the provided data, a query is still running."
                        },
                        "results": {
                            "items": {
                                "items": {},
                                "type": "array"
                            },
                            "type": "array"
                        },
                        "timings": {
                            "description": "Measured timings for different parts of the query generation process",
                            "items": {
                                "$ref": "#/definitions/QueryTiming"
                            },
                            "type": "array"
                        },
                        "types": {
                            "items": {
                                "type": "string"
                            },
                            "type": "array"
                        }
                    },
                    "required": ["columns", "hogql", "limit", "offset", "results", "types"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "columns": {
                            "items": {},
                            "type": "array"
                        },
                        "error": {
                            "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                            "type": "string"
                        },
                        "hasMore": {
                            "type": "boolean"
                        },
                        "hogql": {
                            "description": "Generated HogQL query.",
                            "type": "string"
                        },
                        "kind": {
                            "const": "GroupsQuery",
                            "type": "string"
                        },
                        "limit": {
                            "$ref": "#/definitions/integer"
                        },
                        "modifiers": {
                            "$ref": "#/definitions/HogQLQueryModifiers",
                            "description": "Modifiers used when performing the query"
                        },
                        "offset": {
                            "$ref": "#/definitions/integer"
                        },
                        "query_status": {
                            "$ref": "#/definitions/QueryStatus",
                            "description": "Query status indicates whether next to the provided data, a query is still running."
                        },
                        "results": {
                            "items": {
                                "items": {},
                                "type": "array"
                            },
                            "type": "array"
                        },
                        "timings": {
                            "description": "Measured timings for different parts of the query generation process",
                            "items": {
                                "$ref": "#/definitions/QueryTiming"
                            },
                            "type": "array"
                        },
                        "types": {
                            "items": {
                                "type": "string"
                            },
                            "type": "array"
                        }
                    },
                    "required": ["columns", "hogql", "kind", "limit", "offset", "results", "types"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "breakdown": {
                            "items": {
                                "$ref": "#/definitions/BreakdownItem"
                            },
                            "type": "array"
                        },
                        "breakdowns": {
                            "items": {
                                "$ref": "#/definitions/MultipleBreakdownOptions"
                            },
                            "type": "array"
                        },
                        "compare": {
                            "items": {
                                "additionalProperties": false,
                                "properties": {
                                    "label": {
                                        "type": "string"
                                    },
                                    "value": {
                                        "type": "string"
                                    }
                                },
                                "required": ["label", "value"],
                                "type": "object"
                            },
                            "type": "array"
                        },
                        "day": {
                            "items": {
                                "additionalProperties": false,
                                "properties": {
                                    "label": {
                                        "type": "string"
                                    },
                                    "value": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "$ref": "#/definitions/DatetimeDay"
                                            },
                                            {
                                                "$ref": "#/definitions/Day"
                                            }
                                        ]
                                    }
                                },
                                "required": ["label", "value"],
                                "type": "object"
                            },
                            "type": "array"
                        },
                        "interval": {
                            "items": {
                                "additionalProperties": false,
                                "properties": {
                                    "label": {
                                        "type": "string"
                                    },
                                    "value": {
                                        "$ref": "#/definitions/integer",
                                        "description": "An interval selected out of available intervals in source query"
                                    }
                                },
                                "required": ["label", "value"],
                                "type": "object"
                            },
                            "type": "array"
                        },
                        "series": {
                            "items": {
                                "additionalProperties": false,
                                "properties": {
                                    "label": {
                                        "type": "string"
                                    },
                                    "value": {
                                        "$ref": "#/definitions/integer"
                                    }
                                },
                                "required": ["label", "value"],
                                "type": "object"
                            },
                            "type": "array"
                        },
                        "status": {
                            "items": {
                                "additionalProperties": false,
                                "properties": {
                                    "label": {
                                        "type": "string"
                                    },
                                    "value": {
                                        "type": "string"
                                    }
                                },
                                "required": ["label", "value"],
                                "type": "object"
                            },
                            "type": "array"
                        }
                    },
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "error": {
                            "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                            "type": "string"
                        },
                        "hasMore": {
                            "type": "boolean"
                        },
                        "hogql": {
                            "description": "Generated HogQL query.",
                            "type": "string"
                        },
                        "modifiers": {
                            "$ref": "#/definitions/HogQLQueryModifiers",
                            "description": "Modifiers used when performing the query"
                        },
                        "query_status": {
                            "$ref": "#/definitions/QueryStatus",
                            "description": "Query status indicates whether next to the provided data, a query is still running."
                        },
                        "results": {
                            "items": {
                                "$ref": "#/definitions/TimelineEntry"
                            },
                            "type": "array"
                        },
                        "timings": {
                            "description": "Measured timings for different parts of the query generation process",
                            "items": {
                                "$ref": "#/definitions/QueryTiming"
                            },
                            "type": "array"
                        }
                    },
                    "required": ["results"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "bytecode": {
                            "items": {},
                            "type": "array"
                        },
                        "coloredBytecode": {
                            "items": {},
                            "type": "array"
                        },
                        "results": {},
                        "stdout": {
                            "type": "string"
                        }
                    },
                    "required": ["results"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "clickhouse": {
                            "description": "Executed ClickHouse query",
                            "type": "string"
                        },
                        "columns": {
                            "description": "Returned columns",
                            "items": {},
                            "type": "array"
                        },
                        "error": {
                            "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                            "type": "string"
                        },
                        "explain": {
                            "description": "Query explanation output",
                            "items": {
                                "type": "string"
                            },
                            "type": "array"
                        },
                        "hasMore": {
                            "type": "boolean"
                        },
                        "hogql": {
                            "description": "Generated HogQL query.",
                            "type": "string"
                        },
                        "limit": {
                            "$ref": "#/definitions/integer"
                        },
                        "metadata": {
                            "$ref": "#/definitions/HogQLMetadataResponse",
                            "description": "Query metadata output"
                        },
                        "modifiers": {
                            "$ref": "#/definitions/HogQLQueryModifiers",
                            "description": "Modifiers used when performing the query"
                        },
                        "offset": {
                            "$ref": "#/definitions/integer"
                        },
                        "query": {
                            "description": "Input query string",
                            "type": "string"
                        },
                        "query_status": {
                            "$ref": "#/definitions/QueryStatus",
                            "description": "Query status indicates whether next to the provided data, a query is still running."
                        },
                        "results": {
                            "items": {},
                            "type": "array"
                        },
                        "timings": {
                            "description": "Measured timings for different parts of the query generation process",
                            "items": {
                                "$ref": "#/definitions/QueryTiming"
                            },
                            "type": "array"
                        },
                        "types": {
                            "description": "Types of returned columns",
                            "items": {},
                            "type": "array"
                        }
                    },
                    "required": ["results"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "errors": {
                            "items": {
                                "$ref": "#/definitions/HogQLNotice"
                            },
                            "type": "array"
                        },
                        "isUsingIndices": {
                            "$ref": "#/definitions/QueryIndexUsage"
                        },
                        "isValid": {
                            "type": "boolean"
                        },
                        "notices": {
                            "items": {
                                "$ref": "#/definitions/HogQLNotice"
                            },
                            "type": "array"
                        },
                        "query": {
                            "type": "string"
                        },
                        "table_names": {
                            "items": {
                                "type": "string"
                            },
                            "type": "array"
                        },
                        "warnings": {
                            "items": {
                                "$ref": "#/definitions/HogQLNotice"
                            },
                            "type": "array"
                        }
                    },
                    "required": ["errors", "warnings", "notices"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "incomplete_list": {
                            "description": "Whether or not the suggestions returned are complete",
                            "type": "boolean"
                        },
                        "suggestions": {
                            "items": {
                                "$ref": "#/definitions/AutocompleteCompletionItem"
                            },
                            "type": "array"
                        },
                        "timings": {
                            "description": "Measured timings for different parts of the query generation process",
                            "items": {
                                "$ref": "#/definitions/QueryTiming"
                            },
                            "type": "array"
                        }
                    },
                    "required": ["suggestions", "incomplete_list"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "columns": {
                            "items": {},
                            "type": "array"
                        },
                        "error": {
                            "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                            "type": "string"
                        },
                        "hasMore": {
                            "type": "boolean"
                        },
                        "hogql": {
                            "description": "Generated HogQL query.",
                            "type": "string"
                        },
                        "limit": {
                            "$ref": "#/definitions/integer"
                        },
                        "modifiers": {
                            "$ref": "#/definitions/HogQLQueryModifiers",
                            "description": "Modifiers used when performing the query"
                        },
                        "offset": {
                            "$ref": "#/definitions/integer"
                        },
                        "query_status": {
                            "$ref": "#/definitions/QueryStatus",
                            "description": "Query status indicates whether next to the provided data, a query is still running."
                        },
                        "results": {},
                        "timings": {
                            "description": "Measured timings for different parts of the query generation process",
                            "items": {
                                "$ref": "#/definitions/QueryTiming"
                            },
                            "type": "array"
                        },
                        "types": {
                            "items": {},
                            "type": "array"
                        }
                    },
                    "required": ["results"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "columns": {
                            "items": {},
                            "type": "array"
                        },
                        "error": {
                            "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                            "type": "string"
                        },
                        "hasMore": {
                            "type": "boolean"
                        },
                        "hogql": {
                            "description": "Generated HogQL query.",
                            "type": "string"
                        },
                        "limit": {
                            "$ref": "#/definitions/integer"
                        },
                        "modifiers": {
                            "$ref": "#/definitions/HogQLQueryModifiers",
                            "description": "Modifiers used when performing the query"
                        },
                        "offset": {
                            "$ref": "#/definitions/integer"
                        },
                        "query_status": {
                            "$ref": "#/definitions/QueryStatus",
                            "description": "Query status indicates whether next to the provided data, a query is still running."
                        },
                        "results": {},
                        "timings": {
                            "description": "Measured timings for different parts of the query generation process",
                            "items": {
                                "$ref": "#/definitions/QueryTiming"
                            },
                            "type": "array"
                        },
                        "types": {
                            "items": {},
                            "type": "array"
                        }
                    },
                    "required": ["results"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "columns": {
                            "items": {},
                            "type": "array"
                        },
                        "error": {
                            "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                            "type": "string"
                        },
                        "hasMore": {
                            "type": "boolean"
                        },
                        "hogql": {
                            "description": "Generated HogQL query.",
                            "type": "string"
                        },
                        "limit": {
                            "$ref": "#/definitions/integer"
                        },
                        "modifiers": {
                            "$ref": "#/definitions/HogQLQueryModifiers",
                            "description": "Modifiers used when performing the query"
                        },
                        "offset": {
                            "$ref": "#/definitions/integer"
                        },
                        "query_status": {
                            "$ref": "#/definitions/QueryStatus",
                            "description": "Query status indicates whether next to the provided data, a query is still running."
                        },
                        "results": {},
                        "timings": {
                            "description": "Measured timings for different parts of the query generation process",
                            "items": {
                                "$ref": "#/definitions/QueryTiming"
                            },
                            "type": "array"
                        },
                        "types": {
                            "items": {},
                            "type": "array"
                        }
                    },
                    "required": ["results"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "columns": {
                            "items": {
                                "type": "string"
                            },
                            "type": "array"
                        },
                        "error": {
                            "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                            "type": "string"
                        },
                        "hasMore": {
                            "type": "boolean"
                        },
                        "hogql": {
                            "description": "Generated HogQL query.",
                            "type": "string"
                        },
                        "limit": {
                            "$ref": "#/definitions/integer"
                        },
                        "modifiers": {
                            "$ref": "#/definitions/HogQLQueryModifiers",
                            "description": "Modifiers used when performing the query"
                        },
                        "offset": {
                            "$ref": "#/definitions/integer"
                        },
                        "query_status": {
                            "$ref": "#/definitions/QueryStatus",
                            "description": "Query status indicates whether next to the provided data, a query is still running."
                        },
                        "results": {
                            "items": {
                                "$ref": "#/definitions/ErrorTrackingIssue"
                            },
                            "type": "array"
                        },
                        "timings": {
                            "description": "Measured timings for different parts of the query generation process",
                            "items": {
                                "$ref": "#/definitions/QueryTiming"
                            },
                            "type": "array"
                        }
                    },
                    "required": ["results"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "credible_intervals": {
                            "additionalProperties": {
                                "items": {
                                    "type": "number"
                                },
                                "maxItems": 2,
                                "minItems": 2,
                                "type": "array"
                            },
                            "type": "object"
                        },
                        "expected_loss": {
                            "type": "number"
                        },
                        "funnels_query": {
                            "$ref": "#/definitions/FunnelsQuery"
                        },
                        "insight": {
                            "items": {
                                "items": {
                                    "type": "object"
                                },
                                "type": "array"
                            },
                            "type": "array"
                        },
                        "kind": {
                            "const": "ExperimentFunnelsQuery",
                            "type": "string"
                        },
                        "probability": {
                            "additionalProperties": {
                                "type": "number"
                            },
                            "type": "object"
                        },
                        "significance_code": {
                            "$ref": "#/definitions/ExperimentSignificanceCode"
                        },
                        "significant": {
                            "type": "boolean"
                        },
                        "stats_version": {
                            "$ref": "#/definitions/integer"
                        },
                        "variants": {
                            "items": {
                                "$ref": "#/definitions/ExperimentVariantFunnelsBaseStats"
                            },
                            "type": "array"
                        }
                    },
                    "required": [
                        "kind",
                        "insight",
                        "variants",
                        "probability",
                        "significant",
                        "significance_code",
                        "expected_loss",
                        "credible_intervals"
                    ],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "count_query": {
                            "$ref": "#/definitions/TrendsQuery"
                        },
                        "credible_intervals": {
                            "additionalProperties": {
                                "items": {
                                    "type": "number"
                                },
                                "maxItems": 2,
                                "minItems": 2,
                                "type": "array"
                            },
                            "type": "object"
                        },
                        "exposure_query": {
                            "$ref": "#/definitions/TrendsQuery"
                        },
                        "insight": {
                            "items": {
                                "type": "object"
                            },
                            "type": "array"
                        },
                        "kind": {
                            "const": "ExperimentTrendsQuery",
                            "type": "string"
                        },
                        "p_value": {
                            "type": "number"
                        },
                        "probability": {
                            "additionalProperties": {
                                "type": "number"
                            },
                            "type": "object"
                        },
                        "significance_code": {
                            "$ref": "#/definitions/ExperimentSignificanceCode"
                        },
                        "significant": {
                            "type": "boolean"
                        },
                        "stats_version": {
                            "$ref": "#/definitions/integer"
                        },
                        "variants": {
                            "items": {
                                "$ref": "#/definitions/ExperimentVariantTrendsBaseStats"
                            },
                            "type": "array"
                        }
                    },
                    "required": [
                        "kind",
                        "insight",
                        "variants",
                        "probability",
                        "significant",
                        "significance_code",
                        "p_value",
                        "credible_intervals"
                    ],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "credible_intervals": {
                            "additionalProperties": {
                                "items": {
                                    "type": "number"
                                },
                                "maxItems": 2,
                                "minItems": 2,
                                "type": "array"
                            },
                            "type": "object"
                        },
                        "insight": {
                            "items": {
                                "type": "object"
                            },
                            "type": "array"
                        },
                        "kind": {
                            "const": "ExperimentQuery",
                            "type": "string"
                        },
                        "metric": {
                            "$ref": "#/definitions/ExperimentMetric"
                        },
                        "p_value": {
                            "type": "number"
                        },
                        "probability": {
                            "additionalProperties": {
                                "type": "number"
                            },
                            "type": "object"
                        },
                        "significance_code": {
                            "$ref": "#/definitions/ExperimentSignificanceCode"
                        },
                        "significant": {
                            "type": "boolean"
                        },
                        "stats_version": {
                            "$ref": "#/definitions/integer"
                        },
                        "variants": {
                            "anyOf": [
                                {
                                    "items": {
                                        "$ref": "#/definitions/ExperimentVariantTrendsBaseStats"
                                    },
                                    "type": "array"
                                },
                                {
                                    "items": {
                                        "$ref": "#/definitions/ExperimentVariantFunnelsBaseStats"
                                    },
                                    "type": "array"
                                }
                            ]
                        }
                    },
                    "required": [
                        "kind",
                        "insight",
                        "metric",
                        "variants",
                        "probability",
                        "significant",
                        "significance_code",
                        "p_value",
                        "credible_intervals"
                    ],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "date_range": {
                            "$ref": "#/definitions/DateRange"
                        },
                        "kind": {
                            "const": "ExperimentExposureQuery",
                            "type": "string"
                        },
                        "timeseries": {
                            "items": {
                                "$ref": "#/definitions/ExperimentExposureTimeSeries"
                            },
                            "type": "array"
                        },
                        "total_exposures": {
                            "additionalProperties": {
                                "type": "number"
                            },
                            "type": "object"
                        }
                    },
                    "required": ["kind", "timeseries", "total_exposures", "date_range"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "dateFrom": {
                            "type": "string"
                        },
                        "dateTo": {
                            "type": "string"
                        },
                        "error": {
                            "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                            "type": "string"
                        },
                        "hogql": {
                            "description": "Generated HogQL query.",
                            "type": "string"
                        },
                        "modifiers": {
                            "$ref": "#/definitions/HogQLQueryModifiers",
                            "description": "Modifiers used when performing the query"
                        },
                        "query_status": {
                            "$ref": "#/definitions/QueryStatus",
                            "description": "Query status indicates whether next to the provided data, a query is still running."
                        },
                        "results": {
                            "items": {
                                "$ref": "#/definitions/WebOverviewItem"
                            },
                            "type": "array"
                        },
                        "samplingRate": {
                            "$ref": "#/definitions/SamplingRate"
                        },
                        "timings": {
                            "description": "Measured timings for different parts of the query generation process",
                            "items": {
                                "$ref": "#/definitions/QueryTiming"
                            },
                            "type": "array"
                        }
                    },
                    "required": ["results"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "columns": {
                            "items": {},
                            "type": "array"
                        },
                        "error": {
                            "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                            "type": "string"
                        },
                        "hasMore": {
                            "type": "boolean"
                        },
                        "hogql": {
                            "description": "Generated HogQL query.",
                            "type": "string"
                        },
                        "limit": {
                            "$ref": "#/definitions/integer"
                        },
                        "modifiers": {
                            "$ref": "#/definitions/HogQLQueryModifiers",
                            "description": "Modifiers used when performing the query"
                        },
                        "offset": {
                            "$ref": "#/definitions/integer"
                        },
                        "query_status": {
                            "$ref": "#/definitions/QueryStatus",
                            "description": "Query status indicates whether next to the provided data, a query is still running."
                        },
                        "results": {
                            "items": {},
                            "type": "array"
                        },
                        "samplingRate": {
                            "$ref": "#/definitions/SamplingRate"
                        },
                        "timings": {
                            "description": "Measured timings for different parts of the query generation process",
                            "items": {
                                "$ref": "#/definitions/QueryTiming"
                            },
                            "type": "array"
                        },
                        "types": {
                            "items": {},
                            "type": "array"
                        }
                    },
                    "required": ["results"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "columns": {
                            "items": {},
                            "type": "array"
                        },
                        "error": {
                            "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                            "type": "string"
                        },
                        "hasMore": {
                            "type": "boolean"
                        },
                        "hogql": {
                            "description": "Generated HogQL query.",
                            "type": "string"
                        },
                        "limit": {
                            "$ref": "#/definitions/integer"
                        },
                        "modifiers": {
                            "$ref": "#/definitions/HogQLQueryModifiers",
                            "description": "Modifiers used when performing the query"
                        },
                        "offset": {
                            "$ref": "#/definitions/integer"
                        },
                        "query_status": {
                            "$ref": "#/definitions/QueryStatus",
                            "description": "Query status indicates whether next to the provided data, a query is still running."
                        },
                        "results": {
                            "items": {},
                            "type": "array"
                        },
                        "samplingRate": {
                            "$ref": "#/definitions/SamplingRate"
                        },
                        "timings": {
                            "description": "Measured timings for different parts of the query generation process",
                            "items": {
                                "$ref": "#/definitions/QueryTiming"
                            },
                            "type": "array"
                        },
                        "types": {
                            "items": {},
                            "type": "array"
                        }
                    },
                    "required": ["results"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "columns": {
                            "items": {},
                            "type": "array"
                        },
                        "error": {
                            "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                            "type": "string"
                        },
                        "hasMore": {
                            "type": "boolean"
                        },
                        "hogql": {
                            "description": "Generated HogQL query.",
                            "type": "string"
                        },
                        "limit": {
                            "$ref": "#/definitions/integer"
                        },
                        "modifiers": {
                            "$ref": "#/definitions/HogQLQueryModifiers",
                            "description": "Modifiers used when performing the query"
                        },
                        "offset": {
                            "$ref": "#/definitions/integer"
                        },
                        "query_status": {
                            "$ref": "#/definitions/QueryStatus",
                            "description": "Query status indicates whether next to the provided data, a query is still running."
                        },
                        "results": {
                            "items": {},
                            "type": "array"
                        },
                        "samplingRate": {
                            "$ref": "#/definitions/SamplingRate"
                        },
                        "timings": {
                            "description": "Measured timings for different parts of the query generation process",
                            "items": {
                                "$ref": "#/definitions/QueryTiming"
                            },
                            "type": "array"
                        },
                        "types": {
                            "items": {},
                            "type": "array"
                        }
                    },
                    "required": ["results"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "error": {
                            "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                            "type": "string"
                        },
                        "hogql": {
                            "description": "Generated HogQL query.",
                            "type": "string"
                        },
                        "modifiers": {
                            "$ref": "#/definitions/HogQLQueryModifiers",
                            "description": "Modifiers used when performing the query"
                        },
                        "query_status": {
                            "$ref": "#/definitions/QueryStatus",
                            "description": "Query status indicates whether next to the provided data, a query is still running."
                        },
                        "results": {
                            "items": {
                                "$ref": "#/definitions/WebVitalsPathBreakdownResult"
                            },
                            "maxItems": 1,
                            "minItems": 1,
                            "type": "array"
                        },
                        "timings": {
                            "description": "Measured timings for different parts of the query generation process",
                            "items": {
                                "$ref": "#/definitions/QueryTiming"
                            },
                            "type": "array"
                        }
                    },
                    "required": ["results"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "error": {
                            "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                            "type": "string"
                        },
                        "hasMore": {
                            "type": "boolean"
                        },
                        "hogql": {
                            "description": "Generated HogQL query.",
                            "type": "string"
                        },
                        "limit": {
                            "$ref": "#/definitions/integer"
                        },
                        "modifiers": {
                            "$ref": "#/definitions/HogQLQueryModifiers",
                            "description": "Modifiers used when performing the query"
                        },
                        "query_status": {
                            "$ref": "#/definitions/QueryStatus",
                            "description": "Query status indicates whether next to the provided data, a query is still running."
                        },
                        "results": {
                            "items": {
                                "$ref": "#/definitions/PageURL"
                            },
                            "type": "array"
                        },
                        "timings": {
                            "description": "Measured timings for different parts of the query generation process",
                            "items": {
                                "$ref": "#/definitions/QueryTiming"
                            },
                            "type": "array"
                        }
                    },
                    "required": ["results"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "error": {
                            "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                            "type": "string"
                        },
                        "hasMore": {
                            "type": "boolean"
                        },
                        "hogql": {
                            "description": "Generated HogQL query.",
                            "type": "string"
                        },
                        "limit": {
                            "$ref": "#/definitions/integer"
                        },
                        "modifiers": {
                            "$ref": "#/definitions/HogQLQueryModifiers",
                            "description": "Modifiers used when performing the query"
                        },
                        "query_status": {
                            "$ref": "#/definitions/QueryStatus",
                            "description": "Query status indicates whether next to the provided data, a query is still running."
                        },
                        "results": {
                            "$ref": "#/definitions/EventsHeatMapStructuredResult"
                        },
                        "timings": {
                            "description": "Measured timings for different parts of the query generation process",
                            "items": {
                                "$ref": "#/definitions/QueryTiming"
                            },
                            "type": "array"
                        }
                    },
                    "required": ["results"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "error": {
                            "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                            "type": "string"
                        },
                        "hogql": {
                            "description": "Generated HogQL query.",
                            "type": "string"
                        },
                        "modifiers": {
                            "$ref": "#/definitions/HogQLQueryModifiers",
                            "description": "Modifiers used when performing the query"
                        },
                        "query_status": {
                            "$ref": "#/definitions/QueryStatus",
                            "description": "Query status indicates whether next to the provided data, a query is still running."
                        },
                        "results": {
                            "items": {
                                "$ref": "#/definitions/RevenueAnalyticsOverviewItem"
                            },
                            "type": "array"
                        },
                        "timings": {
                            "description": "Measured timings for different parts of the query generation process",
                            "items": {
                                "$ref": "#/definitions/QueryTiming"
                            },
                            "type": "array"
                        }
                    },
                    "required": ["results"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "columns": {
                            "items": {
                                "type": "string"
                            },
                            "type": "array"
                        },
                        "error": {
                            "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                            "type": "string"
                        },
                        "hogql": {
                            "description": "Generated HogQL query.",
                            "type": "string"
                        },
                        "modifiers": {
                            "$ref": "#/definitions/HogQLQueryModifiers",
                            "description": "Modifiers used when performing the query"
                        },
                        "query_status": {
                            "$ref": "#/definitions/QueryStatus",
                            "description": "Query status indicates whether next to the provided data, a query is still running."
                        },
                        "results": {},
                        "timings": {
                            "description": "Measured timings for different parts of the query generation process",
                            "items": {
                                "$ref": "#/definitions/QueryTiming"
                            },
                            "type": "array"
                        }
                    },
                    "required": ["results"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "columns": {
                            "items": {
                                "type": "string"
                            },
                            "type": "array"
                        },
                        "error": {
                            "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                            "type": "string"
                        },
                        "hogql": {
                            "description": "Generated HogQL query.",
                            "type": "string"
                        },
                        "modifiers": {
                            "$ref": "#/definitions/HogQLQueryModifiers",
                            "description": "Modifiers used when performing the query"
                        },
                        "query_status": {
                            "$ref": "#/definitions/QueryStatus",
                            "description": "Query status indicates whether next to the provided data, a query is still running."
                        },
                        "results": {},
                        "timings": {
                            "description": "Measured timings for different parts of the query generation process",
                            "items": {
                                "$ref": "#/definitions/QueryTiming"
                            },
                            "type": "array"
                        }
                    },
                    "required": ["results"],
                    "type": "object"
                },
                {
                    "properties": {},
                    "type": "object"
                },
                {
                    "not": {}
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "columns": {
                            "items": {},
                            "type": "array"
                        },
                        "error": {
                            "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                            "type": "string"
                        },
                        "hasMore": {
                            "type": "boolean"
                        },
                        "hogql": {
                            "description": "Generated HogQL query.",
                            "type": "string"
                        },
                        "limit": {
                            "$ref": "#/definitions/integer"
                        },
                        "modifiers": {
                            "$ref": "#/definitions/HogQLQueryModifiers",
                            "description": "Modifiers used when performing the query"
                        },
                        "offset": {
                            "$ref": "#/definitions/integer"
                        },
                        "query_status": {
                            "$ref": "#/definitions/QueryStatus",
                            "description": "Query status indicates whether next to the provided data, a query is still running."
                        },
                        "results": {
                            "items": {
                                "items": {},
                                "type": "array"
                            },
                            "type": "array"
                        },
                        "timings": {
                            "description": "Measured timings for different parts of the query generation process",
                            "items": {
                                "$ref": "#/definitions/QueryTiming"
                            },
                            "type": "array"
                        },
                        "types": {
                            "items": {
                                "type": "string"
                            },
                            "type": "array"
                        }
                    },
                    "required": ["columns", "hogql", "results", "types"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "columns": {
                            "items": {},
                            "type": "array"
                        },
                        "error": {
                            "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                            "type": "string"
                        },
                        "hasMore": {
                            "type": "boolean"
                        },
                        "hogql": {
                            "description": "Generated HogQL query.",
                            "type": "string"
                        },
                        "limit": {
                            "$ref": "#/definitions/integer"
                        },
                        "missing_actors_count": {
                            "$ref": "#/definitions/integer"
                        },
                        "modifiers": {
                            "$ref": "#/definitions/HogQLQueryModifiers",
                            "description": "Modifiers used when performing the query"
                        },
                        "offset": {
                            "$ref": "#/definitions/integer"
                        },
                        "query_status": {
                            "$ref": "#/definitions/QueryStatus",
                            "description": "Query status indicates whether next to the provided data, a query is still running."
                        },
                        "results": {
                            "items": {
                                "items": {},
                                "type": "array"
                            },
                            "type": "array"
                        },
                        "timings": {
                            "description": "Measured timings for different parts of the query generation process",
                            "items": {
                                "$ref": "#/definitions/QueryTiming"
                            },
                            "type": "array"
                        },
                        "types": {
                            "items": {
                                "type": "string"
                            },
                            "type": "array"
                        }
                    },
                    "required": ["columns", "hogql", "limit", "offset", "results", "types"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "columns": {
                            "items": {},
                            "type": "array"
                        },
                        "error": {
                            "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                            "type": "string"
                        },
                        "hasMore": {
                            "type": "boolean"
                        },
                        "hogql": {
                            "description": "Generated HogQL query.",
                            "type": "string"
                        },
                        "kind": {
                            "const": "GroupsQuery",
                            "type": "string"
                        },
                        "limit": {
                            "$ref": "#/definitions/integer"
                        },
                        "modifiers": {
                            "$ref": "#/definitions/HogQLQueryModifiers",
                            "description": "Modifiers used when performing the query"
                        },
                        "offset": {
                            "$ref": "#/definitions/integer"
                        },
                        "query_status": {
                            "$ref": "#/definitions/QueryStatus",
                            "description": "Query status indicates whether next to the provided data, a query is still running."
                        },
                        "results": {
                            "items": {
                                "items": {},
                                "type": "array"
                            },
                            "type": "array"
                        },
                        "timings": {
                            "description": "Measured timings for different parts of the query generation process",
                            "items": {
                                "$ref": "#/definitions/QueryTiming"
                            },
                            "type": "array"
                        },
                        "types": {
                            "items": {
                                "type": "string"
                            },
                            "type": "array"
                        }
                    },
                    "required": ["columns", "hogql", "kind", "limit", "offset", "results", "types"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "clickhouse": {
                            "description": "Executed ClickHouse query",
                            "type": "string"
                        },
                        "columns": {
                            "description": "Returned columns",
                            "items": {},
                            "type": "array"
                        },
                        "error": {
                            "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                            "type": "string"
                        },
                        "explain": {
                            "description": "Query explanation output",
                            "items": {
                                "type": "string"
                            },
                            "type": "array"
                        },
                        "hasMore": {
                            "type": "boolean"
                        },
                        "hogql": {
                            "description": "Generated HogQL query.",
                            "type": "string"
                        },
                        "limit": {
                            "$ref": "#/definitions/integer"
                        },
                        "metadata": {
                            "$ref": "#/definitions/HogQLMetadataResponse",
                            "description": "Query metadata output"
                        },
                        "modifiers": {
                            "$ref": "#/definitions/HogQLQueryModifiers",
                            "description": "Modifiers used when performing the query"
                        },
                        "offset": {
                            "$ref": "#/definitions/integer"
                        },
                        "query": {
                            "description": "Input query string",
                            "type": "string"
                        },
                        "query_status": {
                            "$ref": "#/definitions/QueryStatus",
                            "description": "Query status indicates whether next to the provided data, a query is still running."
                        },
                        "results": {
                            "items": {},
                            "type": "array"
                        },
                        "timings": {
                            "description": "Measured timings for different parts of the query generation process",
                            "items": {
                                "$ref": "#/definitions/QueryTiming"
                            },
                            "type": "array"
                        },
                        "types": {
                            "description": "Types of returned columns",
                            "items": {},
                            "type": "array"
                        }
                    },
                    "required": ["results"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "dateFrom": {
                            "type": "string"
                        },
                        "dateTo": {
                            "type": "string"
                        },
                        "error": {
                            "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                            "type": "string"
                        },
                        "hogql": {
                            "description": "Generated HogQL query.",
                            "type": "string"
                        },
                        "modifiers": {
                            "$ref": "#/definitions/HogQLQueryModifiers",
                            "description": "Modifiers used when performing the query"
                        },
                        "query_status": {
                            "$ref": "#/definitions/QueryStatus",
                            "description": "Query status indicates whether next to the provided data, a query is still running."
                        },
                        "results": {
                            "items": {
                                "$ref": "#/definitions/WebOverviewItem"
                            },
                            "type": "array"
                        },
                        "samplingRate": {
                            "$ref": "#/definitions/SamplingRate"
                        },
                        "timings": {
                            "description": "Measured timings for different parts of the query generation process",
                            "items": {
                                "$ref": "#/definitions/QueryTiming"
                            },
                            "type": "array"
                        }
                    },
                    "required": ["results"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "columns": {
                            "items": {},
                            "type": "array"
                        },
                        "error": {
                            "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                            "type": "string"
                        },
                        "hasMore": {
                            "type": "boolean"
                        },
                        "hogql": {
                            "description": "Generated HogQL query.",
                            "type": "string"
                        },
                        "limit": {
                            "$ref": "#/definitions/integer"
                        },
                        "modifiers": {
                            "$ref": "#/definitions/HogQLQueryModifiers",
                            "description": "Modifiers used when performing the query"
                        },
                        "offset": {
                            "$ref": "#/definitions/integer"
                        },
                        "query_status": {
                            "$ref": "#/definitions/QueryStatus",
                            "description": "Query status indicates whether next to the provided data, a query is still running."
                        },
                        "results": {
                            "items": {},
                            "type": "array"
                        },
                        "samplingRate": {
                            "$ref": "#/definitions/SamplingRate"
                        },
                        "timings": {
                            "description": "Measured timings for different parts of the query generation process",
                            "items": {
                                "$ref": "#/definitions/QueryTiming"
                            },
                            "type": "array"
                        },
                        "types": {
                            "items": {},
                            "type": "array"
                        }
                    },
                    "required": ["results"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "columns": {
                            "items": {},
                            "type": "array"
                        },
                        "error": {
                            "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                            "type": "string"
                        },
                        "hasMore": {
                            "type": "boolean"
                        },
                        "hogql": {
                            "description": "Generated HogQL query.",
                            "type": "string"
                        },
                        "limit": {
                            "$ref": "#/definitions/integer"
                        },
                        "modifiers": {
                            "$ref": "#/definitions/HogQLQueryModifiers",
                            "description": "Modifiers used when performing the query"
                        },
                        "offset": {
                            "$ref": "#/definitions/integer"
                        },
                        "query_status": {
                            "$ref": "#/definitions/QueryStatus",
                            "description": "Query status indicates whether next to the provided data, a query is still running."
                        },
                        "results": {
                            "items": {},
                            "type": "array"
                        },
                        "samplingRate": {
                            "$ref": "#/definitions/SamplingRate"
                        },
                        "timings": {
                            "description": "Measured timings for different parts of the query generation process",
                            "items": {
                                "$ref": "#/definitions/QueryTiming"
                            },
                            "type": "array"
                        },
                        "types": {
                            "items": {},
                            "type": "array"
                        }
                    },
                    "required": ["results"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "columns": {
                            "items": {},
                            "type": "array"
                        },
                        "error": {
                            "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                            "type": "string"
                        },
                        "hasMore": {
                            "type": "boolean"
                        },
                        "hogql": {
                            "description": "Generated HogQL query.",
                            "type": "string"
                        },
                        "limit": {
                            "$ref": "#/definitions/integer"
                        },
                        "modifiers": {
                            "$ref": "#/definitions/HogQLQueryModifiers",
                            "description": "Modifiers used when performing the query"
                        },
                        "offset": {
                            "$ref": "#/definitions/integer"
                        },
                        "query_status": {
                            "$ref": "#/definitions/QueryStatus",
                            "description": "Query status indicates whether next to the provided data, a query is still running."
                        },
                        "results": {
                            "items": {},
                            "type": "array"
                        },
                        "samplingRate": {
                            "$ref": "#/definitions/SamplingRate"
                        },
                        "timings": {
                            "description": "Measured timings for different parts of the query generation process",
                            "items": {
                                "$ref": "#/definitions/QueryTiming"
                            },
                            "type": "array"
                        },
                        "types": {
                            "items": {},
                            "type": "array"
                        }
                    },
                    "required": ["results"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "error": {
                            "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                            "type": "string"
                        },
                        "hogql": {
                            "description": "Generated HogQL query.",
                            "type": "string"
                        },
                        "modifiers": {
                            "$ref": "#/definitions/HogQLQueryModifiers",
                            "description": "Modifiers used when performing the query"
                        },
                        "query_status": {
                            "$ref": "#/definitions/QueryStatus",
                            "description": "Query status indicates whether next to the provided data, a query is still running."
                        },
                        "results": {
                            "items": {
                                "$ref": "#/definitions/WebVitalsPathBreakdownResult"
                            },
                            "maxItems": 1,
                            "minItems": 1,
                            "type": "array"
                        },
                        "timings": {
                            "description": "Measured timings for different parts of the query generation process",
                            "items": {
                                "$ref": "#/definitions/QueryTiming"
                            },
                            "type": "array"
                        }
                    },
                    "required": ["results"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "error": {
                            "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                            "type": "string"
                        },
                        "hasMore": {
                            "type": "boolean"
                        },
                        "hogql": {
                            "description": "Generated HogQL query.",
                            "type": "string"
                        },
                        "limit": {
                            "$ref": "#/definitions/integer"
                        },
                        "modifiers": {
                            "$ref": "#/definitions/HogQLQueryModifiers",
                            "description": "Modifiers used when performing the query"
                        },
                        "query_status": {
                            "$ref": "#/definitions/QueryStatus",
                            "description": "Query status indicates whether next to the provided data, a query is still running."
                        },
                        "results": {
                            "$ref": "#/definitions/EventsHeatMapStructuredResult"
                        },
                        "timings": {
                            "description": "Measured timings for different parts of the query generation process",
                            "items": {
                                "$ref": "#/definitions/QueryTiming"
                            },
                            "type": "array"
                        }
                    },
                    "required": ["results"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "columns": {
                            "items": {},
                            "type": "array"
                        },
                        "error": {
                            "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                            "type": "string"
                        },
                        "hasMore": {
                            "type": "boolean"
                        },
                        "hogql": {
                            "description": "Generated HogQL query.",
                            "type": "string"
                        },
                        "limit": {
                            "$ref": "#/definitions/integer"
                        },
                        "modifiers": {
                            "$ref": "#/definitions/HogQLQueryModifiers",
                            "description": "Modifiers used when performing the query"
                        },
                        "offset": {
                            "$ref": "#/definitions/integer"
                        },
                        "query_status": {
                            "$ref": "#/definitions/QueryStatus",
                            "description": "Query status indicates whether next to the provided data, a query is still running."
                        },
                        "results": {},
                        "timings": {
                            "description": "Measured timings for different parts of the query generation process",
                            "items": {
                                "$ref": "#/definitions/QueryTiming"
                            },
                            "type": "array"
                        },
                        "types": {
                            "items": {},
                            "type": "array"
                        }
                    },
                    "required": ["results"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "error": {
                            "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                            "type": "string"
                        },
                        "hogql": {
                            "description": "Generated HogQL query.",
                            "type": "string"
                        },
                        "modifiers": {
                            "$ref": "#/definitions/HogQLQueryModifiers",
                            "description": "Modifiers used when performing the query"
                        },
                        "query_status": {
                            "$ref": "#/definitions/QueryStatus",
                            "description": "Query status indicates whether next to the provided data, a query is still running."
                        },
                        "results": {
                            "items": {
                                "$ref": "#/definitions/RevenueAnalyticsOverviewItem"
                            },
                            "type": "array"
                        },
                        "timings": {
                            "description": "Measured timings for different parts of the query generation process",
                            "items": {
                                "$ref": "#/definitions/QueryTiming"
                            },
                            "type": "array"
                        }
                    },
                    "required": ["results"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "columns": {
                            "items": {
                                "type": "string"
                            },
                            "type": "array"
                        },
                        "error": {
                            "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                            "type": "string"
                        },
                        "hogql": {
                            "description": "Generated HogQL query.",
                            "type": "string"
                        },
                        "modifiers": {
                            "$ref": "#/definitions/HogQLQueryModifiers",
                            "description": "Modifiers used when performing the query"
                        },
                        "query_status": {
                            "$ref": "#/definitions/QueryStatus",
                            "description": "Query status indicates whether next to the provided data, a query is still running."
                        },
                        "results": {},
                        "timings": {
                            "description": "Measured timings for different parts of the query generation process",
                            "items": {
                                "$ref": "#/definitions/QueryTiming"
                            },
                            "type": "array"
                        }
                    },
                    "required": ["results"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "columns": {
                            "items": {
                                "type": "string"
                            },
                            "type": "array"
                        },
                        "error": {
                            "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                            "type": "string"
                        },
                        "hogql": {
                            "description": "Generated HogQL query.",
                            "type": "string"
                        },
                        "modifiers": {
                            "$ref": "#/definitions/HogQLQueryModifiers",
                            "description": "Modifiers used when performing the query"
                        },
                        "query_status": {
                            "$ref": "#/definitions/QueryStatus",
                            "description": "Query status indicates whether next to the provided data, a query is still running."
                        },
                        "results": {},
                        "timings": {
                            "description": "Measured timings for different parts of the query generation process",
                            "items": {
                                "$ref": "#/definitions/QueryTiming"
                            },
                            "type": "array"
                        }
                    },
                    "required": ["results"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "columns": {
                            "items": {},
                            "type": "array"
                        },
                        "error": {
                            "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                            "type": "string"
                        },
                        "hasMore": {
                            "type": "boolean"
                        },
                        "hogql": {
                            "description": "Generated HogQL query.",
                            "type": "string"
                        },
                        "limit": {
                            "$ref": "#/definitions/integer"
                        },
                        "modifiers": {
                            "$ref": "#/definitions/HogQLQueryModifiers",
                            "description": "Modifiers used when performing the query"
                        },
                        "offset": {
                            "$ref": "#/definitions/integer"
                        },
                        "query_status": {
                            "$ref": "#/definitions/QueryStatus",
                            "description": "Query status indicates whether next to the provided data, a query is still running."
                        },
                        "results": {},
                        "timings": {
                            "description": "Measured timings for different parts of the query generation process",
                            "items": {
                                "$ref": "#/definitions/QueryTiming"
                            },
                            "type": "array"
                        },
                        "types": {
                            "items": {},
                            "type": "array"
                        }
                    },
                    "required": ["results"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "columns": {
                            "items": {},
                            "type": "array"
                        },
                        "error": {
                            "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                            "type": "string"
                        },
                        "hasMore": {
                            "type": "boolean"
                        },
                        "hogql": {
                            "description": "Generated HogQL query.",
                            "type": "string"
                        },
                        "limit": {
                            "$ref": "#/definitions/integer"
                        },
                        "modifiers": {
                            "$ref": "#/definitions/HogQLQueryModifiers",
                            "description": "Modifiers used when performing the query"
                        },
                        "offset": {
                            "$ref": "#/definitions/integer"
                        },
                        "query_status": {
                            "$ref": "#/definitions/QueryStatus",
                            "description": "Query status indicates whether next to the provided data, a query is still running."
                        },
                        "results": {},
                        "timings": {
                            "description": "Measured timings for different parts of the query generation process",
                            "items": {
                                "$ref": "#/definitions/QueryTiming"
                            },
                            "type": "array"
                        },
                        "types": {
                            "items": {},
                            "type": "array"
                        }
                    },
                    "required": ["results"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "columns": {
                            "items": {
                                "type": "string"
                            },
                            "type": "array"
                        },
                        "error": {
                            "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                            "type": "string"
                        },
                        "hasMore": {
                            "type": "boolean"
                        },
                        "hogql": {
                            "description": "Generated HogQL query.",
                            "type": "string"
                        },
                        "limit": {
                            "$ref": "#/definitions/integer"
                        },
                        "modifiers": {
                            "$ref": "#/definitions/HogQLQueryModifiers",
                            "description": "Modifiers used when performing the query"
                        },
                        "offset": {
                            "$ref": "#/definitions/integer"
                        },
                        "query_status": {
                            "$ref": "#/definitions/QueryStatus",
                            "description": "Query status indicates whether next to the provided data, a query is still running."
                        },
                        "results": {
                            "items": {
                                "$ref": "#/definitions/ErrorTrackingIssue"
                            },
                            "type": "array"
                        },
                        "timings": {
                            "description": "Measured timings for different parts of the query generation process",
                            "items": {
                                "$ref": "#/definitions/QueryTiming"
                            },
                            "type": "array"
                        }
                    },
                    "required": ["results"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "credible_intervals": {
                            "additionalProperties": {
                                "items": {
                                    "type": "number"
                                },
                                "maxItems": 2,
                                "minItems": 2,
                                "type": "array"
                            },
                            "type": "object"
                        },
                        "expected_loss": {
                            "type": "number"
                        },
                        "funnels_query": {
                            "$ref": "#/definitions/FunnelsQuery"
                        },
                        "insight": {
                            "items": {
                                "items": {
                                    "type": "object"
                                },
                                "type": "array"
                            },
                            "type": "array"
                        },
                        "kind": {
                            "const": "ExperimentFunnelsQuery",
                            "type": "string"
                        },
                        "probability": {
                            "additionalProperties": {
                                "type": "number"
                            },
                            "type": "object"
                        },
                        "significance_code": {
                            "$ref": "#/definitions/ExperimentSignificanceCode"
                        },
                        "significant": {
                            "type": "boolean"
                        },
                        "stats_version": {
                            "$ref": "#/definitions/integer"
                        },
                        "variants": {
                            "items": {
                                "$ref": "#/definitions/ExperimentVariantFunnelsBaseStats"
                            },
                            "type": "array"
                        }
                    },
                    "required": [
                        "credible_intervals",
                        "expected_loss",
                        "insight",
                        "kind",
                        "probability",
                        "significance_code",
                        "significant",
                        "variants"
                    ],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "count_query": {
                            "$ref": "#/definitions/TrendsQuery"
                        },
                        "credible_intervals": {
                            "additionalProperties": {
                                "items": {
                                    "type": "number"
                                },
                                "maxItems": 2,
                                "minItems": 2,
                                "type": "array"
                            },
                            "type": "object"
                        },
                        "exposure_query": {
                            "$ref": "#/definitions/TrendsQuery"
                        },
                        "insight": {
                            "items": {
                                "type": "object"
                            },
                            "type": "array"
                        },
                        "kind": {
                            "const": "ExperimentTrendsQuery",
                            "type": "string"
                        },
                        "p_value": {
                            "type": "number"
                        },
                        "probability": {
                            "additionalProperties": {
                                "type": "number"
                            },
                            "type": "object"
                        },
                        "significance_code": {
                            "$ref": "#/definitions/ExperimentSignificanceCode"
                        },
                        "significant": {
                            "type": "boolean"
                        },
                        "stats_version": {
                            "$ref": "#/definitions/integer"
                        },
                        "variants": {
                            "items": {
                                "$ref": "#/definitions/ExperimentVariantTrendsBaseStats"
                            },
                            "type": "array"
                        }
                    },
                    "required": [
                        "credible_intervals",
                        "insight",
                        "kind",
                        "p_value",
                        "probability",
                        "significance_code",
                        "significant",
                        "variants"
                    ],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "columns": {
                            "items": {
                                "type": "string"
                            },
                            "type": "array"
                        },
                        "error": {
                            "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                            "type": "string"
                        },
                        "hasMore": {
                            "type": "boolean"
                        },
                        "hogql": {
                            "description": "Generated HogQL query.",
                            "type": "string"
                        },
                        "limit": {
                            "$ref": "#/definitions/integer"
                        },
                        "modifiers": {
                            "$ref": "#/definitions/HogQLQueryModifiers",
                            "description": "Modifiers used when performing the query"
                        },
                        "offset": {
                            "$ref": "#/definitions/integer"
                        },
                        "query_status": {
                            "$ref": "#/definitions/QueryStatus",
                            "description": "Query status indicates whether next to the provided data, a query is still running."
                        },
                        "results": {
                            "items": {
                                "$ref": "#/definitions/LLMTrace"
                            },
                            "type": "array"
                        },
                        "timings": {
                            "description": "Measured timings for different parts of the query generation process",
                            "items": {
                                "$ref": "#/definitions/QueryTiming"
                            },
                            "type": "array"
                        }
                    },
                    "required": ["results"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "error": {
                            "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                            "type": "string"
                        },
                        "hasMore": {
                            "description": "Wether more breakdown values are available.",
                            "type": "boolean"
                        },
                        "hogql": {
                            "description": "Generated HogQL query.",
                            "type": "string"
                        },
                        "modifiers": {
                            "$ref": "#/definitions/HogQLQueryModifiers",
                            "description": "Modifiers used when performing the query"
                        },
                        "query_status": {
                            "$ref": "#/definitions/QueryStatus",
                            "description": "Query status indicates whether next to the provided data, a query is still running."
                        },
                        "results": {
                            "items": {
                                "type": "object"
                            },
                            "type": "array"
                        },
                        "timings": {
                            "description": "Measured timings for different parts of the query generation process",
                            "items": {
                                "$ref": "#/definitions/QueryTiming"
                            },
                            "type": "array"
                        }
                    },
                    "required": ["results"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "error": {
                            "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                            "type": "string"
                        },
                        "hogql": {
                            "description": "Generated HogQL query.",
                            "type": "string"
                        },
                        "isUdf": {
                            "type": "boolean"
                        },
                        "modifiers": {
                            "$ref": "#/definitions/HogQLQueryModifiers",
                            "description": "Modifiers used when performing the query"
                        },
                        "query_status": {
                            "$ref": "#/definitions/QueryStatus",
                            "description": "Query status indicates whether next to the provided data, a query is still running."
                        },
                        "results": {
                            "anyOf": [
                                {
                                    "$ref": "#/definitions/FunnelStepsResults"
                                },
                                {
                                    "$ref": "#/definitions/FunnelStepsBreakdownResults"
                                },
                                {
                                    "$ref": "#/definitions/FunnelTimeToConvertResults"
                                },
                                {
                                    "$ref": "#/definitions/FunnelTrendsResults"
                                }
                            ]
                        },
                        "timings": {
                            "description": "Measured timings for different parts of the query generation process",
                            "items": {
                                "$ref": "#/definitions/QueryTiming"
                            },
                            "type": "array"
                        }
                    },
                    "required": ["results"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "error": {
                            "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                            "type": "string"
                        },
                        "hogql": {
                            "description": "Generated HogQL query.",
                            "type": "string"
                        },
                        "modifiers": {
                            "$ref": "#/definitions/HogQLQueryModifiers",
                            "description": "Modifiers used when performing the query"
                        },
                        "query_status": {
                            "$ref": "#/definitions/QueryStatus",
                            "description": "Query status indicates whether next to the provided data, a query is still running."
                        },
                        "results": {
                            "items": {
                                "$ref": "#/definitions/RetentionResult"
                            },
                            "type": "array"
                        },
                        "timings": {
                            "description": "Measured timings for different parts of the query generation process",
                            "items": {
                                "$ref": "#/definitions/QueryTiming"
                            },
                            "type": "array"
                        }
                    },
                    "required": ["results"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "error": {
                            "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                            "type": "string"
                        },
                        "hogql": {
                            "description": "Generated HogQL query.",
                            "type": "string"
                        },
                        "modifiers": {
                            "$ref": "#/definitions/HogQLQueryModifiers",
                            "description": "Modifiers used when performing the query"
                        },
                        "query_status": {
                            "$ref": "#/definitions/QueryStatus",
                            "description": "Query status indicates whether next to the provided data, a query is still running."
                        },
                        "results": {
                            "items": {
                                "$ref": "#/definitions/PathsLink"
                            },
                            "type": "array"
                        },
                        "timings": {
                            "description": "Measured timings for different parts of the query generation process",
                            "items": {
                                "$ref": "#/definitions/QueryTiming"
                            },
                            "type": "array"
                        }
                    },
                    "required": ["results"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "error": {
                            "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                            "type": "string"
                        },
                        "hogql": {
                            "description": "Generated HogQL query.",
                            "type": "string"
                        },
                        "modifiers": {
                            "$ref": "#/definitions/HogQLQueryModifiers",
                            "description": "Modifiers used when performing the query"
                        },
                        "query_status": {
                            "$ref": "#/definitions/QueryStatus",
                            "description": "Query status indicates whether next to the provided data, a query is still running."
                        },
                        "results": {
                            "items": {
                                "type": "object"
                            },
                            "type": "array"
                        },
                        "timings": {
                            "description": "Measured timings for different parts of the query generation process",
                            "items": {
                                "$ref": "#/definitions/QueryTiming"
                            },
                            "type": "array"
                        }
                    },
                    "required": ["results"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "error": {
                            "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                            "type": "string"
                        },
                        "hogql": {
                            "description": "Generated HogQL query.",
                            "type": "string"
                        },
                        "modifiers": {
                            "$ref": "#/definitions/HogQLQueryModifiers",
                            "description": "Modifiers used when performing the query"
                        },
                        "query_status": {
                            "$ref": "#/definitions/QueryStatus",
                            "description": "Query status indicates whether next to the provided data, a query is still running."
                        },
                        "results": {
                            "items": {
                                "type": "object"
                            },
                            "type": "array"
                        },
                        "timings": {
                            "description": "Measured timings for different parts of the query generation process",
                            "items": {
                                "$ref": "#/definitions/QueryTiming"
                            },
                            "type": "array"
                        }
                    },
                    "required": ["results"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "columns": {
                            "items": {},
                            "type": "array"
                        },
                        "error": {
                            "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                            "type": "string"
                        },
                        "hasMore": {
                            "type": "boolean"
                        },
                        "hogql": {
                            "description": "Generated HogQL query.",
                            "type": "string"
                        },
                        "limit": {
                            "$ref": "#/definitions/integer"
                        },
                        "modifiers": {
                            "$ref": "#/definitions/HogQLQueryModifiers",
                            "description": "Modifiers used when performing the query"
                        },
                        "offset": {
                            "$ref": "#/definitions/integer"
                        },
                        "query_status": {
                            "$ref": "#/definitions/QueryStatus",
                            "description": "Query status indicates whether next to the provided data, a query is still running."
                        },
                        "results": {
                            "$ref": "#/definitions/FunnelCorrelationResult"
                        },
                        "timings": {
                            "description": "Measured timings for different parts of the query generation process",
                            "items": {
                                "$ref": "#/definitions/QueryTiming"
                            },
                            "type": "array"
                        },
                        "types": {
                            "items": {},
                            "type": "array"
                        }
                    },
                    "required": ["results"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "tables": {
                            "additionalProperties": {
                                "$ref": "#/definitions/DatabaseSchemaTable"
                            },
                            "type": "object"
                        }
                    },
                    "required": ["tables"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "questions": {
                            "items": {
                                "type": "string"
                            },
                            "type": "array"
                        }
                    },
                    "required": ["questions"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "error": {
                            "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                            "type": "string"
                        },
                        "hogql": {
                            "description": "Generated HogQL query.",
                            "type": "string"
                        },
                        "modifiers": {
                            "$ref": "#/definitions/HogQLQueryModifiers",
                            "description": "Modifiers used when performing the query"
                        },
                        "query_status": {
                            "$ref": "#/definitions/QueryStatus",
                            "description": "Query status indicates whether next to the provided data, a query is still running."
                        },
                        "results": {
                            "$ref": "#/definitions/TeamTaxonomyResponse"
                        },
                        "timings": {
                            "description": "Measured timings for different parts of the query generation process",
                            "items": {
                                "$ref": "#/definitions/QueryTiming"
                            },
                            "type": "array"
                        }
                    },
                    "required": ["results"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "error": {
                            "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                            "type": "string"
                        },
                        "hogql": {
                            "description": "Generated HogQL query.",
                            "type": "string"
                        },
                        "modifiers": {
                            "$ref": "#/definitions/HogQLQueryModifiers",
                            "description": "Modifiers used when performing the query"
                        },
                        "query_status": {
                            "$ref": "#/definitions/QueryStatus",
                            "description": "Query status indicates whether next to the provided data, a query is still running."
                        },
                        "results": {
                            "$ref": "#/definitions/EventTaxonomyResponse"
                        },
                        "timings": {
                            "description": "Measured timings for different parts of the query generation process",
                            "items": {
                                "$ref": "#/definitions/QueryTiming"
                            },
                            "type": "array"
                        }
                    },
                    "required": ["results"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "error": {
                            "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                            "type": "string"
                        },
                        "hogql": {
                            "description": "Generated HogQL query.",
                            "type": "string"
                        },
                        "modifiers": {
                            "$ref": "#/definitions/HogQLQueryModifiers",
                            "description": "Modifiers used when performing the query"
                        },
                        "query_status": {
                            "$ref": "#/definitions/QueryStatus",
                            "description": "Query status indicates whether next to the provided data, a query is still running."
                        },
                        "results": {
                            "$ref": "#/definitions/ActorsPropertyTaxonomyResponse"
                        },
                        "timings": {
                            "description": "Measured timings for different parts of the query generation process",
                            "items": {
                                "$ref": "#/definitions/QueryTiming"
                            },
                            "type": "array"
                        }
                    },
                    "required": ["results"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "columns": {
                            "items": {
                                "type": "string"
                            },
                            "type": "array"
                        },
                        "error": {
                            "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                            "type": "string"
                        },
                        "hasMore": {
                            "type": "boolean"
                        },
                        "hogql": {
                            "description": "Generated HogQL query.",
                            "type": "string"
                        },
                        "limit": {
                            "$ref": "#/definitions/integer"
                        },
                        "modifiers": {
                            "$ref": "#/definitions/HogQLQueryModifiers",
                            "description": "Modifiers used when performing the query"
                        },
                        "offset": {
                            "$ref": "#/definitions/integer"
                        },
                        "query_status": {
                            "$ref": "#/definitions/QueryStatus",
                            "description": "Query status indicates whether next to the provided data, a query is still running."
                        },
                        "results": {
                            "items": {
                                "$ref": "#/definitions/LLMTrace"
                            },
                            "type": "array"
                        },
                        "timings": {
                            "description": "Measured timings for different parts of the query generation process",
                            "items": {
                                "$ref": "#/definitions/QueryTiming"
                            },
                            "type": "array"
                        }
                    },
                    "required": ["results"],
                    "type": "object"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "error": {
                            "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                            "type": "string"
                        },
                        "hogql": {
                            "description": "Generated HogQL query.",
                            "type": "string"
                        },
                        "modifiers": {
                            "$ref": "#/definitions/HogQLQueryModifiers",
                            "description": "Modifiers used when performing the query"
                        },
                        "query_status": {
                            "$ref": "#/definitions/QueryStatus",
                            "description": "Query status indicates whether next to the provided data, a query is still running."
                        },
                        "results": {
                            "$ref": "#/definitions/VectorSearchResponse"
                        },
                        "timings": {
                            "description": "Measured timings for different parts of the query generation process",
                            "items": {
                                "$ref": "#/definitions/QueryTiming"
                            },
                            "type": "array"
                        }
                    },
                    "required": ["results"],
                    "type": "object"
                }
            ]
        },
        "QuerySchema": {
            "discriminator": {
                "propertyName": "kind"
            },
            "oneOf": [
                {
                    "$ref": "#/definitions/EventsNode"
                },
                {
                    "$ref": "#/definitions/ActionsNode"
                },
                {
                    "$ref": "#/definitions/PersonsNode"
                },
                {
                    "$ref": "#/definitions/DataWarehouseNode"
                },
                {
                    "$ref": "#/definitions/EventsQuery"
                },
                {
                    "$ref": "#/definitions/ActorsQuery"
                },
                {
                    "$ref": "#/definitions/GroupsQuery"
                },
                {
                    "$ref": "#/definitions/InsightActorsQuery"
                },
                {
                    "$ref": "#/definitions/InsightActorsQueryOptions"
                },
                {
                    "$ref": "#/definitions/SessionsTimelineQuery"
                },
                {
                    "$ref": "#/definitions/HogQuery"
                },
                {
                    "$ref": "#/definitions/HogQLQuery"
                },
                {
                    "$ref": "#/definitions/HogQLMetadata"
                },
                {
                    "$ref": "#/definitions/HogQLAutocomplete"
                },
                {
                    "$ref": "#/definitions/SessionAttributionExplorerQuery"
                },
                {
                    "$ref": "#/definitions/RevenueExampleEventsQuery"
                },
                {
                    "$ref": "#/definitions/RevenueExampleDataWarehouseTablesQuery"
                },
                {
                    "$ref": "#/definitions/ErrorTrackingQuery"
                },
                {
                    "$ref": "#/definitions/ExperimentFunnelsQuery"
                },
                {
                    "$ref": "#/definitions/ExperimentTrendsQuery"
                },
                {
                    "$ref": "#/definitions/ExperimentQuery"
                },
                {
                    "$ref": "#/definitions/ExperimentExposureQuery"
                },
                {
                    "$ref": "#/definitions/WebOverviewQuery"
                },
                {
                    "$ref": "#/definitions/WebStatsTableQuery"
                },
                {
                    "$ref": "#/definitions/WebExternalClicksTableQuery"
                },
                {
                    "$ref": "#/definitions/WebGoalsQuery"
                },
                {
                    "$ref": "#/definitions/WebVitalsQuery"
                },
                {
                    "$ref": "#/definitions/WebVitalsPathBreakdownQuery"
                },
                {
                    "$ref": "#/definitions/WebPageURLSearchQuery"
                },
                {
                    "$ref": "#/definitions/EventsHeatMapQuery"
                },
                {
                    "$ref": "#/definitions/RevenueAnalyticsOverviewQuery"
                },
                {
                    "$ref": "#/definitions/RevenueAnalyticsGrowthRateQuery"
                },
                {
                    "$ref": "#/definitions/RevenueAnalyticsTopCustomersQuery"
                },
                {
                    "$ref": "#/definitions/DataVisualizationNode"
                },
                {
                    "$ref": "#/definitions/DataTableNode"
                },
                {
                    "$ref": "#/definitions/SavedInsightNode"
                },
                {
                    "$ref": "#/definitions/InsightVizNode"
                },
                {
                    "$ref": "#/definitions/TrendsQuery"
                },
                {
                    "$ref": "#/definitions/FunnelsQuery"
                },
                {
                    "$ref": "#/definitions/RetentionQuery"
                },
                {
                    "$ref": "#/definitions/PathsQuery"
                },
                {
                    "$ref": "#/definitions/StickinessQuery"
                },
                {
                    "$ref": "#/definitions/LifecycleQuery"
                },
                {
                    "$ref": "#/definitions/FunnelCorrelationQuery"
                },
                {
                    "$ref": "#/definitions/DatabaseSchemaQuery"
                },
                {
                    "$ref": "#/definitions/SuggestedQuestionsQuery"
                },
                {
                    "$ref": "#/definitions/TeamTaxonomyQuery"
                },
                {
                    "$ref": "#/definitions/EventTaxonomyQuery"
                },
                {
                    "$ref": "#/definitions/ActorsPropertyTaxonomyQuery"
                },
                {
                    "$ref": "#/definitions/TracesQuery"
                },
                {
                    "$ref": "#/definitions/VectorSearchQuery"
                }
            ],
            "required": ["kind"],
            "type": "object"
        },
        "QuerySchemaRoot": {
            "$ref": "#/definitions/QuerySchema"
        },
        "QueryStatus": {
            "additionalProperties": false,
            "properties": {
                "complete": {
                    "default": false,
                    "description": "Whether the query is still running. Will be true if the query is complete, even if it errored. Either result or error will be set.",
                    "type": "boolean"
                },
                "dashboard_id": {
                    "$ref": "#/definitions/integer"
                },
                "end_time": {
                    "description": "When did the query execution task finish (whether successfully or not).",
                    "format": "date-time",
                    "type": "string"
                },
                "error": {
                    "default": false,
                    "description": "If the query failed, this will be set to true. More information can be found in the error_message field.",
                    "type": "boolean"
                },
                "error_message": {
                    "default": null,
                    "type": ["string", "null"]
                },
                "expiration_time": {
                    "format": "date-time",
                    "type": "string"
                },
                "id": {
                    "type": "string"
                },
                "insight_id": {
                    "$ref": "#/definitions/integer"
                },
                "labels": {
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                },
                "pickup_time": {
                    "description": "When was the query execution task picked up by a worker.",
                    "format": "date-time",
                    "type": "string"
                },
                "query_async": {
                    "const": true,
                    "default": true,
                    "description": "ONLY async queries use QueryStatus.",
                    "type": "boolean"
                },
                "query_progress": {
                    "$ref": "#/definitions/ClickhouseQueryProgress"
                },
                "results": {},
                "start_time": {
                    "description": "When was query execution task enqueued.",
                    "format": "date-time",
                    "type": "string"
                },
                "task_id": {
                    "type": "string"
                },
                "team_id": {
                    "$ref": "#/definitions/integer"
                }
            },
            "required": ["id", "query_async", "team_id", "error", "complete", "error_message"],
            "type": "object"
        },
        "QueryStatusResponse": {
            "additionalProperties": false,
            "properties": {
                "query_status": {
                    "$ref": "#/definitions/QueryStatus"
                }
            },
            "required": ["query_status"],
            "type": "object"
        },
        "QueryTiming": {
            "additionalProperties": false,
            "properties": {
                "k": {
                    "description": "Key. Shortened to 'k' to save on data.",
                    "type": "string"
                },
                "t": {
                    "description": "Time in seconds. Shortened to 't' to save on data.",
                    "type": "number"
                }
            },
            "required": ["k", "t"],
            "type": "object"
        },
        "ReasoningMessage": {
            "additionalProperties": false,
            "properties": {
                "content": {
                    "type": "string"
                },
                "id": {
                    "type": "string"
                },
                "substeps": {
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                },
                "type": {
                    "const": "ai/reasoning",
                    "type": "string"
                }
            },
            "required": ["type", "content"],
            "type": "object"
        },
        "RecordingDurationFilter": {
            "additionalProperties": false,
            "properties": {
                "key": {
                    "$ref": "#/definitions/DurationType"
                },
                "label": {
                    "type": "string"
                },
                "operator": {
                    "$ref": "#/definitions/PropertyOperator"
                },
                "type": {
                    "const": "recording",
                    "type": "string"
                },
                "value": {
                    "type": "number"
                }
            },
            "required": ["key", "operator", "type", "value"],
            "type": "object"
        },
        "RecordingOrder": {
            "enum": [
                "duration",
                "recording_duration",
                "inactive_seconds",
                "active_seconds",
                "start_time",
                "console_error_count",
                "click_count",
                "keypress_count",
                "mouse_activity_count",
                "activity_score"
            ],
            "type": "string"
        },
        "RecordingPropertyFilter": {
            "additionalProperties": false,
            "properties": {
                "key": {
                    "anyOf": [
                        {
                            "$ref": "#/definitions/DurationType"
                        },
                        {
                            "const": "snapshot_source",
                            "type": "string"
                        },
                        {
                            "const": "visited_page",
                            "type": "string"
                        }
                    ]
                },
                "label": {
                    "type": "string"
                },
                "operator": {
                    "$ref": "#/definitions/PropertyOperator"
                },
                "type": {
                    "const": "recording",
                    "type": "string"
                },
                "value": {
                    "$ref": "#/definitions/PropertyFilterValue"
                }
            },
            "required": ["key", "operator", "type"],
            "type": "object"
        },
        "RecordingsQuery": {
            "additionalProperties": false,
            "properties": {
                "actions": {
                    "items": {
                        "type": "object"
                    },
                    "type": "array"
                },
                "console_log_filters": {
                    "items": {
                        "$ref": "#/definitions/LogEntryPropertyFilter"
                    },
                    "type": "array"
                },
                "date_from": {
                    "default": "-3d",
                    "type": ["string", "null"]
                },
                "date_to": {
                    "type": ["string", "null"]
                },
                "distinct_ids": {
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                },
                "events": {
                    "items": {
                        "type": "object"
                    },
                    "type": "array"
                },
                "filter_test_accounts": {
                    "type": "boolean"
                },
                "having_predicates": {
                    "items": {
                        "$ref": "#/definitions/AnyPropertyFilter"
                    },
                    "type": "array"
                },
                "kind": {
                    "const": "RecordingsQuery",
                    "type": "string"
                },
                "limit": {
                    "$ref": "#/definitions/integer"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "offset": {
                    "$ref": "#/definitions/integer"
                },
                "operand": {
                    "$ref": "#/definitions/FilterLogicalOperator",
                    "default": "AND"
                },
                "order": {
                    "$ref": "#/definitions/RecordingOrder",
                    "default": "start_time"
                },
                "person_uuid": {
                    "type": "string"
                },
                "properties": {
                    "items": {
                        "$ref": "#/definitions/AnyPropertyFilter"
                    },
                    "type": "array"
                },
                "response": {
                    "$ref": "#/definitions/RecordingsQueryResponse"
                },
                "session_ids": {
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                },
                "user_modified_filters": {
                    "type": "object"
                }
            },
            "required": ["kind"],
            "type": "object"
        },
        "RecordingsQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "has_next": {
                    "type": "boolean"
                },
                "results": {
                    "items": {
                        "$ref": "#/definitions/SessionRecordingType"
                    },
                    "type": "array"
                }
            },
            "required": ["results", "has_next"],
            "type": "object"
        },
        "RefreshType": {
            "enum": [
                "async",
                "async_except_on_cache_miss",
                "blocking",
                "force_async",
                "force_blocking",
                "force_cache",
                "lazy_async"
            ],
            "type": "string"
        },
        "ResultCustomization": {
            "anyOf": [
                {
                    "$ref": "#/definitions/ResultCustomizationByValue"
                },
                {
                    "$ref": "#/definitions/ResultCustomizationByPosition"
                }
            ]
        },
        "ResultCustomizationBase": {
            "additionalProperties": false,
            "properties": {
                "color": {
                    "$ref": "#/definitions/DataColorToken"
                }
            },
            "required": ["color"],
            "type": "object"
        },
        "ResultCustomizationBy": {
            "enum": ["value", "position"],
            "type": "string"
        },
        "ResultCustomizationByPosition": {
            "additionalProperties": false,
            "properties": {
                "assignmentBy": {
                    "const": "position",
                    "type": "string"
                },
                "color": {
                    "$ref": "#/definitions/DataColorToken"
                }
            },
            "required": ["assignmentBy", "color"],
            "type": "object"
        },
        "ResultCustomizationByValue": {
            "additionalProperties": false,
            "properties": {
                "assignmentBy": {
                    "const": "value",
                    "type": "string"
                },
                "color": {
                    "$ref": "#/definitions/DataColorToken"
                }
            },
            "required": ["assignmentBy", "color"],
            "type": "object"
        },
        "RetentionDashboardDisplayType": {
            "enum": ["table_only", "graph_only", "all"],
            "type": "string"
        },
        "RetentionEntity": {
            "additionalProperties": false,
            "properties": {
                "custom_name": {
                    "type": "string"
                },
                "id": {
                    "type": ["string", "number"]
                },
                "kind": {
                    "$ref": "#/definitions/RetentionEntityKind"
                },
                "name": {
                    "type": "string"
                },
                "order": {
                    "type": "integer"
                },
                "properties": {
                    "description": "filters on the event",
                    "items": {
                        "$ref": "#/definitions/AnyPropertyFilter"
                    },
                    "type": "array"
                },
                "type": {
                    "$ref": "#/definitions/EntityType"
                },
                "uuid": {
                    "type": "string"
                }
            },
            "type": "object"
        },
        "RetentionEntityKind": {
            "enum": ["ActionsNode", "EventsNode"],
            "type": "string"
        },
        "RetentionFilter": {
            "additionalProperties": false,
            "properties": {
                "cumulative": {
                    "type": "boolean"
                },
                "dashboardDisplay": {
                    "$ref": "#/definitions/RetentionDashboardDisplayType"
                },
                "display": {
                    "$ref": "#/definitions/ChartDisplayType",
                    "description": "controls the display of the retention graph"
                },
                "meanRetentionCalculation": {
                    "enum": ["simple", "weighted", "none"],
                    "type": "string"
                },
                "period": {
                    "$ref": "#/definitions/RetentionPeriod",
                    "default": "Day"
                },
                "retentionReference": {
                    "description": "Whether retention is with regard to initial cohort size, or that of the previous period.",
                    "enum": ["total", "previous"],
                    "type": "string"
                },
                "retentionType": {
                    "$ref": "#/definitions/RetentionType"
                },
                "returningEntity": {
                    "$ref": "#/definitions/RetentionEntity"
                },
                "showMean": {
                    "type": "boolean"
                },
                "targetEntity": {
                    "$ref": "#/definitions/RetentionEntity"
                },
                "totalIntervals": {
                    "$ref": "#/definitions/integer",
                    "default": 8
                }
            },
            "type": "object"
        },
        "RetentionFilterLegacy": {
            "additionalProperties": false,
            "description": "`RetentionFilterType` minus everything inherited from `FilterType`",
            "properties": {
                "cumulative": {
                    "type": "boolean"
                },
                "mean_retention_calculation": {
                    "enum": ["simple", "weighted", "none"],
                    "type": "string"
                },
                "period": {
                    "$ref": "#/definitions/RetentionPeriod"
                },
                "retention_reference": {
                    "description": "Whether retention is with regard to initial cohort size, or that of the previous period.",
                    "enum": ["total", "previous"],
                    "type": "string"
                },
                "retention_type": {
                    "$ref": "#/definitions/RetentionType"
                },
                "returning_entity": {
                    "$ref": "#/definitions/RetentionEntity"
                },
                "show_mean": {
                    "type": "boolean"
                },
                "target_entity": {
                    "$ref": "#/definitions/RetentionEntity"
                },
                "total_intervals": {
                    "type": "integer"
                }
            },
            "type": "object"
        },
        "RetentionPeriod": {
            "enum": ["Hour", "Day", "Week", "Month"],
            "type": "string"
        },
        "RetentionQuery": {
            "additionalProperties": false,
            "properties": {
                "aggregation_group_type_index": {
                    "anyOf": [
                        {
                            "$ref": "#/definitions/integer"
                        },
                        {
                            "type": "null"
                        }
                    ],
                    "description": "Groups aggregation"
                },
                "breakdownFilter": {
                    "$ref": "#/definitions/BreakdownFilter",
                    "description": "Breakdown of the events and actions"
                },
                "dataColorTheme": {
                    "description": "Colors used in the insight's visualization",
                    "type": ["number", "null"]
                },
                "dateRange": {
                    "$ref": "#/definitions/DateRange",
                    "description": "Date range for the query"
                },
                "filterTestAccounts": {
                    "default": false,
                    "description": "Exclude internal and test users by applying the respective filters",
                    "type": "boolean"
                },
                "kind": {
                    "const": "RetentionQuery",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "properties": {
                    "anyOf": [
                        {
                            "items": {
                                "$ref": "#/definitions/AnyPropertyFilter"
                            },
                            "type": "array"
                        },
                        {
                            "$ref": "#/definitions/PropertyGroupFilter"
                        }
                    ],
                    "default": [],
                    "description": "Property filters for all series"
                },
                "response": {
                    "$ref": "#/definitions/RetentionQueryResponse"
                },
                "retentionFilter": {
                    "$ref": "#/definitions/RetentionFilter",
                    "description": "Properties specific to the retention insight"
                },
                "samplingFactor": {
                    "description": "Sampling rate",
                    "type": ["number", "null"]
                }
            },
            "required": ["kind", "retentionFilter"],
            "type": "object"
        },
        "RetentionQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "items": {
                        "$ref": "#/definitions/RetentionResult"
                    },
                    "type": "array"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                }
            },
            "required": ["results"],
            "type": "object"
        },
        "RetentionResult": {
            "additionalProperties": false,
            "properties": {
                "breakdown_value": {
                    "description": "Optional breakdown value for retention cohorts",
                    "type": ["string", "number", "null"]
                },
                "date": {
                    "format": "date-time",
                    "type": "string"
                },
                "label": {
                    "type": "string"
                },
                "values": {
                    "items": {
                        "$ref": "#/definitions/RetentionValue"
                    },
                    "type": "array"
                }
            },
            "required": ["values", "label", "date"],
            "type": "object"
        },
        "RetentionType": {
            "enum": ["retention_recurring", "retention_first_time"],
            "type": "string"
        },
        "RetentionValue": {
            "additionalProperties": false,
            "properties": {
                "count": {
                    "$ref": "#/definitions/integer"
                },
                "label": {
                    "type": "string"
                }
            },
            "required": ["count"],
            "type": "object"
        },
        "RevenueAnalyticsBaseQuery<RevenueAnalyticsGrowthRateQueryResponse>": {
            "additionalProperties": false,
            "properties": {
                "dateRange": {
                    "$ref": "#/definitions/DateRange"
                },
                "kind": {
                    "$ref": "#/definitions/NodeKind"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "response": {
                    "$ref": "#/definitions/RevenueAnalyticsGrowthRateQueryResponse"
                },
                "revenueSources": {
                    "$ref": "#/definitions/RevenueSources"
                }
            },
            "required": ["kind", "revenueSources"],
            "type": "object"
        },
        "RevenueAnalyticsBaseQuery<RevenueAnalyticsOverviewQueryResponse>": {
            "additionalProperties": false,
            "properties": {
                "dateRange": {
                    "$ref": "#/definitions/DateRange"
                },
                "kind": {
                    "$ref": "#/definitions/NodeKind"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "response": {
                    "$ref": "#/definitions/RevenueAnalyticsOverviewQueryResponse"
                },
                "revenueSources": {
                    "$ref": "#/definitions/RevenueSources"
                }
            },
            "required": ["kind", "revenueSources"],
            "type": "object"
        },
        "RevenueAnalyticsBaseQuery<RevenueAnalyticsTopCustomersQueryResponse>": {
            "additionalProperties": false,
            "properties": {
                "dateRange": {
                    "$ref": "#/definitions/DateRange"
                },
                "kind": {
                    "$ref": "#/definitions/NodeKind"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "response": {
                    "$ref": "#/definitions/RevenueAnalyticsTopCustomersQueryResponse"
                },
                "revenueSources": {
                    "$ref": "#/definitions/RevenueSources"
                }
            },
            "required": ["kind", "revenueSources"],
            "type": "object"
        },
        "RevenueAnalyticsConfig": {
            "additionalProperties": false,
            "properties": {
                "base_currency": {
                    "$ref": "#/definitions/CurrencyCode",
                    "default": "USD"
                },
                "events": {
                    "default": [],
                    "items": {
                        "$ref": "#/definitions/RevenueAnalyticsEventItem"
                    },
                    "type": "array"
                }
            },
            "required": ["base_currency", "events"],
            "type": "object"
        },
        "RevenueAnalyticsEventItem": {
            "additionalProperties": false,
            "properties": {
                "eventName": {
                    "type": "string"
                },
                "revenueCurrencyProperty": {
                    "$ref": "#/definitions/RevenueCurrencyPropertyConfig",
                    "default": {
                        "static": "USD"
                    }
                },
                "revenueProperty": {
                    "type": "string"
                }
            },
            "required": ["eventName", "revenueProperty", "revenueCurrencyProperty"],
            "type": "object"
        },
        "RevenueAnalyticsGrowthRateQuery": {
            "additionalProperties": false,
            "properties": {
                "dateRange": {
                    "$ref": "#/definitions/DateRange"
                },
                "kind": {
                    "const": "RevenueAnalyticsGrowthRateQuery",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "response": {
                    "$ref": "#/definitions/RevenueAnalyticsGrowthRateQueryResponse"
                },
                "revenueSources": {
                    "$ref": "#/definitions/RevenueSources"
                }
            },
            "required": ["kind", "revenueSources"],
            "type": "object"
        },
        "RevenueAnalyticsGrowthRateQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "columns": {
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                },
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {},
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                }
            },
            "required": ["results"],
            "type": "object"
        },
        "RevenueAnalyticsOverviewItem": {
            "additionalProperties": false,
            "properties": {
                "key": {
                    "$ref": "#/definitions/RevenueAnalyticsOverviewItemKey"
                },
                "value": {
                    "type": "number"
                }
            },
            "required": ["key", "value"],
            "type": "object"
        },
        "RevenueAnalyticsOverviewItemKey": {
            "enum": ["revenue", "paying_customer_count", "avg_revenue_per_customer"],
            "type": "string"
        },
        "RevenueAnalyticsOverviewQuery": {
            "additionalProperties": false,
            "properties": {
                "dateRange": {
                    "$ref": "#/definitions/DateRange"
                },
                "kind": {
                    "const": "RevenueAnalyticsOverviewQuery",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "response": {
                    "$ref": "#/definitions/RevenueAnalyticsOverviewQueryResponse"
                },
                "revenueSources": {
                    "$ref": "#/definitions/RevenueSources"
                }
            },
            "required": ["kind", "revenueSources"],
            "type": "object"
        },
        "RevenueAnalyticsOverviewQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "items": {
                        "$ref": "#/definitions/RevenueAnalyticsOverviewItem"
                    },
                    "type": "array"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                }
            },
            "required": ["results"],
            "type": "object"
        },
        "RevenueAnalyticsTopCustomersGroupBy": {
            "enum": ["month", "all"],
            "type": "string"
        },
        "RevenueAnalyticsTopCustomersQuery": {
            "additionalProperties": false,
            "properties": {
                "dateRange": {
                    "$ref": "#/definitions/DateRange"
                },
                "groupBy": {
                    "$ref": "#/definitions/RevenueAnalyticsTopCustomersGroupBy"
                },
                "kind": {
                    "const": "RevenueAnalyticsTopCustomersQuery",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "response": {
                    "$ref": "#/definitions/RevenueAnalyticsTopCustomersQueryResponse"
                },
                "revenueSources": {
                    "$ref": "#/definitions/RevenueSources"
                }
            },
            "required": ["groupBy", "kind", "revenueSources"],
            "type": "object"
        },
        "RevenueAnalyticsTopCustomersQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "columns": {
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                },
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {},
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                }
            },
            "required": ["results"],
            "type": "object"
        },
        "RevenueCurrencyPropertyConfig": {
            "additionalProperties": false,
            "properties": {
                "property": {
                    "type": "string"
                },
                "static": {
                    "$ref": "#/definitions/CurrencyCode"
                }
            },
            "type": "object"
        },
        "RevenueExampleDataWarehouseTablesQuery": {
            "additionalProperties": false,
            "properties": {
                "kind": {
                    "const": "RevenueExampleDataWarehouseTablesQuery",
                    "type": "string"
                },
                "limit": {
                    "$ref": "#/definitions/integer"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "offset": {
                    "$ref": "#/definitions/integer"
                },
                "response": {
                    "$ref": "#/definitions/RevenueExampleDataWarehouseTablesQueryResponse"
                }
            },
            "required": ["kind"],
            "type": "object"
        },
        "RevenueExampleDataWarehouseTablesQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "columns": {
                    "items": {},
                    "type": "array"
                },
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hasMore": {
                    "type": "boolean"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "limit": {
                    "$ref": "#/definitions/integer"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "offset": {
                    "$ref": "#/definitions/integer"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {},
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                },
                "types": {
                    "items": {},
                    "type": "array"
                }
            },
            "required": ["results"],
            "type": "object"
        },
        "RevenueExampleEventsQuery": {
            "additionalProperties": false,
            "properties": {
                "kind": {
                    "const": "RevenueExampleEventsQuery",
                    "type": "string"
                },
                "limit": {
                    "$ref": "#/definitions/integer"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "offset": {
                    "$ref": "#/definitions/integer"
                },
                "response": {
                    "$ref": "#/definitions/RevenueExampleEventsQueryResponse"
                }
            },
            "required": ["kind"],
            "type": "object"
        },
        "RevenueExampleEventsQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "columns": {
                    "items": {},
                    "type": "array"
                },
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hasMore": {
                    "type": "boolean"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "limit": {
                    "$ref": "#/definitions/integer"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "offset": {
                    "$ref": "#/definitions/integer"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {},
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                },
                "types": {
                    "items": {},
                    "type": "array"
                }
            },
            "required": ["results"],
            "type": "object"
        },
        "RevenueSources": {
            "additionalProperties": false,
            "properties": {
                "dataWarehouseSources": {
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                },
                "events": {
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                }
            },
            "required": ["dataWarehouseSources", "events"],
            "type": "object"
        },
        "RootAssistantMessage": {
            "anyOf": [
                {
                    "$ref": "#/definitions/VisualizationMessage"
                },
                {
                    "$ref": "#/definitions/ReasoningMessage"
                },
                {
                    "$ref": "#/definitions/AssistantMessage"
                },
                {
                    "$ref": "#/definitions/HumanMessage"
                },
                {
                    "$ref": "#/definitions/FailureMessage"
                },
                {
                    "additionalProperties": false,
                    "properties": {
                        "content": {
                            "type": "string"
                        },
                        "id": {
                            "type": "string"
                        },
                        "tool_call_id": {
                            "type": "string"
                        },
                        "type": {
                            "const": "tool",
                            "type": "string"
                        },
                        "ui_payload": {
                            "description": "Payload passed through to the frontend - specifically for calls of contextual tool. Tool call messages without a ui_payload are not passed through to the frontend.",
                            "type": "object"
                        }
                    },
                    "required": ["content", "tool_call_id", "type"],
                    "type": "object"
                }
            ]
        },
        "SamplingRate": {
            "additionalProperties": false,
            "properties": {
                "denominator": {
                    "type": "number"
                },
                "numerator": {
                    "type": "number"
                }
            },
            "required": ["numerator"],
            "type": "object"
        },
        "SavedInsightNode": {
            "additionalProperties": false,
            "properties": {
                "allowSorting": {
                    "description": "Can the user click on column headers to sort the table? (default: true)",
                    "type": "boolean"
                },
                "context": {
                    "additionalProperties": false,
                    "description": "Context for the table, used by components like ColumnConfigurator",
                    "properties": {
                        "eventDefinitionId": {
                            "type": "string"
                        },
                        "type": {
                            "enum": ["event_definition", "team_columns"],
                            "type": "string"
                        }
                    },
                    "required": ["type"],
                    "type": "object"
                },
                "embedded": {
                    "description": "Query is embedded inside another bordered component",
                    "type": "boolean"
                },
                "expandable": {
                    "description": "Can expand row to show raw event data (default: true)",
                    "type": "boolean"
                },
                "full": {
                    "description": "Show with most visual options enabled. Used in insight scene.",
                    "type": "boolean"
                },
                "hidePersonsModal": {
                    "type": "boolean"
                },
                "hideTooltipOnScroll": {
                    "type": "boolean"
                },
                "kind": {
                    "const": "SavedInsightNode",
                    "type": "string"
                },
                "propertiesViaUrl": {
                    "description": "Link properties via the URL (default: false)",
                    "type": "boolean"
                },
                "shortId": {
                    "$ref": "#/definitions/InsightShortId"
                },
                "showActions": {
                    "description": "Show the kebab menu at the end of the row",
                    "type": "boolean"
                },
                "showColumnConfigurator": {
                    "description": "Show a button to configure the table's columns if possible",
                    "type": "boolean"
                },
                "showCorrelationTable": {
                    "type": "boolean"
                },
                "showDateRange": {
                    "description": "Show date range selector",
                    "type": "boolean"
                },
                "showElapsedTime": {
                    "description": "Show the time it takes to run a query",
                    "type": "boolean"
                },
                "showEventFilter": {
                    "description": "Include an event filter above the table (EventsNode only)",
                    "type": "boolean"
                },
                "showExport": {
                    "description": "Show the export button",
                    "type": "boolean"
                },
                "showFilters": {
                    "type": "boolean"
                },
                "showHeader": {
                    "type": "boolean"
                },
                "showHogQLEditor": {
                    "description": "Include a HogQL query editor above HogQL tables",
                    "type": "boolean"
                },
                "showLastComputation": {
                    "type": "boolean"
                },
                "showLastComputationRefresh": {
                    "type": "boolean"
                },
                "showOpenEditorButton": {
                    "description": "Show a button to open the current query as a new insight. (default: true)",
                    "type": "boolean"
                },
                "showPersistentColumnConfigurator": {
                    "description": "Show a button to configure and persist the table's default columns if possible",
                    "type": "boolean"
                },
                "showPropertyFilter": {
                    "anyOf": [
                        {
                            "type": "boolean"
                        },
                        {
                            "items": {
                                "$ref": "#/definitions/TaxonomicFilterGroupType"
                            },
                            "type": "array"
                        }
                    ],
                    "description": "Include a property filter above the table"
                },
                "showReload": {
                    "description": "Show a reload button",
                    "type": "boolean"
                },
                "showResults": {
                    "type": "boolean"
                },
                "showResultsTable": {
                    "description": "Show a results table",
                    "type": "boolean"
                },
                "showSavedQueries": {
                    "description": "Shows a list of saved queries",
                    "type": "boolean"
                },
                "showSearch": {
                    "description": "Include a free text search field (PersonsNode only)",
                    "type": "boolean"
                },
                "showTable": {
                    "type": "boolean"
                },
                "showTestAccountFilters": {
                    "description": "Show filter to exclude test accounts",
                    "type": "boolean"
                },
                "showTimings": {
                    "description": "Show a detailed query timing breakdown",
                    "type": "boolean"
                },
                "suppressSessionAnalysisWarning": {
                    "type": "boolean"
                },
                "vizSpecificOptions": {
                    "$ref": "#/definitions/VizSpecificOptions"
                }
            },
            "required": ["kind", "shortId"],
            "type": "object"
        },
        "SessionAttributionExplorerQuery": {
            "additionalProperties": false,
            "properties": {
                "filters": {
                    "additionalProperties": false,
                    "properties": {
                        "dateRange": {
                            "$ref": "#/definitions/DateRange"
                        },
                        "properties": {
                            "items": {
                                "$ref": "#/definitions/SessionPropertyFilter"
                            },
                            "type": "array"
                        }
                    },
                    "type": "object"
                },
                "groupBy": {
                    "items": {
                        "$ref": "#/definitions/SessionAttributionGroupBy"
                    },
                    "type": "array"
                },
                "kind": {
                    "const": "SessionAttributionExplorerQuery",
                    "type": "string"
                },
                "limit": {
                    "$ref": "#/definitions/integer"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "offset": {
                    "$ref": "#/definitions/integer"
                },
                "response": {
                    "$ref": "#/definitions/SessionAttributionExplorerQueryResponse"
                }
            },
            "required": ["groupBy", "kind"],
            "type": "object"
        },
        "SessionAttributionExplorerQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "columns": {
                    "items": {},
                    "type": "array"
                },
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hasMore": {
                    "type": "boolean"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "limit": {
                    "$ref": "#/definitions/integer"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "offset": {
                    "$ref": "#/definitions/integer"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {},
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                },
                "types": {
                    "items": {},
                    "type": "array"
                }
            },
            "required": ["results"],
            "type": "object"
        },
        "SessionAttributionGroupBy": {
            "enum": ["ChannelType", "Medium", "Source", "Campaign", "AdIds", "ReferringDomain", "InitialURL"],
            "type": "string"
        },
        "SessionPropertyFilter": {
            "additionalProperties": false,
            "properties": {
                "key": {
                    "type": "string"
                },
                "label": {
                    "type": "string"
                },
                "operator": {
                    "$ref": "#/definitions/PropertyOperator"
                },
                "type": {
                    "const": "session",
                    "type": "string"
                },
                "value": {
                    "$ref": "#/definitions/PropertyFilterValue"
                }
            },
            "required": ["key", "operator", "type"],
            "type": "object"
        },
        "SessionRecordingType": {
            "additionalProperties": false,
            "properties": {
                "active_seconds": {
                    "type": "number"
                },
                "activity_score": {
                    "description": "calculated on the backend so that we can sort by it, definition may change over time",
                    "type": "number"
                },
                "click_count": {
                    "type": "number"
                },
                "console_error_count": {
                    "type": "number"
                },
                "console_log_count": {
                    "type": "number"
                },
                "console_warn_count": {
                    "type": "number"
                },
                "distinct_id": {
                    "type": "string"
                },
                "email": {
                    "type": "string"
                },
                "end_time": {
                    "description": "When the recording ends in ISO format.",
                    "type": "string"
                },
                "id": {
                    "type": "string"
                },
                "inactive_seconds": {
                    "type": "number"
                },
                "keypress_count": {
                    "type": "number"
                },
                "matching_events": {
                    "description": "List of matching events. *",
                    "items": {
                        "$ref": "#/definitions/MatchedRecording"
                    },
                    "type": "array"
                },
                "mouse_activity_count": {
                    "description": "count of all mouse activity in the recording, not just clicks",
                    "type": "number"
                },
                "ongoing": {
                    "description": "whether we have received data for this recording in the last 5 minutes (assumes the recording was loaded from ClickHouse)\n*",
                    "type": "boolean"
                },
                "person": {
                    "$ref": "#/definitions/PersonType"
                },
                "recording_duration": {
                    "description": "Length of recording in seconds.",
                    "type": "number"
                },
                "snapshot_source": {
                    "enum": ["web", "mobile", "unknown"],
                    "type": "string"
                },
                "start_time": {
                    "description": "When the recording starts in ISO format.",
                    "type": "string"
                },
                "start_url": {
                    "type": "string"
                },
                "storage": {
                    "description": "Where this recording information was loaded from",
                    "enum": ["object_storage_lts", "object_storage"],
                    "type": "string"
                },
                "summary": {
                    "type": "string"
                },
                "viewed": {
                    "description": "Whether this recording has been viewed by you already.",
                    "type": "boolean"
                },
                "viewers": {
                    "description": "user ids of other users who have viewed this recording",
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                }
            },
            "required": ["id", "viewed", "viewers", "recording_duration", "start_time", "end_time", "snapshot_source"],
            "type": "object"
        },
        "SessionsTimelineQuery": {
            "additionalProperties": false,
            "properties": {
                "after": {
                    "description": "Only fetch sessions that started after this timestamp (default: '-24h')",
                    "type": "string"
                },
                "before": {
                    "description": "Only fetch sessions that started before this timestamp (default: '+5s')",
                    "type": "string"
                },
                "kind": {
                    "const": "SessionsTimelineQuery",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "personId": {
                    "description": "Fetch sessions only for a given person",
                    "type": "string"
                },
                "response": {
                    "$ref": "#/definitions/SessionsTimelineQueryResponse"
                }
            },
            "required": ["kind"],
            "type": "object"
        },
        "SessionsTimelineQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hasMore": {
                    "type": "boolean"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "items": {
                        "$ref": "#/definitions/TimelineEntry"
                    },
                    "type": "array"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                }
            },
            "required": ["results"],
            "type": "object"
        },
        "StepOrderValue": {
            "enum": ["strict", "unordered", "ordered"],
            "type": "string"
        },
        "StickinessActorsQuery": {
            "additionalProperties": false,
            "properties": {
                "breakdown": {
                    "anyOf": [
                        {
                            "type": "string"
                        },
                        {
                            "$ref": "#/definitions/BreakdownValueInt"
                        },
                        {
                            "items": {
                                "type": "string"
                            },
                            "type": "array"
                        }
                    ]
                },
                "compare": {
                    "enum": ["current", "previous"],
                    "type": "string"
                },
                "day": {
                    "anyOf": [
                        {
                            "type": "string"
                        },
                        {
                            "$ref": "#/definitions/Day"
                        }
                    ]
                },
                "includeRecordings": {
                    "type": "boolean"
                },
                "interval": {
                    "$ref": "#/definitions/integer",
                    "description": "An interval selected out of available intervals in source query."
                },
                "kind": {
                    "const": "InsightActorsQuery",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "operator": {
                    "$ref": "#/definitions/StickinessOperator"
                },
                "response": {
                    "$ref": "#/definitions/ActorsQueryResponse"
                },
                "series": {
                    "$ref": "#/definitions/integer"
                },
                "source": {
                    "$ref": "#/definitions/InsightQuerySource"
                },
                "status": {
                    "type": "string"
                }
            },
            "required": ["kind", "source"],
            "type": "object"
        },
        "StickinessComputationMode": {
            "enum": ["non_cumulative", "cumulative"],
            "type": "string"
        },
        "StickinessFilter": {
            "additionalProperties": false,
            "properties": {
                "computedAs": {
                    "$ref": "#/definitions/StickinessComputationMode"
                },
                "display": {
                    "$ref": "#/definitions/ChartDisplayType"
                },
                "hiddenLegendIndexes": {
                    "items": {
                        "$ref": "#/definitions/integer"
                    },
                    "type": "array"
                },
                "showLegend": {
                    "type": "boolean"
                },
                "showMultipleYAxes": {
                    "type": "boolean"
                },
                "showValuesOnSeries": {
                    "type": "boolean"
                },
                "stickinessCriteria": {
                    "additionalProperties": false,
                    "properties": {
                        "operator": {
                            "$ref": "#/definitions/StickinessOperator"
                        },
                        "value": {
                            "$ref": "#/definitions/integer"
                        }
                    },
                    "required": ["operator", "value"],
                    "type": "object"
                }
            },
            "type": "object"
        },
        "StickinessFilterLegacy": {
            "additionalProperties": false,
            "description": "`StickinessFilterType` minus everything inherited from `FilterType` and persons modal related params",
            "properties": {
                "compare": {
                    "type": "boolean"
                },
                "compare_to": {
                    "type": "string"
                },
                "display": {
                    "$ref": "#/definitions/ChartDisplayType"
                },
                "hidden_legend_keys": {
                    "additionalProperties": {
                        "anyOf": [
                            {
                                "type": "boolean"
                            },
                            {
                                "not": {}
                            }
                        ]
                    },
                    "type": "object"
                },
                "show_legend": {
                    "type": "boolean"
                },
                "show_multiple_y_axes": {
                    "type": "boolean"
                },
                "show_values_on_series": {
                    "type": "boolean"
                }
            },
            "type": "object"
        },
        "StickinessOperator": {
            "enum": ["gte", "lte", "exact"],
            "type": "string"
        },
        "StickinessQuery": {
            "additionalProperties": false,
            "properties": {
                "compareFilter": {
                    "$ref": "#/definitions/CompareFilter",
                    "description": "Compare to date range"
                },
                "dataColorTheme": {
                    "description": "Colors used in the insight's visualization",
                    "type": ["number", "null"]
                },
                "dateRange": {
                    "$ref": "#/definitions/DateRange",
                    "description": "Date range for the query"
                },
                "filterTestAccounts": {
                    "default": false,
                    "description": "Exclude internal and test users by applying the respective filters",
                    "type": "boolean"
                },
                "interval": {
                    "$ref": "#/definitions/IntervalType",
                    "default": "day",
                    "description": "Granularity of the response. Can be one of `hour`, `day`, `week` or `month`"
                },
                "intervalCount": {
                    "$ref": "#/definitions/integer",
                    "description": "How many intervals comprise a period. Only used for cohorts, otherwise default 1."
                },
                "kind": {
                    "const": "StickinessQuery",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "properties": {
                    "anyOf": [
                        {
                            "items": {
                                "$ref": "#/definitions/AnyPropertyFilter"
                            },
                            "type": "array"
                        },
                        {
                            "$ref": "#/definitions/PropertyGroupFilter"
                        }
                    ],
                    "default": [],
                    "description": "Property filters for all series"
                },
                "response": {
                    "$ref": "#/definitions/StickinessQueryResponse"
                },
                "samplingFactor": {
                    "description": "Sampling rate",
                    "type": ["number", "null"]
                },
                "series": {
                    "description": "Events and actions to include",
                    "items": {
                        "$ref": "#/definitions/AnyEntityNode"
                    },
                    "type": "array"
                },
                "stickinessFilter": {
                    "$ref": "#/definitions/StickinessFilter",
                    "description": "Properties specific to the stickiness insight"
                }
            },
            "required": ["kind", "series"],
            "type": "object"
        },
        "StickinessQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "items": {
                        "type": "object"
                    },
                    "type": "array"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                }
            },
            "required": ["results"],
            "type": "object"
        },
        "SuggestedQuestionsQuery": {
            "additionalProperties": false,
            "properties": {
                "kind": {
                    "const": "SuggestedQuestionsQuery",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "response": {
                    "$ref": "#/definitions/SuggestedQuestionsQueryResponse"
                }
            },
            "required": ["kind"],
            "type": "object"
        },
        "SuggestedQuestionsQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "questions": {
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                }
            },
            "required": ["questions"],
            "type": "object"
        },
        "TableSettings": {
            "additionalProperties": false,
            "properties": {
                "columns": {
                    "items": {
                        "$ref": "#/definitions/ChartAxis"
                    },
                    "type": "array"
                },
                "conditionalFormatting": {
                    "items": {
                        "$ref": "#/definitions/ConditionalFormattingRule"
                    },
                    "type": "array"
                }
            },
            "type": "object"
        },
        "TaxonomicFilterGroupType": {
            "enum": [
                "metadata",
                "actions",
                "cohorts",
                "cohorts_with_all",
                "data_warehouse",
                "data_warehouse_properties",
                "data_warehouse_person_properties",
                "elements",
                "events",
                "event_properties",
                "event_feature_flags",
                "event_metadata",
                "numerical_event_properties",
                "person_properties",
                "pageview_urls",
                "screens",
                "custom_events",
                "wildcard",
                "groups",
                "persons",
                "feature_flags",
                "insights",
                "experiments",
                "plugins",
                "dashboards",
                "name_groups",
                "session_properties",
                "hogql_expression",
                "notebooks",
                "log_entries",
                "error_tracking_issues",
                "replay",
                "resources"
            ],
            "type": "string"
        },
        "TeamTaxonomyItem": {
            "additionalProperties": false,
            "properties": {
                "count": {
                    "$ref": "#/definitions/integer"
                },
                "event": {
                    "type": "string"
                }
            },
            "required": ["event", "count"],
            "type": "object"
        },
        "TeamTaxonomyQuery": {
            "additionalProperties": false,
            "properties": {
                "kind": {
                    "const": "TeamTaxonomyQuery",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "response": {
                    "$ref": "#/definitions/TeamTaxonomyQueryResponse"
                }
            },
            "required": ["kind"],
            "type": "object"
        },
        "TeamTaxonomyQueryResponse": {
            "additionalProperties": false,
            "description": "All analytics query responses must inherit from this.",
            "properties": {
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "$ref": "#/definitions/TeamTaxonomyResponse"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                }
            },
            "required": ["results"],
            "type": "object"
        },
        "TeamTaxonomyResponse": {
            "items": {
                "$ref": "#/definitions/TeamTaxonomyItem"
            },
            "type": "array"
        },
        "TestBasicQueryResponse": {
            "additionalProperties": false,
            "deprecated": "Only exported for use in test_query_runner.py! Don't use anywhere else.",
            "properties": {
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "items": {},
                    "type": "array"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                }
            },
            "required": ["results"],
            "type": "object"
        },
        "TestCachedBasicQueryResponse": {
            "additionalProperties": false,
            "deprecated": "Only exported for use in test_query_runner.py! Don't use anywhere else.",
            "properties": {
                "cache_key": {
                    "type": "string"
                },
                "cache_target_age": {
                    "format": "date-time",
                    "type": "string"
                },
                "calculation_trigger": {
                    "description": "What triggered the calculation of the query, leave empty if user/immediate",
                    "type": "string"
                },
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "is_cached": {
                    "type": "boolean"
                },
                "last_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "next_allowed_client_refresh": {
                    "format": "date-time",
                    "type": "string"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "items": {},
                    "type": "array"
                },
                "timezone": {
                    "type": "string"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                }
            },
            "required": [
                "cache_key",
                "is_cached",
                "last_refresh",
                "next_allowed_client_refresh",
                "results",
                "timezone"
            ],
            "type": "object"
        },
        "TimelineEntry": {
            "additionalProperties": false,
            "properties": {
                "events": {
                    "items": {
                        "$ref": "#/definitions/EventType"
                    },
                    "type": "array"
                },
                "recording_duration_s": {
                    "description": "Duration of the recording in seconds.",
                    "type": "number"
                },
                "sessionId": {
                    "description": "Session ID. None means out-of-session events",
                    "type": "string"
                }
            },
            "required": ["events"],
            "type": "object"
        },
        "TracesQuery": {
            "additionalProperties": false,
            "properties": {
                "dateRange": {
                    "$ref": "#/definitions/DateRange"
                },
                "filterTestAccounts": {
                    "type": "boolean"
                },
                "kind": {
                    "const": "TracesQuery",
                    "type": "string"
                },
                "limit": {
                    "$ref": "#/definitions/integer"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "offset": {
                    "$ref": "#/definitions/integer"
                },
                "properties": {
                    "description": "Properties configurable in the interface",
                    "items": {
                        "$ref": "#/definitions/AnyPropertyFilter"
                    },
                    "type": "array"
                },
                "response": {
                    "$ref": "#/definitions/TracesQueryResponse"
                },
                "showColumnConfigurator": {
                    "type": "boolean"
                },
                "traceId": {
                    "type": "string"
                }
            },
            "required": ["kind"],
            "type": "object"
        },
        "TracesQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "columns": {
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                },
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hasMore": {
                    "type": "boolean"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "limit": {
                    "$ref": "#/definitions/integer"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "offset": {
                    "$ref": "#/definitions/integer"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "items": {
                        "$ref": "#/definitions/LLMTrace"
                    },
                    "type": "array"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                }
            },
            "required": ["results"],
            "type": "object"
        },
        "TrendsAlertConfig": {
            "additionalProperties": false,
            "properties": {
                "check_ongoing_interval": {
                    "type": "boolean"
                },
                "series_index": {
                    "$ref": "#/definitions/integer"
                },
                "type": {
                    "const": "TrendsAlertConfig",
                    "type": "string"
                }
            },
            "required": ["type", "series_index"],
            "type": "object"
        },
        "TrendsFilter": {
            "additionalProperties": false,
            "properties": {
                "aggregationAxisFormat": {
                    "$ref": "#/definitions/AggregationAxisFormat",
                    "default": "numeric"
                },
                "aggregationAxisPostfix": {
                    "type": "string"
                },
                "aggregationAxisPrefix": {
                    "type": "string"
                },
                "breakdown_histogram_bin_count": {
                    "type": "number"
                },
                "decimalPlaces": {
                    "type": "number"
                },
                "display": {
                    "$ref": "#/definitions/ChartDisplayType",
                    "default": "ActionsLineGraph"
                },
                "formula": {
                    "deprecated": "Use formulaNodes instead.",
                    "type": "string"
                },
                "formulaNodes": {
                    "description": "List of formulas with optional custom names. Takes precedence over formula/formulas if set.",
                    "items": {
                        "$ref": "#/definitions/TrendsFormulaNode"
                    },
                    "type": "array"
                },
                "formulas": {
                    "deprecated": "Use formulaNodes instead.",
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                },
                "goalLines": {
                    "description": "Goal Lines",
                    "items": {
                        "$ref": "#/definitions/GoalLine"
                    },
                    "type": "array"
                },
                "hiddenLegendIndexes": {
                    "items": {
                        "$ref": "#/definitions/integer"
                    },
                    "type": "array"
                },
                "minDecimalPlaces": {
                    "type": "number"
                },
                "resultCustomizationBy": {
                    "$ref": "#/definitions/ResultCustomizationBy",
                    "default": "value",
                    "description": "Wether result datasets are associated by their values or by their order."
                },
                "resultCustomizations": {
                    "anyOf": [
                        {
                            "additionalProperties": {
                                "$ref": "#/definitions/ResultCustomizationByValue"
                            },
                            "type": "object"
                        },
                        {
                            "additionalProperties": {
                                "$ref": "#/definitions/ResultCustomizationByPosition"
                            },
                            "propertyNames": {
                                "type": "string"
                            },
                            "type": "object"
                        }
                    ],
                    "description": "Customizations for the appearance of result datasets."
                },
                "showAlertThresholdLines": {
                    "default": false,
                    "type": "boolean"
                },
                "showLabelsOnSeries": {
                    "type": "boolean"
                },
                "showLegend": {
                    "default": false,
                    "type": "boolean"
                },
                "showMultipleYAxes": {
                    "default": false,
                    "type": "boolean"
                },
                "showPercentStackView": {
                    "default": false,
                    "type": "boolean"
                },
                "showValuesOnSeries": {
                    "default": false,
                    "type": "boolean"
                },
                "smoothingIntervals": {
                    "$ref": "#/definitions/integer",
                    "default": 1
                },
                "yAxisScaleType": {
                    "enum": ["log10", "linear"],
                    "type": "string"
                }
            },
            "type": "object"
        },
        "TrendsFilterLegacy": {
            "additionalProperties": false,
            "description": "`TrendsFilterType` minus everything inherited from `FilterType` and `shown_as`",
            "properties": {
                "aggregation_axis_format": {
                    "$ref": "#/definitions/AggregationAxisFormat"
                },
                "aggregation_axis_postfix": {
                    "type": "string"
                },
                "aggregation_axis_prefix": {
                    "type": "string"
                },
                "breakdown_histogram_bin_count": {
                    "type": "number"
                },
                "compare": {
                    "type": "boolean"
                },
                "compare_to": {
                    "type": "string"
                },
                "decimal_places": {
                    "type": "number"
                },
                "display": {
                    "$ref": "#/definitions/ChartDisplayType"
                },
                "formula": {
                    "type": "string"
                },
                "hidden_legend_keys": {
                    "additionalProperties": {
                        "anyOf": [
                            {
                                "type": "boolean"
                            },
                            {
                                "not": {}
                            }
                        ]
                    },
                    "type": "object"
                },
                "min_decimal_places": {
                    "type": "number"
                },
                "show_alert_threshold_lines": {
                    "type": "boolean"
                },
                "show_labels_on_series": {
                    "type": "boolean"
                },
                "show_legend": {
                    "type": "boolean"
                },
                "show_multiple_y_axes": {
                    "type": "boolean"
                },
                "show_percent_stack_view": {
                    "type": "boolean"
                },
                "show_values_on_series": {
                    "type": "boolean"
                },
                "smoothing_intervals": {
                    "type": "number"
                },
                "y_axis_scale_type": {
                    "enum": ["log10", "linear"],
                    "type": "string"
                }
            },
            "type": "object"
        },
        "TrendsFormulaNode": {
            "additionalProperties": false,
            "properties": {
                "custom_name": {
                    "description": "Optional user-defined name for the formula",
                    "type": "string"
                },
                "formula": {
                    "type": "string"
                }
            },
            "required": ["formula"],
            "type": "object"
        },
        "TrendsQuery": {
            "additionalProperties": false,
            "properties": {
                "aggregation_group_type_index": {
                    "anyOf": [
                        {
                            "$ref": "#/definitions/integer"
                        },
                        {
                            "type": "null"
                        }
                    ],
                    "description": "Groups aggregation"
                },
                "breakdownFilter": {
                    "$ref": "#/definitions/BreakdownFilter",
                    "description": "Breakdown of the events and actions"
                },
                "compareFilter": {
                    "$ref": "#/definitions/CompareFilter",
                    "description": "Compare to date range"
                },
                "conversionGoal": {
                    "anyOf": [
                        {
                            "$ref": "#/definitions/WebAnalyticsConversionGoal"
                        },
                        {
                            "type": "null"
                        }
                    ],
                    "description": "Whether we should be comparing against a specific conversion goal"
                },
                "dataColorTheme": {
                    "description": "Colors used in the insight's visualization",
                    "type": ["number", "null"]
                },
                "dateRange": {
                    "$ref": "#/definitions/DateRange",
                    "description": "Date range for the query"
                },
                "filterTestAccounts": {
                    "default": false,
                    "description": "Exclude internal and test users by applying the respective filters",
                    "type": "boolean"
                },
                "interval": {
                    "$ref": "#/definitions/IntervalType",
                    "default": "day",
                    "description": "Granularity of the response. Can be one of `hour`, `day`, `week` or `month`"
                },
                "kind": {
                    "const": "TrendsQuery",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "properties": {
                    "anyOf": [
                        {
                            "items": {
                                "$ref": "#/definitions/AnyPropertyFilter"
                            },
                            "type": "array"
                        },
                        {
                            "$ref": "#/definitions/PropertyGroupFilter"
                        }
                    ],
                    "default": [],
                    "description": "Property filters for all series"
                },
                "response": {
                    "$ref": "#/definitions/TrendsQueryResponse"
                },
                "samplingFactor": {
                    "description": "Sampling rate",
                    "type": ["number", "null"]
                },
                "series": {
                    "description": "Events and actions to include",
                    "items": {
                        "$ref": "#/definitions/AnyEntityNode"
                    },
                    "type": "array"
                },
                "trendsFilter": {
                    "$ref": "#/definitions/TrendsFilter",
                    "description": "Properties specific to the trends insight"
                }
            },
            "required": ["kind", "series"],
            "type": "object"
        },
        "TrendsQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hasMore": {
                    "description": "Wether more breakdown values are available.",
                    "type": "boolean"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "items": {
                        "type": "object"
                    },
                    "type": "array"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                }
            },
            "required": ["results"],
            "type": "object"
        },
        "VectorSearchQuery": {
            "additionalProperties": false,
            "properties": {
                "embedding": {
                    "items": {
                        "type": "number"
                    },
                    "type": "array"
                },
                "kind": {
                    "const": "VectorSearchQuery",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "response": {
                    "$ref": "#/definitions/VectorSearchQueryResponse"
                }
            },
            "required": ["embedding", "kind"],
            "type": "object"
        },
        "VectorSearchQueryResponse": {
            "additionalProperties": false,
            "description": "All analytics query responses must inherit from this.",
            "properties": {
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "$ref": "#/definitions/VectorSearchResponse"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                }
            },
            "required": ["results"],
            "type": "object"
        },
        "VectorSearchResponse": {
            "items": {
                "$ref": "#/definitions/VectorSearchResponseItem"
            },
            "type": "array"
        },
        "VectorSearchResponseItem": {
            "additionalProperties": false,
            "properties": {
                "distance": {
                    "type": "number"
                },
                "id": {
                    "type": "string"
                }
            },
            "required": ["id", "distance"],
            "type": "object"
        },
        "VisualizationMessage": {
            "additionalProperties": false,
            "properties": {
                "answer": {
                    "anyOf": [
                        {
                            "$ref": "#/definitions/AssistantTrendsQuery"
                        },
                        {
                            "$ref": "#/definitions/AssistantFunnelsQuery"
                        },
                        {
                            "$ref": "#/definitions/AssistantRetentionQuery"
                        },
                        {
                            "$ref": "#/definitions/AssistantHogQLQuery"
                        }
                    ]
                },
                "id": {
                    "type": "string"
                },
                "initiator": {
                    "type": "string"
                },
                "plan": {
                    "type": "string"
                },
                "query": {
                    "default": "",
                    "type": "string"
                },
                "type": {
                    "const": "ai/viz",
                    "type": "string"
                }
            },
            "required": ["type", "query", "answer"],
            "type": "object"
        },
        "VizSpecificOptions": {
            "additionalProperties": false,
            "description": "Chart specific rendering options. Use ChartRenderingMetadata for non-serializable values, e.g. onClick handlers",
            "properties": {
                "ActionsPie": {
                    "additionalProperties": false,
                    "properties": {
                        "disableHoverOffset": {
                            "type": "boolean"
                        },
                        "hideAggregation": {
                            "type": "boolean"
                        }
                    },
                    "type": "object"
                },
                "RETENTION": {
                    "additionalProperties": false,
                    "properties": {
                        "hideLineGraph": {
                            "type": "boolean"
                        },
                        "hideSizeColumn": {
                            "type": "boolean"
                        },
                        "useSmallLayout": {
                            "type": "boolean"
                        }
                    },
                    "type": "object"
                }
            },
            "type": "object"
        },
        "WebAnalyticsConversionGoal": {
            "anyOf": [
                {
                    "$ref": "#/definitions/ActionConversionGoal"
                },
                {
                    "$ref": "#/definitions/CustomEventConversionGoal"
                }
            ]
        },
        "WebAnalyticsOrderBy": {
            "items": [
                {
                    "$ref": "#/definitions/WebAnalyticsOrderByFields"
                },
                {
                    "$ref": "#/definitions/WebAnalyticsOrderByDirection"
                }
            ],
            "maxItems": 2,
            "minItems": 2,
            "type": "array"
        },
        "WebAnalyticsOrderByDirection": {
            "enum": ["ASC", "DESC"],
            "type": "string"
        },
        "WebAnalyticsOrderByFields": {
            "enum": [
                "Visitors",
                "Views",
                "Clicks",
                "BounceRate",
                "AverageScrollPercentage",
                "ScrollGt80Percentage",
                "TotalConversions",
                "UniqueConversions",
                "ConversionRate",
                "ConvertingUsers",
                "RageClicks",
                "DeadClicks",
                "Errors"
            ],
            "type": "string"
        },
        "WebAnalyticsPropertyFilter": {
            "anyOf": [
                {
                    "$ref": "#/definitions/EventPropertyFilter"
                },
                {
                    "$ref": "#/definitions/PersonPropertyFilter"
                },
                {
                    "$ref": "#/definitions/SessionPropertyFilter"
                }
            ]
        },
        "WebAnalyticsPropertyFilters": {
            "items": {
                "$ref": "#/definitions/WebAnalyticsPropertyFilter"
            },
            "type": "array"
        },
        "WebExternalClicksTableQuery": {
            "additionalProperties": false,
            "properties": {
                "compareFilter": {
                    "$ref": "#/definitions/CompareFilter"
                },
                "conversionGoal": {
                    "anyOf": [
                        {
                            "$ref": "#/definitions/WebAnalyticsConversionGoal"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "dateRange": {
                    "$ref": "#/definitions/DateRange"
                },
                "doPathCleaning": {
                    "type": "boolean"
                },
                "filterTestAccounts": {
                    "type": "boolean"
                },
                "includeRevenue": {
                    "type": "boolean"
                },
                "kind": {
                    "const": "WebExternalClicksTableQuery",
                    "type": "string"
                },
                "limit": {
                    "$ref": "#/definitions/integer"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "orderBy": {
                    "$ref": "#/definitions/WebAnalyticsOrderBy"
                },
                "properties": {
                    "$ref": "#/definitions/WebAnalyticsPropertyFilters"
                },
                "response": {
                    "$ref": "#/definitions/WebExternalClicksTableQueryResponse"
                },
                "sampling": {
                    "additionalProperties": false,
                    "properties": {
                        "enabled": {
                            "type": "boolean"
                        },
                        "forceSamplingRate": {
                            "$ref": "#/definitions/SamplingRate"
                        }
                    },
                    "type": "object"
                },
                "stripQueryParams": {
                    "type": "boolean"
                },
                "useSessionsTable": {
                    "deprecated": "ignored, always treated as enabled *",
                    "type": "boolean"
                }
            },
            "required": ["kind", "properties"],
            "type": "object"
        },
        "WebExternalClicksTableQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "columns": {
                    "items": {},
                    "type": "array"
                },
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hasMore": {
                    "type": "boolean"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "limit": {
                    "$ref": "#/definitions/integer"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "offset": {
                    "$ref": "#/definitions/integer"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "items": {},
                    "type": "array"
                },
                "samplingRate": {
                    "$ref": "#/definitions/SamplingRate"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                },
                "types": {
                    "items": {},
                    "type": "array"
                }
            },
            "required": ["results"],
            "type": "object"
        },
        "WebGoalsQuery": {
            "additionalProperties": false,
            "properties": {
                "compareFilter": {
                    "$ref": "#/definitions/CompareFilter"
                },
                "conversionGoal": {
                    "anyOf": [
                        {
                            "$ref": "#/definitions/WebAnalyticsConversionGoal"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "dateRange": {
                    "$ref": "#/definitions/DateRange"
                },
                "doPathCleaning": {
                    "type": "boolean"
                },
                "filterTestAccounts": {
                    "type": "boolean"
                },
                "includeRevenue": {
                    "type": "boolean"
                },
                "kind": {
                    "const": "WebGoalsQuery",
                    "type": "string"
                },
                "limit": {
                    "$ref": "#/definitions/integer"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "orderBy": {
                    "$ref": "#/definitions/WebAnalyticsOrderBy"
                },
                "properties": {
                    "$ref": "#/definitions/WebAnalyticsPropertyFilters"
                },
                "response": {
                    "$ref": "#/definitions/WebGoalsQueryResponse"
                },
                "sampling": {
                    "additionalProperties": false,
                    "properties": {
                        "enabled": {
                            "type": "boolean"
                        },
                        "forceSamplingRate": {
                            "$ref": "#/definitions/SamplingRate"
                        }
                    },
                    "type": "object"
                },
                "useSessionsTable": {
                    "deprecated": "ignored, always treated as enabled *",
                    "type": "boolean"
                }
            },
            "required": ["kind", "properties"],
            "type": "object"
        },
        "WebGoalsQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "columns": {
                    "items": {},
                    "type": "array"
                },
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hasMore": {
                    "type": "boolean"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "limit": {
                    "$ref": "#/definitions/integer"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "offset": {
                    "$ref": "#/definitions/integer"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "items": {},
                    "type": "array"
                },
                "samplingRate": {
                    "$ref": "#/definitions/SamplingRate"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                },
                "types": {
                    "items": {},
                    "type": "array"
                }
            },
            "required": ["results"],
            "type": "object"
        },
        "WebOverviewItem": {
            "additionalProperties": false,
            "properties": {
                "changeFromPreviousPct": {
                    "type": "number"
                },
                "isIncreaseBad": {
                    "type": "boolean"
                },
                "key": {
                    "type": "string"
                },
                "kind": {
                    "$ref": "#/definitions/WebOverviewItemKind"
                },
                "previous": {
                    "type": "number"
                },
                "value": {
                    "type": "number"
                }
            },
            "required": ["key", "kind"],
            "type": "object"
        },
        "WebOverviewItemKind": {
            "enum": ["unit", "duration_s", "percentage", "currency"],
            "type": "string"
        },
        "WebOverviewQuery": {
            "additionalProperties": false,
            "properties": {
                "compareFilter": {
                    "$ref": "#/definitions/CompareFilter"
                },
                "conversionGoal": {
                    "anyOf": [
                        {
                            "$ref": "#/definitions/WebAnalyticsConversionGoal"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "dateRange": {
                    "$ref": "#/definitions/DateRange"
                },
                "doPathCleaning": {
                    "type": "boolean"
                },
                "filterTestAccounts": {
                    "type": "boolean"
                },
                "includeRevenue": {
                    "type": "boolean"
                },
                "kind": {
                    "const": "WebOverviewQuery",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "orderBy": {
                    "$ref": "#/definitions/WebAnalyticsOrderBy"
                },
                "properties": {
                    "$ref": "#/definitions/WebAnalyticsPropertyFilters"
                },
                "response": {
                    "$ref": "#/definitions/WebOverviewQueryResponse"
                },
                "sampling": {
                    "additionalProperties": false,
                    "properties": {
                        "enabled": {
                            "type": "boolean"
                        },
                        "forceSamplingRate": {
                            "$ref": "#/definitions/SamplingRate"
                        }
                    },
                    "type": "object"
                },
                "useSessionsTable": {
                    "deprecated": "ignored, always treated as enabled *",
                    "type": "boolean"
                }
            },
            "required": ["kind", "properties"],
            "type": "object"
        },
        "WebOverviewQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "dateFrom": {
                    "type": "string"
                },
                "dateTo": {
                    "type": "string"
                },
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "items": {
                        "$ref": "#/definitions/WebOverviewItem"
                    },
                    "type": "array"
                },
                "samplingRate": {
                    "$ref": "#/definitions/SamplingRate"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                }
            },
            "required": ["results"],
            "type": "object"
        },
        "WebPageURLSearchQuery": {
            "additionalProperties": false,
            "properties": {
                "compareFilter": {
                    "$ref": "#/definitions/CompareFilter"
                },
                "conversionGoal": {
                    "anyOf": [
                        {
                            "$ref": "#/definitions/WebAnalyticsConversionGoal"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "dateRange": {
                    "$ref": "#/definitions/DateRange"
                },
                "doPathCleaning": {
                    "type": "boolean"
                },
                "filterTestAccounts": {
                    "type": "boolean"
                },
                "includeRevenue": {
                    "type": "boolean"
                },
                "kind": {
                    "const": "WebPageURLSearchQuery",
                    "type": "string"
                },
                "limit": {
                    "$ref": "#/definitions/integer"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "orderBy": {
                    "$ref": "#/definitions/WebAnalyticsOrderBy"
                },
                "properties": {
                    "$ref": "#/definitions/WebAnalyticsPropertyFilters"
                },
                "response": {
                    "$ref": "#/definitions/WebPageURLSearchQueryResponse"
                },
                "sampling": {
                    "additionalProperties": false,
                    "properties": {
                        "enabled": {
                            "type": "boolean"
                        },
                        "forceSamplingRate": {
                            "$ref": "#/definitions/SamplingRate"
                        }
                    },
                    "type": "object"
                },
                "searchTerm": {
                    "type": "string"
                },
                "stripQueryParams": {
                    "type": "boolean"
                },
                "useSessionsTable": {
                    "deprecated": "ignored, always treated as enabled *",
                    "type": "boolean"
                }
            },
            "required": ["kind", "properties"],
            "type": "object"
        },
        "WebPageURLSearchQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hasMore": {
                    "type": "boolean"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "limit": {
                    "$ref": "#/definitions/integer"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "items": {
                        "$ref": "#/definitions/PageURL"
                    },
                    "type": "array"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                }
            },
            "required": ["results"],
            "type": "object"
        },
        "WebStatsBreakdown": {
            "enum": [
                "Page",
                "InitialPage",
                "ExitPage",
                "ExitClick",
                "ScreenName",
                "InitialChannelType",
                "InitialReferringDomain",
                "InitialUTMSource",
                "InitialUTMCampaign",
                "InitialUTMMedium",
                "InitialUTMTerm",
                "InitialUTMContent",
                "InitialUTMSourceMediumCampaign",
                "Browser",
                "OS",
                "Viewport",
                "DeviceType",
                "Country",
                "Region",
                "City",
                "Timezone",
                "Language",
                "FrustrationMetrics"
            ],
            "type": "string"
        },
        "WebStatsTableQuery": {
            "additionalProperties": false,
            "properties": {
                "breakdownBy": {
                    "$ref": "#/definitions/WebStatsBreakdown"
                },
                "compareFilter": {
                    "$ref": "#/definitions/CompareFilter"
                },
                "conversionGoal": {
                    "anyOf": [
                        {
                            "$ref": "#/definitions/WebAnalyticsConversionGoal"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "dateRange": {
                    "$ref": "#/definitions/DateRange"
                },
                "doPathCleaning": {
                    "type": "boolean"
                },
                "filterTestAccounts": {
                    "type": "boolean"
                },
                "includeBounceRate": {
                    "type": "boolean"
                },
                "includeRevenue": {
                    "type": "boolean"
                },
                "includeScrollDepth": {
                    "type": "boolean"
                },
                "kind": {
                    "const": "WebStatsTableQuery",
                    "type": "string"
                },
                "limit": {
                    "$ref": "#/definitions/integer"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "orderBy": {
                    "$ref": "#/definitions/WebAnalyticsOrderBy"
                },
                "properties": {
                    "$ref": "#/definitions/WebAnalyticsPropertyFilters"
                },
                "response": {
                    "$ref": "#/definitions/WebStatsTableQueryResponse"
                },
                "sampling": {
                    "additionalProperties": false,
                    "properties": {
                        "enabled": {
                            "type": "boolean"
                        },
                        "forceSamplingRate": {
                            "$ref": "#/definitions/SamplingRate"
                        }
                    },
                    "type": "object"
                },
                "useSessionsTable": {
                    "deprecated": "ignored, always treated as enabled *",
                    "type": "boolean"
                }
            },
            "required": ["breakdownBy", "kind", "properties"],
            "type": "object"
        },
        "WebStatsTableQueryResponse": {
            "additionalProperties": false,
            "properties": {
                "columns": {
                    "items": {},
                    "type": "array"
                },
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hasMore": {
                    "type": "boolean"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "limit": {
                    "$ref": "#/definitions/integer"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "offset": {
                    "$ref": "#/definitions/integer"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "items": {},
                    "type": "array"
                },
                "samplingRate": {
                    "$ref": "#/definitions/SamplingRate"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                },
                "types": {
                    "items": {},
                    "type": "array"
                }
            },
            "required": ["results"],
            "type": "object"
        },
        "WebVitalsItem": {
            "additionalProperties": false,
            "properties": {
                "action": {
                    "$ref": "#/definitions/WebVitalsItemAction"
                },
                "data": {
                    "items": {
                        "type": "number"
                    },
                    "type": "array"
                },
                "days": {
                    "items": {
                        "type": "string"
                    },
                    "type": "array"
                }
            },
            "required": ["data", "days", "action"],
            "type": "object"
        },
        "WebVitalsItemAction": {
            "additionalProperties": false,
            "properties": {
                "custom_name": {
                    "$ref": "#/definitions/WebVitalsMetric"
                },
                "math": {
                    "$ref": "#/definitions/WebVitalsPercentile"
                }
            },
            "required": ["custom_name", "math"],
            "type": "object"
        },
        "WebVitalsMetric": {
            "enum": ["INP", "LCP", "CLS", "FCP"],
            "type": "string"
        },
        "WebVitalsMetricBand": {
            "enum": ["good", "needs_improvements", "poor"],
            "type": "string"
        },
        "WebVitalsPathBreakdownQuery": {
            "additionalProperties": false,
            "properties": {
                "compareFilter": {
                    "$ref": "#/definitions/CompareFilter"
                },
                "conversionGoal": {
                    "anyOf": [
                        {
                            "$ref": "#/definitions/WebAnalyticsConversionGoal"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "dateRange": {
                    "$ref": "#/definitions/DateRange"
                },
                "doPathCleaning": {
                    "type": "boolean"
                },
                "filterTestAccounts": {
                    "type": "boolean"
                },
                "includeRevenue": {
                    "type": "boolean"
                },
                "kind": {
                    "const": "WebVitalsPathBreakdownQuery",
                    "type": "string"
                },
                "metric": {
                    "$ref": "#/definitions/WebVitalsMetric"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "orderBy": {
                    "$ref": "#/definitions/WebAnalyticsOrderBy"
                },
                "percentile": {
                    "$ref": "#/definitions/WebVitalsPercentile"
                },
                "properties": {
                    "$ref": "#/definitions/WebAnalyticsPropertyFilters"
                },
                "response": {
                    "$ref": "#/definitions/WebVitalsPathBreakdownQueryResponse"
                },
                "sampling": {
                    "additionalProperties": false,
                    "properties": {
                        "enabled": {
                            "type": "boolean"
                        },
                        "forceSamplingRate": {
                            "$ref": "#/definitions/SamplingRate"
                        }
                    },
                    "type": "object"
                },
                "thresholds": {
                    "items": {
                        "type": "number"
                    },
                    "maxItems": 2,
                    "minItems": 2,
                    "type": "array"
                },
                "useSessionsTable": {
                    "deprecated": "ignored, always treated as enabled *",
                    "type": "boolean"
                }
            },
            "required": ["kind", "metric", "percentile", "properties", "thresholds"],
            "type": "object"
        },
        "WebVitalsPathBreakdownQueryResponse": {
            "additionalProperties": false,
            "description": "All analytics query responses must inherit from this.",
            "properties": {
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "items": {
                        "$ref": "#/definitions/WebVitalsPathBreakdownResult"
                    },
                    "maxItems": 1,
                    "minItems": 1,
                    "type": "array"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                }
            },
            "required": ["results"],
            "type": "object"
        },
        "WebVitalsPathBreakdownResult": {
            "additionalProperties": false,
            "properties": {
                "good": {
                    "items": {
                        "$ref": "#/definitions/WebVitalsPathBreakdownResultItem"
                    },
                    "type": "array"
                },
                "needs_improvements": {
                    "items": {
                        "$ref": "#/definitions/WebVitalsPathBreakdownResultItem"
                    },
                    "type": "array"
                },
                "poor": {
                    "items": {
                        "$ref": "#/definitions/WebVitalsPathBreakdownResultItem"
                    },
                    "type": "array"
                }
            },
            "required": ["good", "needs_improvements", "poor"],
            "type": "object"
        },
        "WebVitalsPathBreakdownResultItem": {
            "additionalProperties": false,
            "properties": {
                "path": {
                    "type": "string"
                },
                "value": {
                    "type": "number"
                }
            },
            "required": ["path", "value"],
            "type": "object"
        },
        "WebVitalsPercentile": {
            "enum": ["p75", "p90", "p99"],
            "type": "string"
        },
        "WebVitalsQuery": {
            "additionalProperties": false,
            "properties": {
                "compareFilter": {
                    "$ref": "#/definitions/CompareFilter"
                },
                "conversionGoal": {
                    "anyOf": [
                        {
                            "$ref": "#/definitions/WebAnalyticsConversionGoal"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "dateRange": {
                    "$ref": "#/definitions/DateRange"
                },
                "doPathCleaning": {
                    "type": "boolean"
                },
                "filterTestAccounts": {
                    "type": "boolean"
                },
                "includeRevenue": {
                    "type": "boolean"
                },
                "kind": {
                    "const": "WebVitalsQuery",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "orderBy": {
                    "$ref": "#/definitions/WebAnalyticsOrderBy"
                },
                "properties": {
                    "$ref": "#/definitions/WebAnalyticsPropertyFilters"
                },
                "response": {
                    "$ref": "#/definitions/WebGoalsQueryResponse"
                },
                "sampling": {
                    "additionalProperties": false,
                    "properties": {
                        "enabled": {
                            "type": "boolean"
                        },
                        "forceSamplingRate": {
                            "$ref": "#/definitions/SamplingRate"
                        }
                    },
                    "type": "object"
                },
                "source": {
                    "$ref": "#/definitions/InsightQueryNode"
                },
                "useSessionsTable": {
                    "deprecated": "ignored, always treated as enabled *",
                    "type": "boolean"
                }
            },
            "required": ["kind", "properties", "source"],
            "type": "object"
        },
        "WebVitalsQueryResponse": {
            "additionalProperties": false,
            "description": "All analytics query responses must inherit from this.",
            "properties": {
                "error": {
                    "description": "Query error. Returned only if 'explain' or `modifiers.debug` is true. Throws an error otherwise.",
                    "type": "string"
                },
                "hogql": {
                    "description": "Generated HogQL query.",
                    "type": "string"
                },
                "modifiers": {
                    "$ref": "#/definitions/HogQLQueryModifiers",
                    "description": "Modifiers used when performing the query"
                },
                "query_status": {
                    "$ref": "#/definitions/QueryStatus",
                    "description": "Query status indicates whether next to the provided data, a query is still running."
                },
                "results": {
                    "items": {
                        "$ref": "#/definitions/WebVitalsItem"
                    },
                    "type": "array"
                },
                "timings": {
                    "description": "Measured timings for different parts of the query generation process",
                    "items": {
                        "$ref": "#/definitions/QueryTiming"
                    },
                    "type": "array"
                }
            },
            "required": ["results"],
            "type": "object"
        },
        "YAxisSettings": {
            "additionalProperties": false,
            "properties": {
                "scale": {
                    "enum": ["linear", "logarithmic"],
                    "type": "string"
                },
                "startAtZero": {
                    "description": "Whether the Y axis should start at zero",
                    "type": "boolean"
                }
            },
            "type": "object"
        },
        "integer": {
            "type": "integer"
        },
        "isExperimentFunnelMetric": {
            "$comment": "(metric: ExperimentMetric) => metric is ExperimentFunnelMetric",
            "properties": {
                "namedArgs": {
                    "additionalProperties": false,
                    "properties": {
                        "metric": {
                            "$ref": "#/definitions/ExperimentMetric"
                        }
                    },
                    "required": ["metric"],
                    "type": "object"
                }
            },
            "type": "object"
        },
        "isExperimentMeanMetric": {
            "$comment": "(metric: ExperimentMetric) => metric is ExperimentMeanMetric",
            "properties": {
                "namedArgs": {
                    "additionalProperties": false,
                    "properties": {
                        "metric": {
                            "$ref": "#/definitions/ExperimentMetric"
                        }
                    },
                    "required": ["metric"],
                    "type": "object"
                }
            },
            "type": "object"
        }
    }
}
